import React, { Component} from 'react';
import ReactDOM from "react-dom";
import { connect } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { withClassNavigate } from './hocs/withClassNavigate';
import { withRouter } from './hocs/withRouter';
import { waitForElement } from './utils/dom';
import Spinner from './components/spinner/spinner';
import MainBar from './components/main-bar/main-bar';
import SideBar from './calendar/components/sidebar/side-bar';
import { setFormValues } from './actions/login';
import {
  clearUserCredentials, 
  setNextcloudUser, 
  setService, 
  setError,
  setIsFilterDate,
  setEventFilterKeyword,
  setIsSearchTopBar
} from './actions/application';
import {
 setGUID,
 setSign,
 setDataBase,
 resetIdActuation,
 resetIdEvent,
 setIsFirstLoad
} from './actions/lexon';
import './app.scss';
import { CheckBoxComponent } from '@syncfusion/ej2-react-buttons';
import { EVENT_TYPE_COLOR_MODES } from './constants/eventTypeColorModes';
import {
    ScheduleComponent, ViewsDirective, ViewDirective,
    Day, Week, WorkWeek, Month, Agenda, Inject, Resize, DragAndDrop, 
    ResourcesDirective, ResourceDirective, RecurrenceEditor
} from '@syncfusion/ej2-react-schedule';

import { DataManager, Query, Predicate } from '@syncfusion/ej2-data';
import { ToastComponent } from '@syncfusion/ej2-react-notifications';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { DropDownList } from '@syncfusion/ej2-dropdowns';
import { setCulture, L10n, Internationalization, debounce } from '@syncfusion/ej2-base';
import moment from 'moment';
import groupBy from "lodash/groupBy";
import orderBy from "lodash/orderBy";
import { createElement } from '@syncfusion/ej2-base';
import { TabComponent } from '@syncfusion/ej2-react-navigations';
import {
    addCalendarEvent,
    getEventList,
    deleteCalendar,
    calendarList,
    deleteCalendarEvent,
    updateCalendarList,
    createCalendarUser,
    getEventById,
    getEventDataById,
    getEventByDate,
    createCalendar,
    createContact,
    createPersonalCalendarUser,
    invitedUsers
} from './calendar/api/calendar-api';
import { TextBoxComponent } from "@syncfusion/ej2-react-inputs";
import { Confirmation } from './components/notification/confirmation'
import Reminder from "./calendar/components/main/reminder/reminder";
import { Popup } from '@syncfusion/ej2-popups';
import { Eventtype } from './calendar/components/eventtypes/eventtype';
import { FilterEventtype } from './calendar/components/eventtypes/filterEventType';
import { parseJwt, getUserId } from './services/jwt';
import ConfigurationHours from './calendar/components/ConfigurationHours/ConfigurationHours';
import { SCHEDULE_FIELDS, getToast, ITEM_EVENT_TEMPLATE, STATUS_CANCELLED } from "./constants";
import { getEventTypes, resetDefaultAccount, addorUpdateEventType, getDefaultAccount } from './services/accounts';
import { sendNotificationAttendees } from './services/smtp';
import { removeState } from './services/state';
import { Calendars } from './calendar/components/calendars/calendars';
import AttendeeAddress from './calendar/components/main/attendee/attendee-address';
import './lefebvre-material.css';
import {
    getCalendars,
    selectCalendar,
    checkCalendar,
    setConfigHoursCalendar,
    clearErrorCalendars
} from "./calendar/components/sidebar/sidebar.actions";
import {bindActionCreators} from "redux";
import { Navigate } from "react-router-dom";
import i18n from 'i18next';
import { Tooltip, Button, Popover, PopoverBody } from "reactstrap";
import LexonComponentCalendar from "./apps/lexon_content_calendar";
import {
    addEventToActuation,
    createAppoinment,
    updateAppoinment,
    removeAppoinment,
    removeAppoinmentByAppoitmentId
} from "./calendar/api/lexon";
import ContactsImport from "./components/contacts-import/contacts";
import EventsImportV2 from "./calendar/components/events-import/events-v2";
import { isImportEventsLexonV2Enabled } from "./utils/featureFlags";
import Cookies from 'js-cookie';
import * as base64 from 'base-64';
import EventsSearch from './calendar/components/EventsSearch/EventsSearch';
import { getContactString } from './calendar/api/contacts-api';
import { dateTimeDiff, getDateTimeInHHMM } from "./utils/utils";
import { ensureCldrEsLoaded } from "./utils/cldr";
import { applyEventColors, setEventSelected } from "./utils/colorScale";
import Dot from "./components/dot/dot";
import Footer from './components/footer/footer';
import CalendarIcon from './assets/calendar/calendar.svg?react';
import EditIcon from './assets/calendar/edit-white.svg?react';
import DeleteWhiteIcon from './assets/calendar/delete-white.svg?react';
import ArchiveIcon from './assets/icons/archive.svg?react';
import LogoIcon from './assets/icons/logo-sm.svg?react';

const INTERVAL_IN_MINUTES = 30
const SESSION_USER_KEY = 'LEXON_SESSION_USER_ID';

class Calendar extends Component {
  constructor(props) {
    const IMAPCalendarsUserOptions = Cookies.get(`Lefebvre.IMAPCalendarsUserOptions`)
    let view ='Month'
    let selectedDate = new Date()
    if (IMAPCalendarsUserOptions && IMAPCalendarsUserOptions.split('|')[0] === props.lexon.account){
        const cookieView = IMAPCalendarsUserOptions.split('|')[1]
        const cookieDate = IMAPCalendarsUserOptions.split('|')[2]
        // Validate view is not "undefined" string and is a valid view type
        if (cookieView && cookieView !== 'undefined') {
            view = cookieView
        }
        // Validate date is not "undefined" string and creates a valid Date
        if (cookieDate && cookieDate !== 'undefined') {
            const parsedDate = new Date(cookieDate)
            if (!isNaN(parsedDate.getTime())) {
                selectedDate = parsedDate
            }
        }
    }
    super(props);
    this.resourcesDirective = React.createRef();
    this.showResourcesDirective = React.createRef();
    this.localEvents = [];
    this.loading = false;
    this.isFirstLoad = true;
    this.dateNavigate = false;
    this.isOpeningEditor = false;
    this.isLexonTabAutoSave = false;
    this.attendeePortalRoot = null;
    // Track the last selected calendar ID (updated synchronously, not via setState)
    this.lastSelectedCalendarId = null;
    // Calendar ID to set in dropdown when modal opens
    this.pendingCalendarIdForDropdown = null;

    this.state = {
        globalizationReady: false,
        redirectToLogin: this.props.lexon.user ? false : true,
        sidebarOpen: false,
        sidebarDocked: false,
        leftSideBar: {
            collapsed: (window !== window.top) ? true : false
        },
        hidePromptDialog: false,
        hidePromptEventTypeDialog: false,
        hidePromptFilterEventTypeDialog: false,
        hideConfigurationHoursDialog: false,
        showPromptImportContactsDialog: false,
        showPromptImportEventsV2Dialog: false,
        calendarToEdit: undefined,
        reminders: [],
        eventType: undefined,
        isVisibility: false,
        calendars: [],
        schedule: null,
        to2: [],
        to: '',
        creatingEvent: false,
        lexonEvent: false,
        calendarResult: [],
        idActuation: '',
        idEvent: '',
        isUpdatedDefaultAccount: false,
        isEdit: false,
        windowSize: window.innerWidth,
        showCalendarToolTipOpen: false,
        configToolTipOpen: false,
        logoutToolTipOpen: false,
        loading: false,
        loadedToolbar: false,
        loadedEvent: false,
        isDataBound: false,
        loadCalendar: false,
        loadingCalendars: [],
        importingEvents: false,
        appConnectData: null,
        originalEventCalendarId: "", // TO DO: Move event from calendar
        isPopUpOpen: false,
        currentView: view,
        selectedDateUpdated: false,
        selectedDate: selectedDate,
        popUpRecurrenceMessages: [],
        isResized: false,
        tabChanged: false,
        filterEventType: [],
        tableEvents: [],
        quickInfoEventData: {},
        showDeleteConfirmation: false,
        showRecurrenceConfirmation: false,
        isIframeOptionsOpen: false,
        toolbarRenderKey: 0,
        validationAlert: null,
        showDateValidationAlert: false,
        showNotClassifiedEvent: false,
        showAlertUser: false,
        eventTypeColorMode: EVENT_TYPE_COLOR_MODES.DOT,
        // Connection error modal state
        showConnectionErrorModal: false,
        connectionErrorMessage: '',
        connectionRetryCallback: null,
        conflictWarning: null,
        hasTimeConflict: false,
        openNewEventOnFullCalendar: false,
        isInvalidEmail: false,
        showSharedCalendarSyncInfo: false,
      };

      if (!this.props.lexon.user) {
          this.props.logout();
      }
    
      this.toggleSideBar = this.toggleSideBar.bind(this);
      this.tableMonth = React.createRef('');
      this.viewCalendar = React.createRef('');
      this.tableEvents = React.createRef();
      this.contactString = React.createRef('');
      this.tableEvents.current = [];
      this.dataManager = new DataManager();
      this.defaultCalendar = undefined;
      this.scheduleData = [];
      this.pendingConflictCheck = null; // Store conflict check function for iframe mode
      this.editorElement = null; // Store editor element reference for conflict warnings
      this.position = { X: 'Right', Y: 'Top' };
      this.resourceCalendarData = [];
      this.instance = new Internationalization();
      this.tabInstance = new TabComponent();
      this.layoutIframe = false;
      this.layoutIframHeight = (window.innerHeight - 72);
      this.openNewEventFromIframeStorageKey = "calendar.openNewEventFromIframe";
      this.closingIframe = false;
      this.layoutIframeNewEventView = false;
      this.layoutIframeEditEventView = false;
      this.sidebarCalendarList = this.sidebarCalendarList.bind(this);
      this.openCalendarView = this.openCalendarView.bind(this);
      this.deleteCalendar = this.deleteCalendar.bind(this);
      this.calendarColorModify = this.calendarColorModify.bind(this);
      this.onDataBound = this.onDataBound.bind(this);
      this.tabContent = this.tabContent.bind(this);
      this.eventRendered = this.eventRendered.bind(this);
      this.onEventRendered = this.onEventRendered.bind(this);
      this.buildEventoCalDav = this.buildEventoCalDav.bind(this);
      this.handleAddAddress = this.addAddress.bind(this);
      this.handleRemoveAddress = this.removeAddress.bind(this);
      this.onCloseDialog = this.onCloseDialog.bind(this);
      this.onExportEvents = this.onExportEvents.bind(this);
      this.onExportContacts = this.onExportContacts.bind(this);
      this.loadCalendarEvents = this.loadCalendarEvents.bind(this);
      this.handleClassificatedEvent = this.handleClassificatedEvent.bind(this);
      this.handleClassificatedEventRemoved = this.handleClassificatedEventRemoved.bind(this);
      this.handleCloseImportEvents = this.handleCloseImportEvents.bind(this);
      this.onImportEventsV2Click = this.onImportEventsV2Click.bind(this);
      this.classifyEventOnLexon = this.classifyEventOnLexon.bind(this);
      this.clickCancel = this.clickCancel.bind(this);
      this.handleGetUserFromLexonConnector = this.handleGetUserFromLexonConnector.bind(
          this
        );
        this.handleLogout = this.handleLogout.bind(this);
        this.openCalendar = this.openCalendar.bind(this);

      this.alertButtons = [{
          // Click the footer buttons to hide the Dialog
          click: () => {
              this.setState({ hideAlertDialog: false });
          },
          buttonModel: { content: 'Dismiss', isPrimary: true }
      }];
      // Calednar View Dialog
      this.confirmButton = [{
          click: () => {
              this.setState({ hideConfirmDialog: false });
          },
          buttonModel: { content: 'Yes', isPrimary: true }
      },
      {
          click: () => {
              this.setState({ hideConfirmDialog: false });
          },
          buttonModel: { content: 'No' }
      }];
      // Calednar View Dialog
      this.promptButtons = [{
          click: () => {
              this.setState({ hidePromptDialog: false });
          },
          buttonModel: { content: 'Accept', isPrimary: true }
      },
      {
          click: () => {
              this.setState({ hidePromptDialog: false });
          },
          buttonModel: { content: 'Cancel' }
      }];
      // Calednar View Dialog
      this.animationSettings = { effect: 'None' };

      // Syncfusion omponent translation
      this.setGlobalization();
      this.tabObj = undefined;
      this.drowDownListEventType = undefined;
      this.drowDownListVisibility = undefined;
      this.selectedEvent = undefined;
      this.selectedEventElement = null;
      this.isSharedCalendarPendingClose = false;
      // to change when api would be ready
      this.eventTypeDataSource = [];
      this.items = [
          {
              text: 'Dashboard',
              iconCss: 'e-ddb-icons e-dashboard'
          },
          {
              text: 'Notifications',
              iconCss: 'e-ddb-icons e-notifications'
          },
          {
              text: 'User Settings',
              iconCss: 'e-ddb-icons e-settings'
          },
          {
              text: 'Log Out',
              iconCss: 'e-ddb-icons e-logout'
          }
      ];
      this.remObj = React.createRef();
      this.checkedCalendar = React.createRef();
      this.tagObjHead = React.createRef();
      this.TokensFlows();
    }

    hasProduct(product) {
        if (this.props.currentUser && this.props.currentUser.roles) {
            return this.props.currentUser.roles.indexOf(product) > -1;
        }
        return false;
    }

    toggleSideBar() {
        const toggleCollapsed = !this.state.leftSideBar.collapsed;
        this.setState({
            leftSideBar: {
                collapsed: toggleCollapsed
            }
        }, () => {
            if (this.scheduleObj) {
                setTimeout(() => {
                    this.scheduleObj.refresh();
                }, 300);
            }
        });
    }

    toggleShowCalendarTooltip = () => {
        const {showCalendarToolTipOpen} = this.state;
        this.setState({showCalendarToolTipOpen: !showCalendarToolTipOpen});
    }

    toggleConfigTooltip = () => {
        const {configToolTipOpen} = this.state;
        this.setState({configToolTipOpen: !configToolTipOpen});
    }

    toggleLogoutTooltip = () => {
        const {logoutToolTipOpen} = this.state;
        this.setState({logoutToolTipOpen: !logoutToolTipOpen});
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.isLexonTabAutoSave) {
            return false;
        }

        // Block renders while editor is open or opening to prevent modal from closing
        const editorIsOpenOrOpening = this.state.creatingEvent || nextState.creatingEvent || this.isOpeningEditor;

        // Always allow re-render if loading state changes (to show/hide spinner)
        const loadingStateChanged = this.state.loading !== nextState.loading;
        if (loadingStateChanged) {
          return true;
        }

        // Always allow re-render when confirmation modals state changes
        const confirmationModalChanged = 
          this.state.showDeleteConfirmation !== nextState.showDeleteConfirmation ||
          this.state.showRecurrenceConfirmation !== nextState.showRecurrenceConfirmation ||
          this.state.showDateValidationAlert !== nextState.showDateValidationAlert ||
          this.state.showNotClassifiedEvent !== nextState.showNotClassifiedEvent ||
          this.state.showConnectionErrorModal !== nextState.showConnectionErrorModal;
        if (confirmationModalChanged) {
          return true;
        }

        if (
          (this.state.lexonEvent === true && nextState.lexonEvent === false) ||
          editorIsOpenOrOpening ||
          (nextState.isPopUpOpen || this.state.isPopUpOpen)
        ) {
          return false;
        }
        return true;
    }

    allowResizing(){
        if (this.layoutIframe){
            return false
        }

        if(this.scheduleObj && this.scheduleObj.currentView === 'Month'){
            return true
        }

        return false
    }

    quickInfoHeaderTemplate(props)  {
        return (
         
          props.elementType === 'cell' ?
            <div className="quick-info-header" style={{padding: '16px 16px 0 16px'}} >
              <div className="quick-info-header-content" >
                  <div className="quick-info-title inter-bold-16" style={{height:'46px', borderRadius: '5px',backgroundColor:'#001978', color:'white', padding: '14px 16px'}} >
                    Nuevo evento
                  </div>
                  <div  style={{padding:'20px 5px 0 5px', display:'flex', gap:'10px', alignItems:'center'}}>
                    <CalendarIcon className="lf-icon lf-icon-calendar" style={{fontSize:'22px'}} ></CalendarIcon>
                    <span className="duration-text inter-regular-14">{this.getQuickInfoHeaderDetails(props, true)}</span>
                  </div>
              </div>
            </div>
              :
            <div className="quick-info-header" style={{padding: '16px 16px 0 16px',background: '#4C5EA0'}} >
                <span
                    className='lf-icon lf-icon-close'
                    style={{cursor:'pointer'}}
                    onClick={()=>{
                        this.scheduleObj.closeQuickInfoPopup()
                    }}
                />
              <div className="quick-info-header-content" >
                <div style={{
                        display:'flex',
                        paddingTop: window !== window.top ? '0' : '35px',
                        height: window !== window.top ? '24px' : '75px',
                        justifyContent:'space-between',
                        color:'white'
                    }}>
                  <div className="quick-info-subject quick-info-title inter-bold-18" style={{maxWidth:'75%', overflow:'hidden'}} >
                    {props.Subject}
                  </div>
                  <div className="quick-info-title inter-bold-16" style={{display:'flex', justifyContent: 'space-around', width:'15%', fontSize:'16px'}} >
                    {window === window.top && (
                        <>
                            <EditIcon
                                width='18px'
                                className='lf-icon lf-icon-edit'
                                style={{cursor:'pointer'}}
                                onClick={()=>{
                                    setTimeout(()=>{
                                        if (!props.RecurrenceRule) {
                                            this.scheduleObj.openEditor(
                                                this.state.quickInfoEventData, 
                                                'Save',
                                                true,
                                            )
                                        } else {
                                            this.scheduleObj.closeQuickInfoPopup();
                                            setTimeout(()=>{
                                                this.setState({showRecurrenceConfirmation: true });
                                            }, 100)
                                        }
                                    }, 100)
                                }}
                            />
                            <DeleteWhiteIcon
                                width='18px'
                                className='lf-icon lf-icon-trash'
                                style={{cursor:'pointer'}}
                                onClick={()=>{
                                    this.scheduleObj.closeQuickInfoPopup()
                                    setTimeout(()=>{
                                        this.setState({showDeleteConfirmation:true})
                                    }, 100)
                                }}
                            />
                        </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            
          
        );
    }
    
    getQuickInfoHeaderDetails(data){
        const { IsAllDay } = data;
        const startDate = new Date(data.StartTime)
        const endDate = new Date(data.EndTime);
        if (IsAllDay){
          return this.instance.formatDate(data.StartTime, { type: 'date', skeleton: 'yMMMd' }) + ' (Todo el día)' 
        }
        const startDateString = startDate.toLocaleString()
        const endDateString = endDate.toLocaleString()
        if (startDateString.split(',')[0]===endDateString.split(',')[0]){//Mismo dia diferente hora
          return this.instance.formatDate(data.StartTime, { type: 'date', skeleton: 'yMMMd' }) + `(${startDateString.split(',')[1]} - ${endDateString.split(',')[1]})`
        }
        return this.instance.formatDate(data.StartTime, { type: 'date', skeleton: 'yMMMd' }) + ' - ' + this.instance.formatDate(data.EndTime, { type: 'date', skeleton: 'yMMMd' });
      }

    quickInfoContentTemplate(props){
        return (<div className="quick-info">
                {props.elementType === 'cell' ?
                  <div className="form-group">
                    <div className="e-float-input type-text-input">
                      <label className="label-field-text inter-regular-16">
                        Título
                        <span className="inter-bold-20 text-required ml-1">*</span>
                      </label>
                      <TextBoxComponent
                        id="name"
                        placeholder={i18n.t("general.write_here_placeholder")}
                        className="field-input"
                        input={(e) => {
                            const aux = {...this.state.quickInfoEventData}
                            aux.Subject = e.value
                            let btnQuickInfoSave = document.querySelector(".quickInfoButton-save");
                            if (e.value !== '') {
                              btnQuickInfoSave.disabled = false;
                              btnQuickInfoSave.classList.remove("disabled")
                              btnQuickInfoSave.onclick = () => {
                                this.scheduleObj.eventWindow.eventData = undefined;
                                this.scheduleObj.addEvent(this.state.quickInfoEventData);
                                this.scheduleObj.closeQuickInfoPopup();
                              }
                            } else {
                              btnQuickInfoSave.disabled = true;
                            }
                            this.setState({quickInfoEventData: aux});  
                        }}
                      />
                      <div style={{background:'#D9E1FC', display: 'flex', padding:'10px', marginTop:'20px', borderRadius:'5px', alignItems:'center', gap:'10px'}}>
                        <div>
                          <span className="lf-icon lf-icon-information" style={{color:'var(--tertiary-byzantine-blue-200)', fontSize:'18px'}} ></span>
                        </div>
                        <div style={{paddingLeft:'5px'}}>
                          <span className=" inter-medium-14">
                            Este es un formulario reducido
                          </span>
                          <br/>
                          <span className=" inter-medium-14"  onClick={()=>{
                             setTimeout(()=>{
                                const isAllDay = this.state.quickInfoEventData.isAllDay;
                                if(isAllDay) {
                                    const timeDate = new Date();
                                    const startTime = this.state.quickInfoEventData.startTime;
                                    const endTimeDate = this.state.quickInfoEventData.endTime;
                              
                                    startTime.setHours(timeDate.getHours());
                                    startTime.setMinutes(timeDate.getMinutes());
                              
                                    endTimeDate.setHours(timeDate.getHours());
                                    endTimeDate.setMinutes(timeDate.getMinutes() + INTERVAL_IN_MINUTES);
    
                                    const endTime = isAllDay ? moment(endTimeDate).subtract(1, "days") : endTimeDate;
                              
                                    const cellData = {
                                        ...this.state.quickInfoEventData,
                                        subject: this.props.lexon.title ? this.props.lexon.title : null,
                                        startTime: startTime,
                                        endTime: endTime,
                                        EndTime: endTime
                                    };
                                    this.scheduleObj.openEditor(cellData, 'Add', true);
                                } else {
                                    this.scheduleObj.openEditor(this.state.quickInfoEventData, 'Add', true);
                                }
                            },100)
                          } } style={{cursor:'pointer', color:'#2E53D6'}}>
                            Completar mas información
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                :
                  <div className="event-content">
                    <div className="duration-text inter-medium-16" style={{paddingBottom:'10px'}}>
                      {this.getQuickInfoHeaderDetails(props,false)}
                    </div>
                    <div className="meeting-type-wrap inter-regular-14" style={{paddingBottom:'10px'}}>
                        <span>{ props.Description !== '' && props.Description?.length > 120 ?
                            `${props.Description.substring(0,200)}...` : props.Description}</span>
                    </div>
                    {props.Location &&
                        <div className="meeting-type-wrap inter-regular-14" style={{paddingBottom:'10px', display:'flex', gap:'10px'}}>
                            <span className="lf-icon lf-icon-map-marker" style={{fontSize:'14px'}} />
                            <span>{props?.Location}</span>
                        </div>
                    }
                    <div className="meeting-type-wrap inter-regular-14" style={{paddingBottom:'10px', display:'flex', gap:'10px'}}>
                            <CalendarIcon className="lf-icon lf-icon-calendar" style={{fontSize:'14px'}} />
                        <span>{this.props.calendarsResult.calendars.find((x) => x.id === props.CalendarId)?.summary}</span>
                    </div>
                  </div>}
            </div>);
      };

    quickInfoFooterTemplate (props) {
        return (
          <div className="quick-info">
            {props.elementType == "cell" ?
            <div className="form-group">
              <div className="d-flex justify-content-end btn-action-container ml-20">
                <Button
                  className="btn-outline-primary inter-bold-16 quickInfoButton"
                  title={i18n.t("general.cancel")}
                  color="secondary"
                  onClick={() => this.scheduleObj.closeQuickInfoPopup()} >
                  {i18n.t("general.cancel")}
                </Button>
                <Button
                  disabled
                  id="modify"
                  className="ml-3 inter-bold-16 quickInfoButton quickInfoButton-save"
                  color="primary"
                  title={i18n.t("general.save")}
                >
                  {i18n.t("general.save")}
                </Button>       
              </div>
            </div>
            :
            <div className="event-footer">
                
            </div>}
          </div>);
      };

    renderAttendeePortal() {
        const container = document.getElementById('attendee-portal-container');
        if (!container) {
            return;
        }

        if (!this.attendeePortalRoot) {
            this.attendeePortalRoot = createRoot(container);
        }

        this.attendeePortalRoot.render(
            <AttendeeAddress
                id='to'
                lexon={this.props.lexon}
                userAccount={this.props.all.login.formValues.user}
                userPw={this.props.all.login.formValues.password}
                addresses={this.state.to2}
                onAddressAdd={this.handleAddAddress}
                onAddressRemove={this.handleRemoveAddress}
                onAddressMove={this.handleMoveAddress}
                getAddresses={this.props.getAddresses}
                label={i18n.t('compose-message.to')}
                isInvalidEmail={this.state.isInvalidEmail}
                setInvalidEmail={(isInvalidEmail) => {
                    this.setState({ isInvalidEmail }, () => {
                        this.renderAttendeePortal();
                    });
                } }
                portalContainer={container}
                lexonToken={this.props.lexon.lexonToken}
            />
        );
    }

    unmountAttendeePortal() {
        if (this.attendeePortalRoot) {
            this.attendeePortalRoot.unmount();
            this.attendeePortalRoot = null;
        }
    }

    checkEventConflict(startTime, endTime, excludeEventId = null, isAllDay = false) {
        const newStart = new Date(startTime);
        const newEnd = new Date(endTime);
        const conflicts = this.scheduleData.filter(event => {
            if (excludeEventId && event.Id === excludeEventId) {
                return false;
            }

            if (event.RecurrenceRule) {
                // Manual recurrence check (sin usar generateOccurrences)
                try {
                    const checkDate = moment(newStart).format('YYYY-MM-DD');

                    // Parse recurrence rule
                    const rruleParts = event.RecurrenceRule.split(';').reduce((acc, part) => {
                        const [key, value] = part.split('=');
                        acc[key] = value;
                        return acc;
                    }, {});

                    const freq = rruleParts.FREQ;
                    const byMonthDay = rruleParts.BYMONTHDAY ? parseInt(rruleParts.BYMONTHDAY, 10) : null;
                    const until = rruleParts.UNTIL ? moment(rruleParts.UNTIL, 'YYYYMMDDTHHmmss[Z]') : null;

                    // Check if date matches recurrence
                    const eventStartDate = moment(event.StartTime);
                    const checkMoment = moment(newStart);

                    let matchesRecurrence = false;

                    if (freq === 'MONTHLY' && byMonthDay) {
                        // Mensual por día del mes
                        matchesRecurrence = checkMoment.date() === byMonthDay;
                    } else if (freq === 'MONTHLY') {
                        // Mensual mismo día que el evento original
                        matchesRecurrence = checkMoment.date() === eventStartDate.date();
                    } else if (freq === 'WEEKLY') {
                        // Semanal mismo día de la semana
                        matchesRecurrence = checkMoment.day() === eventStartDate.day();
                    } else if (freq === 'DAILY') {
                        matchesRecurrence = true;
                    }

                    // Check if within UNTIL limit
                    if (until && checkMoment.isAfter(until)) {
                        matchesRecurrence = false;
                    }

                    // Check if event has started
                    if (checkMoment.isBefore(eventStartDate, 'day')) {
                        matchesRecurrence = false;
                    }

                    if (!matchesRecurrence) {
                        return false;
                    }

                    // Calculate occurrence time for this date
                    const occStart = moment(checkDate + ' ' + moment(event.StartTime).format('HH:mm')).toDate();
                    const occEnd = moment(checkDate + ' ' + moment(event.EndTime).format('HH:mm')).toDate();

                    // Check conflict with this occurrence
                    if (isAllDay && event.IsAllDay) {
                        return true; // Both all-day on same date
                    }

                    if (isAllDay && !event.IsAllDay) {
                        return false;
                    }

                    if (!isAllDay && event.IsAllDay) {
                        return false;
                    }

                    if (!isAllDay && !event.IsAllDay) {
                        return (newStart < occEnd && newEnd > occStart);
                    }

                    return false;

                } catch (error) {
                    console.error('Error checking recurrence:', error);
                    return false;
                }
            }

            // Non-recurring logic
            if (isAllDay && event.IsAllDay) {
                const eventDate = moment(event.StartTime).format('YYYY-MM-DD');
                const newDate = moment(newStart).format('YYYY-MM-DD');
                return eventDate === newDate;
            }

            if (isAllDay && !event.IsAllDay) {
                return false;
            }

            if (!isAllDay && event.IsAllDay) {
                return false;
            }

            if (!isAllDay && !event.IsAllDay) {
                const eventStart = new Date(event.StartTime);
                const eventEnd = new Date(event.EndTime);
                return (newStart < eventEnd && newEnd > eventStart);
            }

            return false;
        });

        return conflicts;
    }

    showConflictWarning(formElement) { 
        const existingWarning = formElement.querySelector('.conflict-warning-container');
        if (existingWarning) {
            existingWarning.remove();
        }

        let insertTarget = formElement.querySelector('.e-start-end-row');

        if (insertTarget) {
            const warningContainer = createElement('div', {
                className: 'conflict-warning-container'
            });

            const warningMessage = createElement('div', {
                className: 'conflict-warning-message'
            });

            warningMessage.innerHTML = `
            <div style="display: flex; align-items: center; gap: 8px;">
                <img src="/assets/images/warning.svg" alt="Warning" class="conflict-warning-icon" style="width: 20px;"/>
                <span>${i18n.t("schedule.event-conflict-description")}</span>
            </div>
                <img src="/assets/icons/lexon/close.svg" alt="Close" class="conflict-warning-close" style="cursor: pointer;" />
            `;

            const conflictList = createElement('div', {
                className: 'conflict-list'
            });

            warningContainer.appendChild(warningMessage);
            warningContainer.appendChild(conflictList);

            if (insertTarget.nextSibling) {
                insertTarget.parentNode.insertBefore(warningContainer, insertTarget.nextSibling);
            } else {
                insertTarget.parentNode.appendChild(warningContainer);
            }

            const closeIcon = warningMessage.querySelector('.conflict-warning-close');
            if (closeIcon) {
                closeIcon.addEventListener('click', () => {
                    warningContainer.remove();
                    this.setState({
                        conflictWarning: null,
                        hasTimeConflict: false
                    });
                });
            } else {
                console.warn('  ⚠️ Close icon not found!');
            }
        } else {
            console.warn('❌ [SHOW WARNING] Could not find .e-start-end-row element');
        }
    }

    hideConflictWarning(formElement) {
        const existingWarning = formElement.querySelector('.conflict-warning-container');
        if (existingWarning) {
            existingWarning.remove();
        }
    }
    
    renderCalendarNotFound() {
        return (
            <div className='d-flex h-100 align-items-center justify-content-center h3'>
                {i18n.t("calendar.no_access_calendar")}
            </div>
        );
    }

    render() {
        const { 
            isIframeOptionsOpen,
            showNotClassifiedEvent,
            globalizationReady,
            showSharedCalendarSyncInfo 
        } = this.state;
        const popoverTargetEl = document.querySelector('#iframe-options-toolbar');
        if (!globalizationReady) {
            return <Spinner visible={true} />;
        }
        if (!this.closingIframe){
            const { lexon } = this.props;
            const { 
                leftSideBar, 
                calendarResult,
                hideConfigurationHoursDialog 
            } = this.state
            
            // Use calendarResult if available, otherwise fallback to props
            // Check calendarResult.length because empty array [] is truthy
            const calendarsForResource = calendarResult && calendarResult.length > 0 
                ? calendarResult 
                : this.props.calendarsResult.calendars;

            if (this.props.calendarsResult !== undefined) {
                if (lexon.idCalendar !== null && lexon.idCalendar !== undefined){
                    if (this.props.calendarsResult.calendars.length > 0){
                        if (!this.props.calendarsResult.calendars.find(c => c.id === lexon.idCalendar)){
                            return this.renderCalendarNotFound();
                        }
                    }
                }
            }
            
            if (this.state.redirectToLogin) {
                return <Navigate to={"/login"}/>;
            }

            return (
                <div className={`custom-padding-top-calendar
                    ${!this.layoutIframe && 'custom-padding-top-calendar-iframe'}`}>
                {!this.layoutIframe && (
                    <div >
                        <MainBar
                            sideBarCollapsed={false}
                            sideBarToggle={this.toggleSideBar}
                            hiddeSearch={true}
                            showSearchEvents={true}
                        />
                    </div>
                )}
                <div id='target' className={`app-calendar main hbox`}>
                    <Spinner
                    visible={this.state.loading}
                    className="spinner-calendar"
                    pathClassName={`spinnerPath`}
                    />
                    <SideBar
                        collapsed={leftSideBar.collapsed}
                        sideBarToggle={this.toggleSideBar}
                        casefile={lexon.idCaseFile}
                        bbdd={lexon.bbdd}
                        sideBarCollapsed={false}
                        getCalendarList={this.sidebarCalendarList}
                        pathname={this.props.location.pathname}
                        calendarResult={this.props.calendarsResult}
                        onCalendarClick={(calendarId, checked) => {
                            if (this.lexonAppRoot) {
                              //Remover el contenedor lexon-app-tab si existe
                              const lexonTab = document.getElementById('lexon-app-tab');
                              if (lexonTab && lexonTab.parentNode) {
                                  lexonTab.parentNode.removeChild(lexonTab);
                              }
                            }
                            this.checkedCalendar.current = calendarId;
                            this.loadCalendarEvents(calendarId, checked);
                        }}
                        onSidebarCloseClick={this.handleShowLeftSidebarClick}
                        onCalendarChange={this.handleScheduleDate}
                        onCalendarOpenEditor={this.handleScheduleOpenNewEventEditor}
                        onCalendarOpenCalnendarView={this.openCalendarView}
                        onCalendarDelete={this.deleteCalendar}
                        onCalendarColorModify={this.calendarColorModify}
                        isIframeContainer={this.layoutIframe}
                        newMessage={() => ''}
                        selectedDate={this.state.selectedDate}
                    />
                    <div
                        className={`content-wrapper
                                ${leftSideBar.collapsed
                                ? ''
                                : 'with-side-bar'
                            } custom-padding-top`}>
    
                        <div className={`
                            schedule-control-section
                            schedule-control-section-full
                            ${(this.layoutIframeEditEventView || this.layoutIframeNewEventView) && 'schedule-section-iframe-hidden'}
                        `}>
                            <div className='col-lg-12 control-section h-100'>
                                <div  className={`
                                ${!((this.layoutIframeNewEventView || this.layoutIframeEditEventView) &&
                                    this.layoutIframe)
                                        ? 'control-wrapper h-100'
                                        : 'hidden'
                                    } `}>
                                        <ScheduleComponent
                                            id="schedule"
                                            className={`${this.layoutIframe ? 'custom-calendar-iframe' : 'custom-calendar'}`}
                                            cssClass='schedule-header-bar'
                                            ref={schedule => this.scheduleObj = schedule}
                                            width='100%'
                                            currentView= {this.state.currentView}
                                            dateFormat="dd/M/yyyy"
                                            allowKeyboardInteraction={true}
                                            height='100%'
                                            views={this.viewsCollections}
                                            actionComplete={this.onEventRendered.bind(this)}
                                            dataBound={this.onDataBound}
                                            eventRendered={this.eventRendered}
                                            popupOpen={this.onPopupOpen.bind(this)}
                                            popupClose={this.onPopupClose.bind(this)}
                                            resizeStop={this.onResizeStop.bind(this)}
                                            actionBegin={this.onActionBegin.bind(this)}
                                            cellDoubleClick={this.doubleOpen.bind(this)}
                                            allowResizing={this.allowResizing()}
                                            allowDragAndDrop={this.allowResizing()}
                                            eventSettings={this.scheduleData.length > 0 &&
                                                {
                                                    dataSource: this.scheduleData,
                                                    fields: SCHEDULE_FIELDS,
                                                    enableTooltip: true
                                                }
                                            }
                                            dragStart={(this.onEventDragStart.bind(this))}
                                            eventClick={(this.onEventClick.bind(this))}
                                            dragStop={(this.onEventDragStop.bind(this))}
                                            firstDayOfWeek={1}
                                            timeScale={this.props.calendarsResult.calendarTimeScale}
                                            quickInfoTemplates= {{ 
                                                header: this.quickInfoHeaderTemplate.bind(this), 
                                                content: this.quickInfoContentTemplate.bind(this),  
                                                footer: this.quickInfoFooterTemplate.bind(this)
                                            }}
                                        >
                                        <ViewsDirective>
                                            <ViewDirective option='Day' eventTemplate={this.eventTemplate.bind(this, 'Day')} />
                                            <ViewDirective option='Week' eventTemplate={this.eventTemplate.bind(this, 'Week')} />
                                            <ViewDirective option='WorkWeek' eventTemplate={this.eventTemplate.bind(this, 'WorkWeek')} />
                                            <ViewDirective 
                                                option='Month' 
                                                eventTemplate={this.eventTemplate.bind(this, 'Month')}  
                                                dateFormat='MMMM yyyy' />
                                            <ViewDirective option='Agenda' eventTemplate={this.eventTemplateAgendaView.bind(this)} />
                                        </ViewsDirective>
                                        <ResourcesDirective ref={this.resourcesDirective}>
                                            <ResourceDirective
                                                field='CalendarId'
                                                title={i18n.t("calendar-sidebar.mycalendars")}
                                                name='Calendars'
                                                allowMultiple={false}
                                                dataSource={calendarsForResource.filter(c => c.accessRole !== 'read')}
                                                textField='summary'
                                                idField='id'
                                                colorField='backgroundColor'
                                            >
                                            </ResourceDirective>
                                        </ResourcesDirective>
                                        <Inject services={[Day, Week, WorkWeek, Month, Agenda, Resize, DragAndDrop, RecurrenceEditor]} />
                                    </ScheduleComponent>
                                    <EventsSearch
                                        scheduleObj={this.scheduleObj}
                                        calendars={this.props.calendarsResult.calendars}
                                        userId={this.props.lexon.userId}
                                        mailAccount={this.props.all.login.formValues.user}
                                        lexonToken={this.props.lexon.lexonToken}
                                    />
                                    <div id="calendar-events-print-v2" />
                                    {
                                        this.state.loadedToolbar &&
                                        <Tooltip placement="top-start" isOpen={this.state.showCalendarToolTipOpen} target="showCalendarToolbar" toggle={this.toggleShowCalendarTooltip}>
                                            {i18n.t('calendar.showCalendars')}
                                        </Tooltip>
                                    }
                                    {
                                        (this.state.loadedToolbar && !this.layoutIframe) &&
                                        <Tooltip placement="top-start" isOpen={this.state.configToolTipOpen} target="configToolbar" toggle={this.toggleConfigTooltip}>
                                            {i18n.t('calendar.title')}
                                        </Tooltip>
                                    }
                                </div >
                            </div >
                        </div >
                    </div>
                </div>
                {!this.layoutIframe && <Footer />}
                <section className='hbox space-between'>
                    <article className='d-flex flex-column position-relative'>
                        <div className="hidden">
                            <Reminder
                                ref={this.remObj}
                                layoutIframe={this.layoutIframe}
                                reminders={this.state.reminders}
                                onReady={instance => {
                                    this.remObj && (this.remObj.current.listviewInstance = instance);
                                }}
                            />
                        </div>
                        <div className="hidden">
                            <div className='buttons-wrapper' ref={but => this.buttonEventTypeObj = but}>

                                <div
                                    className="kebab-menu-button"
                                    onClick={() => {
                                        this.onPrintAgenda();
                                        this.profilePopup.hide();
                                    }}
                                >
                                    <div className="kebab-menu-icon kebab-menu-icon-print"/>
                                    Imprimir
                                </div>
                                <div
                                    className="kebab-menu-button"
                                    onClick={() => this.onFilterEventTypeClick()}
                                >
                                    <div id="kebak-icon-filter" className="kebab-menu-icon kebab-menu-icon-filter"/>
                                    Filtrar por tipos de eventos
                                </div>
                                <div
                                    className="kebab-menu-button"
                                    onClick={() => this.onEventTypeClick()}
                                >
                                    <div className="kebab-menu-icon kebab-menu-icon-event-types"/>
                                    {i18n.t('eventtype.title_menu_event_type')}
                                </div>
                                <div
                                    className="kebab-menu-button"
                                    onClick={() => this.onImportContactsTypeClick()}
                                >
                                    <div className="kebab-menu-icon kebab-menu-icon-import-events"/>
                                    Importar eventos de LexON
                                </div>
                                {isImportEventsLexonV2Enabled([this.props.lexon.account, this.props.lexon.user, this.props.lexon.userId]) && (
                                    <div
                                        className="kebab-menu-button"
                                        onClick={() => this.onImportEventsV2Click()}
                                    >
                                        <div className="kebab-menu-icon kebab-menu-icon-import-events"/>
                                        Importar eventos de LexON V2
                                    </div>
                                )}
                                <div
                                    className="kebab-menu-button"
                                    onClick={() => this.onConfigurationHoursClick()}
                                >
                                    <div className="kebab-menu-icon kebab-menu-icon-config"/>
                                    {i18n.t('calendar.configuration_hours')}
                                </div>
                            </div>
                        </div>

                        <ToastComponent
                            ref={(toast) => {
                              this.toastObj = toast;
                            }}
                            id="toast_pos"
                            content="Action successfully completed."
                            position={this.position}
                            target={this.target}
                            close={this.toastOnclose.bind(this)}
                            beforeOpen={this.toastOnbeforeOpen.bind(this)}
                            animation={this.toastCusAnimation}
                            timeOut={7000}
                            showCloseButton
                        ></ToastComponent>
                        
                        {/* Connection Error Modal - shows when CalDAV requests fail after retries */}
                        <DialogComponent
                            id='connectionErrorDialog'
                            isModal={true}
                            header={i18n.t("calendar.connection_error_title", "Error de conexión")}
                            visible={this.state.showConnectionErrorModal}
                            showCloseIcon={true}
                            closeOnEscape={true}
                            animationSettings={this.animationSettings}
                            width='450px'
                            target='#target'
                            open={this.dialogOpen.bind(this)}
                            close={this.handleCloseConnectionErrorModal}
                            className="modal-form-schedule-container modal-container"
                        >
                            <div className="dialog-content" style={{ textAlign: 'center' }}>
                                <i className="lf-icon lf-icon-warning" style={{ fontSize: '48px', color: '#f0ad4e', marginBottom: '15px', display: 'block' }}></i>
                                <p style={{ margin: 0, fontSize: '14px', color: '#666' }}>
                                    {this.state.connectionErrorMessage || i18n.t("calendar.connection_error_message", "No se pudo conectar con el servidor. Por favor, intenta de nuevo.")}
                                </p>
                                <div className="e-footer-content">
                                    <div className="my-3 btn-action-container">
                                        <Button
                                            className="btn-outline-primary inter-bold-16"
                                            title={i18n.t("general.cancel", "Cancelar")}
                                            color="secondary"
                                            onClick={this.handleCloseConnectionErrorModal}
                                        >
                                            {i18n.t("general.cancel", "Cancelar")}
                                        </Button>
                                        <Button
                                            className="ml-2 inter-bold-16"
                                            color="primary"
                                            title={i18n.t("calendar.retry", "Reintentar")}
                                            onClick={this.handleRetryConnection}
                                        >
                                            {i18n.t("calendar.retry", "Reintentar")}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </DialogComponent>
                        
                        <Confirmation
                            initialModalState={showNotClassifiedEvent}
                            onAccept={() => {
                                this.setState({ showNotClassifiedEvent: false });
                            }}
                            message={i18n.t("schedule.event-not-clafified-description")}
                            titleAccept={i18n.t('general.accept')}
                            confirmType="confirm-error"
                            iconType="lf-icon lf-icon-close-round"
                        />
                        <Confirmation
                            initialModalState={showSharedCalendarSyncInfo}
                            onAccept={() => {
                                this.setState({ showSharedCalendarSyncInfo: false });
                                this.onCloseDialog(false, false);
                            }}
                            message={i18n.t("schedule.shared-calendar-sync-info")}
                            titleAccept={i18n.t('general.accept')}
                            confirmType="confirm-info"
                            iconType="lf-icon lf-icon-info-full"
                        />
                         <Confirmation
                            initialModalState={this.state.showDeleteConfirmation}
                            onAccept={() => {
                                const currentAction = this.scheduleObj?.activeEventData?.event?.RecurrenceID ? 'DeleteSeries' : 'Delete';
                                this.scheduleObj.deleteEvent([this.state.quickInfoEventData], currentAction);
                                this.setState({showDeleteConfirmation:false})
                                if (window === window.top) {
                                    this.scheduleObj.closeEditor();
                                }
                            }}
                            onCancel={() => {
                                this.scheduleObj.closeQuickInfoPopup();
                                this.setState({showDeleteConfirmation:false});
                            }}
                            message={ this.scheduleObj?.activeEventData?.event?.RecurrenceID ?
                                i18n.t("schedule.deleteRecurrentEvent")
                                .replace('{1}', this.scheduleObj?.activeEventData?.event?.Subject)
                                :
                                i18n.t("schedule.deleteEvent")
                                .replace('{}', this.scheduleObj?.activeEventData?.event?.Subject)}
                            titleAccept={i18n.t("schedule.delete")}
                            titleCancel={i18n.t("schedule.cancel")}
                            confirmType="confirm-info"
                            iconType="lf-icon lf-icon-information"
                        />
                        <Confirmation
                            initialModalState={this.state.showDateValidationAlert}
                            onAccept={() => {
                                this.setState({showDateValidationAlert:false})
                            }}
                            message={i18n.t("schedule.date-validation-error")}
                            titleAccept={i18n.t("schedule.date-validation-error-close")}
                            confirmType="confirm-info"
                            iconType="lf-icon lf-icon-information"
                        />
                        <Confirmation
                            initialModalState={this.state.showRecurrenceConfirmation}
                            onAccept={() => {
                                this.setState({showRecurrenceConfirmation: false }, () => {
                                const recurrenceEventFind = this.scheduleObj.eventBase
                                .getOccurrenceEvent(this.state.quickInfoEventData.RecurrenceID)
                                .find((x) => x.Id === this.state.quickInfoEventData.RecurrenceID);
                                this.scheduleObj.openEditor(
                                    {
                                        ...this.state.quickInfoEventData, 
                                        StartTime: recurrenceEventFind ? 
                                          recurrenceEventFind?.StartTime : this.state.quickInfoEventData.StartTime,
                                        EndTime: recurrenceEventFind ?
                                            recurrenceEventFind?.EndTime : this.state.quickInfoEventData.EndTime,
                                    },
                                    'EditSeries',
                                    true,
                                )
                            });
                            }}
                            onCancel={() => {
                                this.setState({showRecurrenceConfirmation: false });
                            }}
                            message={i18n.t("schedule.editRecurrenceContent")}
                            titleAccept={i18n.t("general.accept")}
                            titleCancel={i18n.t("general.cancel")}
                            confirmType="confirm-info"
                            iconType="lf-icon lf-icon-information"
                        />
                        <Confirmation
                            initialModalState={this.state.showAlertUser}
                            onAccept={() => {
                                this.setState({showAlertUser: false});
                            }}
                            message={i18n.t("schedule.user-not-found")}
                            titleAccept={i18n.t("general.accept")}
                            confirmType="confirm-info"
                            iconType="lf-icon lf-icon-info-full"
                        />
                        <DialogComponent
                            id='dialogDraggable'
                            isModal={true}
                            header={i18n.t(this.state.calendarToEdit !== '' ? "calendar.edit_calendar" : "calendar.new_calendar")}
                            visible={this.state.hidePromptDialog}
                            animationSettings={this.animationSettings}
                            target="#target" 
                            width='940px'
                            open={this.dialogOpen.bind(this)}
                            className="modal-form-schedule-container modal-form-calendar">
                            <div>{(this.state.hidePromptDialog) && 
                                <Calendars
                                    userId={this.props.lexon.userId}
                                    userAccount={this.props.all.login.formValues.user}
                                    userPw={this.props.all.login.formValues.password}
                                    userNavision={this.props.currentUser.idClienteLef}
                                    token={this.props.lexon.lexonToken}
                                    calendarId={this.state.calendarToEdit}
                                    calendars={this.props.calendarsResult.calendars}
                                    successCalendarClose={this.dialogSuccessCalendarClose.bind(this)}
                                    userName={this.props.currentUser.name}
                                    userSign={this.props.lexon.sign}
                                    cancel={() => {
                                        this.setState({
                                          hidePromptDialog: false,
                                        });
                                    }}
                                /> 
                            }</div>
                        </DialogComponent>
                        <DialogComponent
                            id='eventTypes'
                            isModal={true}
                            header={i18n.t("eventtype.title_menu_event_type")}
                            visible={this.state.hidePromptEventTypeDialog}
                            animationSettings={this.animationSettings}
                            width="940px"
                            ref={dialog => this.promptDialogEventTypeInstance = dialog}
                            target='#target'
                            open={this.dialogOpen.bind(this)}
                            className="modal-form-schedule-container modal-event-types-container">
                            <div>
                                {(this.state.hidePromptEventTypeDialog) && (
                                    <Eventtype
                                        getlistEventTypes={this.getlistEventTypes.bind(this)}
                                        email={this.props.email}
                                        colorMode={this.state.eventTypeColorMode}
                                        onColorModeChange={(newMode) => {
                                            this.setState({ eventTypeColorMode: newMode });
                                            this.scheduleObj.refresh();
                                        }}
                                        cancel={() => {
                                            this.setState({
                                              hidePromptEventTypeDialog: false,
                                            });
                                        }}
                                        lexonToken={this.props.lexon.lexonToken}
                                    /> 
                                )}
                            </div>
                        </DialogComponent>
                        <DialogComponent
                            id="filterEventTypes"
                            isModal={true}
                            header={i18n.t("eventtype.filter_title")}
                            visible={this.state.hidePromptFilterEventTypeDialog}
                            animationSettings={this.animationSettings}
                            width="940px"
                            ref={(dialog) =>
                            (this.promptDialogEventTypeInstance = dialog)
                            }
                            target="#target"
                            open={this.dialogOpen.bind(this)}
                            close={this.dialogFilterEventTypeClose.bind(this)}
                            className="
                                modal-form-schedule-container 
                                modal-container 
                                modal-filter-event-type-container"
                        >
                            <div>
                            {this.state.hidePromptFilterEventTypeDialog && (
                                <FilterEventtype
                                    filterEventType={this.state.filterEventType}
                                    eventTypes={this.eventTypeDataSource}
                                    onFilterEventsByEventType={this.onFilterEventsByEventType.bind(this)}
                                    cancel={() => {
                                        this.setState({
                                          hidePromptFilterEventTypeDialog: false,
                                        });
                                    }}
                                    openEventTypes={() => {
                                        this.setState({
                                          hidePromptEventTypeDialog: true,
                                          hidePromptFilterEventTypeDialog: false,
                                        });
                                    }}
                                />
                            )}
                            </div>
                        </DialogComponent>
                        <DialogComponent
                            id='configuration-hours'
                            isModal={true}
                            header={i18n.t('calendar.configuration_hours')}
                            visible={hideConfigurationHoursDialog}
                            animationSettings={this.animationSettings}
                            width='940px'
                            target='#target'
                            open={this.dialogOpen.bind(this)}
                            className="modal-form-schedule-container modal-container">
                            <div>
                                {(hideConfigurationHoursDialog) && (
                                    <ConfigurationHours 
                                        close={(value) => this.dialogConfigurationHoursClose(value)} 
                                    />
                                )}
                            </div>
                        </DialogComponent>
                        <DialogComponent
                            id='EventImports'
                            isModal={true}
                            header={"Importar eventos de LexON"}
                            visible={this.state.showPromptImportContactsDialog}
                            showCloseIcon={true}
                            animationSettings={this.animationSettings}
                            width="940px"
                            height="724px"
                            ref={dialog => this.promptDialogEventTypeInstance = dialog}
                            target='#target'
                            open={this.dialogOpen.bind(this)}
                            close={this.dialogImportContactsClose.bind(this)}
                            className="modal-form-schedule-container">
                            <div>{(this.state.showPromptImportContactsDialog) &&
                                <ContactsImport
                                    getlistEventTypes={this.getlistEventTypes.bind(this)}
                                    googleUser={this.props.googleUser}
                                    close={this.dialogClose.bind(this)}
                                />
                            }</div>
                        </DialogComponent>
                        <DialogComponent
                            id="importEventsV2"
                            isModal={true}
                            showCloseIcon={true}
                            header="Importar eventos de LexON V2"
                            visible={this.state.showPromptImportEventsV2Dialog}
                            animationSettings={this.animationSettings}
                            width="min(940px, 96vw)"
                            height="auto"
                            target="#target"
                            close={this.dialogImportEventsV2Close.bind(this)}
                            className="modal-form-schedule-container">
                            <div>
                                {this.state.showPromptImportEventsV2Dialog && (
                                    <EventsImportV2
                                        getlistEventTypes={this.getlistEventTypes.bind(this)}
                                        close={this.dialogImportEventsV2Close.bind(this)}
                                    />
                                )}
                            </div>
                        </DialogComponent>
                    </article >
                </section >
                {popoverTargetEl && this.state.loadedToolbar && (
                    <Popover
                        key={this.state.toolbarRenderKey}
                        isOpen={isIframeOptionsOpen}
                        target="iframe-options-toolbar"
                        toggle={() => {
                            this.setState({ isIframeOptionsOpen: !isIframeOptionsOpen });
                        }}
                        placement="bottom"
                        className="popover-filter-date-events"
                    >
                    <PopoverBody>
                        <div className="pt-2 menu-option-container">

                        <div 
                            className="d-flex align-items-center change-account-container" 
                            onClick={() => this.openCalendar()}
                        >
                            <span className="lf-icon lf-icon-open-window mr-2"></span>
                            <span className="change-account-text">{i18n.t("menu-user.calendar-view")}</span>
                        </div>

                        <div 
                            className="d-flex align-items-center add-account-container"
                            onClick={() => this.handleLogout()}
                        >
                            <span className="lf-icon lf-icon-close-session mr-2"></span>
                            <span className="add-account-text">{i18n.t("menu-user.close-session")}</span>
                        </div>

                        </div>
                    </PopoverBody>
                    </Popover>
                )}
                {((this.layoutIframe) && (this.layoutIframeNewEventView || this.layoutIframeEditEventView)) ? (
                    <style>{`
                        .schedule-section-iframe-hidden {
                            display: none;
                        }
                        .conflict-warning-container {
                            background-color: #FFF2C2;
                            border-radius: 4px;
                            padding: 10px;
                            margin-bottom: 12px;
                        }
                        .conflict-warning-message {
                            display: flex;
                            justify-content: space-between;
                        }
                    `}</style>
                    ) : (
                        <style>{`
                            #schedule_dialog_wrapper {
                                min-height: 300px !important;
                                height: 713px !important;
                                max-height: 730px !important;
                                .e-dlg-header-content {
                                    padding: 15px !important;
                                }
                            }

                            @media (max-height: 800px) {
                                #schedule_dialog_wrapper {
                                    height: 85vh !important;
                                    max-height: 85vh !important;
                                }
                            }

                            @media (max-height: 650px) {
                                #schedule_dialog_wrapper {
                                    height: 90vh !important;
                                    max-height: 90vh !important;
                                    min-height: 260px !important;
                                }
                            }

                            .conflict-warning-container {
                                background-color: #FFF2C2;
                                border-radius: 4px;
                                padding: 10px;
                                margin-bottom: 12px;
                            }

                            .conflict-warning-message {
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                gap: 10px;
                            }

                            .conflict-list {
                                margin-left: 28px;
                                font-size: 14px;
                                color: #666;
                            }

                            .conflict-item {
                                margin: 4px 0;
                            }

                            .conflict-more {
                                margin-top: 4px;
                                font-style: italic;
                                color: #999;
                            }
                        `}</style>
                    )}
            </div >
            );
        }
        else {
            return this.renderSpinner();
        }
    }

    closeEventDialog() {
        if (window == window.top) {
            return;
        }
        if (this.isSharedCalendarPendingClose) {
            this.setState({ showSharedCalendarSyncInfo: true });
            return;
        }
        this.onCloseDialog(false);
    }

    onCloseDialog(removed = false) {
        if (!this.layoutIframe) {
            this.sidebarCalendarList();
            let selectedCalendars = this.props.calendarsResult.calendars.filter(
                (c) => c.checked === true
              );
    
            selectedCalendars.forEach((cal) => {
                this.loadCalendarEvents(cal.id, true);
            });
            
            const buttons = document.getElementsByClassName("e-footer-content");
            if (buttons) {
                for (let i = 0; i < buttons.length; i++) {
                    buttons[i].style.visibility = 'visible';
                }
            }
    
            var editButtonSave = document.querySelector('.e-event-save');
            if(editButtonSave) {
                editButtonSave.disabled = false;
            }
        }       
        if (window != window.top) {
            if (!removed) {
                this.closingIframe = true;
            }
            const appUrl = this.state.appConnectData ? this.state.appConnectData?.appConnectUrl : window.URL_LEXON;

            this.props.resetIdActuation();
            this.props.resetIdEvent();

            window.top.postMessage(
                JSON.stringify({
                    idEvent: undefined,
                    actionCancelled: true,
                    selectedDate: undefined,
                    removed,
                    message: '',
                    isAuth: false,
                }),
                appUrl
            );
        }
        this.setState({ creatingEvent: false, lexonEvent: false });
    }

    clickCancel(message) {
        var editButtonSave = document.querySelector('.e-event-save');
        if(editButtonSave) {
            editButtonSave.disabled = false;
        }
        if (window != window.top) {
            const appUrl = this.state.appConnectData ? this.state.appConnectData?.appConnectUrl : window.URL_LEXON;
            window.top.postMessage(
                JSON.stringify({
                    idEvent: undefined,
                    actionCancelled: true,
                    selectedDate: undefined,
                    removed: false,
                    message: message,
                    isAuth: false,
                }),
                appUrl
            );
            this.props.resetIdActuation();
            this.props.resetIdEvent();
        }
        this.setState({ creatingEvent: false, lexonEvent: false });
    }

    onCloseDeleteAlert() {
        if (window != window.top) {
            const appUrl = this.state?.appConnectData ? this.state.appConnectData?.appConnectUrl : window.URL_LEXON;
            window.top.postMessage(
                JSON.stringify({
                    idEvent: undefined,
                    actionCancelled: true,
                    selectedDate: undefined,
                    removed: false,
                    message: '',
                    isAuth: false,
                }),
                appUrl
            );
            this.props?.resetIdActuation();
            this.props?.resetIdEvent();
        }
        if (window === window.top) this.setState({creatingEvent: false, lexonEvent: false});
        this.unmountAttendeePortal();
    }

    async handleClassificatedEvent(event) {
        let caldavEvent = this.buildEventoCalDav(event.detail, true, 'classify');
        const { idEvent, idCalendar } = this.props.lexon;

        await addCalendarEvent(
            event.detail.CalendarId,
            caldavEvent,
            this.props.lexon.userId,
            this.props.all.login.formValues.user,
            this.props.lexon.lexonToken
        );
        this.currentClassification = event.detail.LexonClassification;
        this.currentCompany = event.detail.CompanySelected;
        this.currentIdCompany = event.detail.IdCompanySelected;
        this.currentIdEventAction = event.detail.IdEventAction;

        const evt = this.scheduleObj?.dataModule.dataManager.dataSource.json.find(e => e.Id.endsWith(event.detail.Id));
        if (evt){
            evt.LexonClassification = event.detail.LexonClassification;
            evt.CompanySelected = event.detail.CompanySelected;
            evt.IdCompanySelected = event.detail.IdCompanySelected;
            evt.IdEventAction = event.detail.IdEventAction;
        }
        // Intentar notificar al dataManager; la mutación directa ya es suficiente si falla
        this.scheduleObj?.dataModule.dataManager.update?.();

        // Also update this.scheduleData so refreshEvents() preserves classification
        const schedEvt = this.scheduleData.find(e => e.Id && e.Id.endsWith(event.detail.Id));
        if (schedEvt) {
            schedEvt.LexonClassification = event.detail.LexonClassification;
            schedEvt.CompanySelected = event.detail.CompanySelected;
            schedEvt.IdCompanySelected = event.detail.IdCompanySelected;
            schedEvt.IdEventAction = event.detail.IdEventAction;
        }

        if (idEvent && idCalendar && window === window.top) {
            this.scheduleObj.refreshEvents();
        } else {
            if (this.lexonAppRoot && !this.layoutIframeEditEventView) {
                //Remover el contenedor lexon-app-tab si existe
                const lexonTab = document.getElementById('lexon-app-tab');
                if (lexonTab && lexonTab.parentNode) {
                    lexonTab.parentNode.removeChild(lexonTab);
                }
            }
            this.scheduleObj.closeEditor();
            this.scheduleObj.refreshEvents();
        }
        this.scheduleObj.eventSettings.dataSource = [...this.scheduleData];
        this.scheduleObj?.closeEditor();
        this.scheduleObj?.refreshEvents();
    }

    async handleClassificatedEventRemoved(event) {
        // Clear current* before buildEventoCalDav so fallback values don't re-add removed classification
        this.currentClassification = undefined;

        if (!event.detail.isPreviousEvent) {
            event.detail.LexonClassification = undefined;
            const imapEvent = this.buildEventoCalDav(event.detail);
            await addCalendarEvent(
                event.detail.CalendarId,
                imapEvent,
                this.props.lexon.userId,
                this.props.all.login.formValues.user,
                this.props.lexon.lexonToken
            );
            var desc = this.scheduleObj?.dataModule.dataManager.dataSource.json.find(e => {
                return e.Id.split("/").pop() === event.detail.Id
            });
            if (desc){
                desc.LexonClassification = null;
                this.scheduleObj.eventSettings.dataSource = [...this.scheduleData];
                this.scheduleObj.refreshEvents();
            }
        } else {
            const { calendarId, idEvent } = event.detail;
            let desc = null;

            // El backend ya confirmó calendarId+idEvent del evento anterior: lo pedimos
            // directamente en vez de depender de que su calendario esté cargado en pantalla.
            if (calendarId && idEvent) {
                try {
                    const result = await getEventById(
                        this.props.lexon.userId,
                        this.props.all.login.formValues.user,
                        this.props.lexon.lexonToken,
                        calendarId,
                        idEvent
                    );
                    const item = result?.result?.items?.[0];
                    if (item) {
                        desc = getEventDataById(item, calendarId);
                    }
                } catch (error) {
                    // El evento anterior no se pudo recuperar por id; probamos el fallback local
                }
            }

            if (!desc) {
                // Fallback legacy: solo encuentra el evento si su calendario está cargado en pantalla
                desc = this.scheduleObj?.dataModule.dataManager.dataSource.json.find(e => {
                    return parseInt(e.LexonClassification, 10) === event.detail.idActuation
                });
            }

            if (desc){
                desc.LexonClassification = undefined;
                const imapEvent = this.buildEventoCalDav(desc);
                await addCalendarEvent(
                    desc.CalendarId,
                    imapEvent,
                    this.props.lexon.userId,
                    this.props.all.login.formValues.user,
                    this.props.lexon.lexonToken
                );
                desc.LexonClassification = null;
                this.scheduleObj.eventSettings.dataSource = [...this.scheduleData];
                this.scheduleObj?.dataModule.dataManager.update();
                this.scheduleObj?.refreshEvents();
            }
        }

    }

    handleCloseImportEvents() {
        this.onCloseDialog();
    }

    // Handler for CalDAV connection error events (after max retries exceeded)
    // Shows modal with retry button
    handleCaldavConnectionError = (event) => {
        const { message, errorType, retryCallback } = event.detail;
        console.error(`[CalDAV Connection Error] ${errorType}: ${message}`);
        
        this.setState({
            showConnectionErrorModal: true,
            connectionErrorMessage: message,
            connectionRetryCallback: retryCallback
        });
    };

    // Close connection error modal
    handleCloseConnectionErrorModal = () => {
        this.setState({
            showConnectionErrorModal: false,
            connectionErrorMessage: '',
            connectionRetryCallback: null
        });
    };

    // Handle retry button click in connection error modal
    handleRetryConnection = () => {
        const { connectionRetryCallback } = this.state;
        if (connectionRetryCallback && typeof connectionRetryCallback === 'function') {
            console.log('[CalDAV] Retrying connection...');
            connectionRetryCallback();
        }
        this.handleCloseConnectionErrorModal();
    };

    // Handle retry reload event (for test mode - reloads calendar data)
    handleCaldavRetryReload = () => {
        console.log('[CalDAV] Retry reload triggered - reloading calendar data...');
        this.sidebarCalendarList();
        
        // Also reload events for selected calendars
        const selectedCalendars = this.props.calendarsResult.calendars.filter(
            (c) => c.checked === true
        );
        selectedCalendars.forEach((cal) => {
            this.loadCalendarEvents(cal.id, true);
        });
    };

    handleBtnDisabledPrimary(event) {
        let btnSave = document.querySelector(".e-event-save");
        let btnCancel = document.querySelector(".e-event-cancel");
        let btnDelete = document.querySelector(".e-event-delete");
        if (event.detail.disabledBtnPrimary) {
            btnSave.hidden = true;
            btnCancel.hidden = true;
            btnDelete.hidden = true;
        } else {
            btnSave.hidden = true;
            btnCancel.hidden = false;
            btnDelete.hidden = true;
        }
    }

    async setGlobalization() {
        await ensureCldrEsLoaded();
        const data = await import('./calendar/syncfusion-resources/calendar-es.json');
        setCulture('es');
        L10n.load(data);
    }

    TokensFlows() {
        if (window != window.top) {
            this.layoutIframe = true;
            this.layoutIframHeight = window.document.body.clientHeight;
        }

        const search = this.props.location.search;
        const appConnectEvent = new URLSearchParams(search).get('appConnectEvent');
        const appConnectParse = appConnectEvent && parseJwt(appConnectEvent);

        if (this.props.lexon.idActuation && this.props.lexon.idEvent) {
            this.layoutIframeEditEventView = true;
        } else if ((this.props.lexon.idActuation != undefined || appConnectParse) && this.props.lexon.idEvent == null) {
            this.layoutIframeNewEventView = true;
        }
    }

    convertUnicode(input) {
        return input.replace(/\\u(\w{4,4})/g, (a, b) => {
            const charcode = parseInt(b, 16);
            return String.fromCharCode(charcode);
        });
    }

    calendarColorModify(calendarId, color) {
        const { user } = this.props.all.login.formValues;
        const calendar = this.props.calendarsResult.calendars.find(a => a.id === calendarId);
        const calendarData = {
            backgroundColor: color,
            summary: calendar.summary,
            description: calendar.description,
            foregroundColor: '#ffffff'
        };
        updateCalendarList(
            calendarId,
            calendarData,
            this.props.lexon.userId,
            user,
            this.props.lexon.lexonToken
        )
            .then(() => {
                this.toastObj.hide('All');
                this.toastObj.showProgressBar = false;
                this.toastObj.show(getToast().toast[14]);
                const newCalendarResult = this.state.calendarResult.map((cr) => {
                    if (cr.id === calendarId) {
                        return {...cr, backgroundColor: color, colorId: color }
                    }
                    return {...cr}
                });
                this.props.getCalendars(this.props.lexon.userId, user, this.props.lexon.lexonToken, newCalendarResult);
                this.setState({calendarResult: newCalendarResult})
            })
            .catch(error => {
                console.error('error ->', error);
                this.toastObj.showProgressBar = false;
                this.toastObj.hide('All');
                this.toastObj.show(getToast().toast[2]);
            });
    }

    deleteCalendar(calendarid, args) {
        this.setState({loading: true });
        const { user } = this.props.all.login.formValues;
        const { userId } = this.props.lexon;
        const { lexonToken } = this.props.lexon;
        deleteCalendar(calendarid, userId, user, lexonToken)
            .then( async () => {
                this.setState({loading: false });
                this.sidebarCalendarList();
                this.scheduleData = this.scheduleData.filter(obj => obj.CalendarId !== calendarid);
                this.scheduleObj?.refreshEvents();
                this.toastObj.hide('All');
                this.toastObj.show(getToast(args).toast[3]);
            })
            .catch(error => {
                console.error('error ->', error);
                this.toastObj.show(getToast().toast[2]);
            });
    }
    // Calendar View Dialog
    openCalendarView(args) {
        let calendarId = "";
        if (args != undefined) {
            calendarId = args.currentTarget.id;
        }
        this.setState(
            {
                hidePromptDialog: true, calendarToEdit: calendarId
            });
    }
    // Calednar View Dialog
    dialogClose(args) {
        if (args == undefined || args === 'Update') {
            this.sidebarCalendarList(args);

            this.toastObj.show(getToast().toast[1]);
        }

        
        this.setState({
            hidePromptDialog: false
        });
    }

    dialogSuccessCalendarClose(args) {
        this.sidebarCalendarList();
        if (args === 'add') {
          this.toastObj.show(getToast().toast[4]);
        } else {
          this.toastObj.show(getToast().toast[5]);
        }
    
        this.setState({
          hidePromptDialog: false,
        });
    }
    
    // Calednar View Dialog
    dialogOpen() {}
    // Calednar View Dialog
    onFocus() {}
    // Calednar View Dialog
    onBlur() {}

    // EventType View Dialog
    openEventTypeView() {
        this.setState({ hidePromptEventTypeDialog: true });
    }

     // Filter EventType View Dialog
    openFilterEventTypeView() {
        this.setState({
        hidePromptFilterEventTypeDialog: true,
        });
    }


    // Event Type View Dialog
    dialogEventTypeClose(args) {
        this.sidebarCalendarList();
            let selectedCalendars = this.props.calendarsResult.calendars.filter(
                (c) => c.checked === true
              );
    
            selectedCalendars.forEach((cal) => {
                this.loadCalendarEvents(cal.id, true);
            });

        if (args == undefined) {
            this.toastObj.show(getToast().toast[1]);
        }
        this.setState({
            hidePromptEventTypeDialog: false
        });
    }

    onFilterEventsByEventType(data){
        this.dialogFilterEventTypeClose()
        this.setState({filterEventType: data})
        let calendars = groupBy(this.props.calendarsResult.calendars, "checked");
        this.setState({loading:true})
        let filterEventTypeIconEle = document.querySelector("#kebak-icon-filter");
        if (data?.length === this.eventTypeDataSource?.length + 2 && filterEventTypeIconEle){
            filterEventTypeIconEle.classList.remove("kebab-menu-icon-filter-delete")
            filterEventTypeIconEle.classList.add("kebab-menu-icon-filter")
        } else {
            filterEventTypeIconEle.classList.remove("kebab-menu-icon-filter")
            filterEventTypeIconEle.classList.add("kebab-menu-icon-filter-delete")
        }
        calendars.true.forEach((cal) => {
        this.loadCalendarEvents(cal.id, false);
        this.loadCalendarEvents(cal.id, true);
        });
    }

    // Import Contacts View Dialog
    openImportEventsView() {
        this.setState(
            {
                showPromptImportContactsDialog: true
            });
    }

    openImportContactsView(){
        this.setState(
            {
                showPromptImportContactsDialog: true
            });
    }

    // Import Contacts View Dialog
    dialogImportContactsClose() {
        this.setState({
            showPromptImportContactsDialog: false
        });
    }

    getRandomColor(color) {
        let res;
        switch (color.toLowerCase()) {
            case 'azul':
                res = '#0078d4';
                break;
            case 'rojo':
                res = '#c50f1f';
                break;
            case 'amarillo':
                res = '#e6e600';
                break;
            case 'verde':
                res = '#498205';
                break;
            case 'naranja':
                res = '#da3b01';
                break;
            default:
                const letters = '0123456789ABCDEF';
                let color = '#';
                for (let i = 0; i < 6; i++) {
                    color += letters[Math.floor(Math.random() * 16)];
                }
                res = color;
                break;
        }
        return res;
      }

    mapCategory(cat) {
        let res;
        switch (cat.toLowerCase()){
            case "clients":
                res = "Clientes";
                break;
            case "opposites":
                res = "Contrarios";
                break;
            case "suppliers":
                res = "Proveedores";
                break;
            case "lawyers":
                res = "Abogados propios";
                break;
            case "opposingLawyers":
                res = "Abogados contrarios";
                break;
            case "solicitors":
                res = "Procuradores propios";
                break;
            case "opposingSolicitors":
                res = "Procuradores contrarios";
                break;
            case "notaries":
                res = "Notarios";
                break;
            case "courts":
                res = "Juzgados";
                break;
            case "insurances":
                res = "Aseguradoras";
                break;
            case "agencies":
                res = "Agencias";
                break;
            case "others":
                res = "Otros";
                break;
            default:
                res = "Otros";
                break;
        }
        return res;
    }

    async onExportContacts(){
        let contacts = 'testData';

        const userId = this.props.lexon.userId;
        const mailAccount = this.props.all.login.formValues.user;
        const lexonToken = this.props.lexon.lexonToken;

        let errors = [];
        let contactsImported = 0;
        let cancelExportContacts = false;


        window.addEventListener("ExportContactsCancel", () => {
            cancelExportContacts = true;
        });

        for (let i = 0; i < contacts.length; i++){
            if (cancelExportContacts){
                dispatchEvent(
                    new CustomEvent("ExportContactsProgress", {
                      detail: { completed: true, progress: 100, errors, contactsImported },
                    })
                  );
                  return;
            }

            const guid = this.createGuid();

            if (!this.contactString.current) {
                this.contactString.current = await getContactString(userId, mailAccount, lexonToken);
            }

            let nxContact = {
                name: contacts[i].name,
                email: contacts[i].email,
                categories: this.mapCategory(contacts[i].entityType),
                phone: contacts[i].phone,
                mobilePhone: contacts[i].mobilePhone,
                guid: guid,
                filename: `/addressbooks/users/${mailAccount}/${this.contactString.current}/${guid}.vcf`
            }

            await createContact(nxContact, userId, mailAccount, lexonToken);   

            dispatchEvent(new CustomEvent('ExportContactsProgress', {
                detail: {
                    completed: false,
                    progress: Math.round(i * 100 / contacts.length),
                    errors,
                    contactsImported
                }
            }));
        }
    }

    
      // TO DO: Check event importations
    async onExportEvents(eventData) {
        const { detail } = eventData;
        const { events, calendar,selectedImportType, newCalendarName, idUser_  } = detail;
        let idUser = idUser_;
        const errors = [];
        const warnings = []; // Track events with conflicts
        let eventsImported = 0;
        let cancelExportEvents = false;

        let {calendars} = this.props.calendarsResult;
        let importCalendarList = calendars.map(c => {
            return {summary: c.summary, id: c.id, description: c.description}
        });

        let selectedCalendarFromLexon = calendars.find(c=> c.id === calendar)

        if (selectedImportType === 1 && calendar ==='Nuevo'){
            await createCalendar({
                summary: newCalendarName,
                description: 'Importado Lex-On',
                color: this.getRandomColor('nuevo')
            },
            this.props.lexon.userId,
            this.props.all.login.formValues.user,
            this.props.lexon.lexonToken)

            selectedCalendarFromLexon = {
              summary: newCalendarName.toLowerCase(),
              id: `/remote.php/dav/calendars/${this.props.all.login.formValues.user}/${encodeURIComponent(newCalendarName)}/`,
              description: 'Importado Lex-On'
            }
            importCalendarList.push(selectedCalendarFromLexon);
        }

        window.addEventListener("ExportEventsCancel", () => {
            cancelExportEvents = true;
        });

        for (let i = 0; i < events.length; i++) {
            if (cancelExportEvents) {
                dispatchEvent(
                  new CustomEvent("ExportEventsProgress", {
                    detail: { completed: true, progress: 100, errors, warnings, eventsImported },
                  })
                );
                return;
            }

            const isAllDay = this.isAllDay(events[i])
            const sd = (isAllDay) ? moment(events[i].startDate).format('YYYYMMDD') : moment(events[i].startDate).format('YYYY-MM-DD HH:mm:ss');
            const ed = (isAllDay) ? moment(events[i].endDate).format('YYYYMMDD') : moment(events[i].endDate).format('YYYY-MM-DD HH:mm:ss');
            const guid = this.createGuid();
            
            const lefEvent = {
                start: sd,
                end: ed,
                allDay: isAllDay,
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                summary: events[i].subject,
                saveType: 'new',
                attendees: events[i].assistants ? events[i].assistants : [],
                description: events[i].notes || '', //Description or notes?
                visibility: events[i].private ? 'private' : 'default'
            };

            if (events[i].reminder !== null && events[i].reminder > 0) {
                lefEvent.reminders = [{
                    type: 'display',
                    trigger: events[i].reminder
                }]
            }

            // Check for conflicts with existing events
            const eventStartTime = new Date(events[i].startDate);
            const eventEndTime = new Date(events[i].endDate);
            const conflicts = this.checkEventConflict(eventStartTime, eventEndTime, null, isAllDay);

            if (conflicts.length > 0) {
                warnings.push({
                    event: events[i],
                    conflicts: conflicts.map(c => ({
                        subject: c.Subject,
                        startTime: c.StartTime,
                        endTime: c.EndTime
                    })),
                    message: `El evento "${events[i].subject}" coincide con ${conflicts.length} evento(s) existente(s)`
                });
            }

            let calId;
            let searchEvents;
            let eventFound = false;
            let calendarExists;

            if(events[i].calendar != undefined && events[i].calendar!=null && selectedImportType !== 1){
                calendarExists = importCalendarList.find(
                  (c) => c.summary.toLowerCase() === events[i].calendar.toLowerCase()
                );
              }else if (events[i].calendar != undefined && events[i].calendar!=null && selectedImportType === 1 ){
                calendarExists = selectedCalendarFromLexon
              }
            
            if (events[i].calendar !== null && calendarExists){

                if (selectedImportType !== 1){
                    calId = `/remote.php/dav/calendars/${this.props.all.login.formValues.user}/${encodeURIComponent(events[i].calendar.toLowerCase() === 'personal' ? events[i].calendar.toLowerCase() : events[i].calendar)}/`;
                }else{
                    calId = `/remote.php/dav/calendars/${this.props.all.login.formValues.user}/${encodeURIComponent(selectedCalendarFromLexon.summary.toLowerCase() === 'personal' ? selectedCalendarFromLexon.summary.toLowerCase() : selectedCalendarFromLexon.summary )}/`;
                }
                
                try {
                    let searchEv = {
                        start: lefEvent.allDay ? moment(sd).add(-1, 'days').format('YYYYMMDD') : sd,
                        end: lefEvent.allDay ? moment(ed).add(1, 'days').format('YYYYMMDD') : ed,
                    }
                    searchEvents = await getEventByDate(this.props.lexon.userId, this.props.all.login.formValues.user, this.props.lexon.lexonToken, calId, searchEv);    
                } catch (error) {
                    console.error('error ->', error);
                }
                let classificatedEvent = (events[i].idClassification && events[i].idClassification > 0);
                if (searchEvents && searchEvents.result && searchEvents.result.items && searchEvents.result.items.length > 0 ){
                    for (let j = 0; j < searchEvents.result.items.length; j++) {
                        const nxEvent = searchEvents.result.items[j];
                        if (classificatedEvent){
                            eventFound = (nxEvent.lexonActuation === events[i].idClassification);
                        } else {
                            eventFound = (nxEvent.summary === events[i].subject || parseInt(nxEvent.idEventLexon, 10) === events[i].id);
                        }
                        if (eventFound) {
                            break;
                        }
                    }
                }
            }
            if (!eventFound && events[i].calendar !== null // Process only events that where created in Lexon old calendar (calendar not null)
            ){
                if (selectedImportType !== 1){
                    calId = `/remote.php/dav/calendars/${this.props.all.login.formValues.user}/${encodeURIComponent(events[i].calendar)}/`;
                    if (!calendarExists){
                        let res = await createCalendar({
                            summary: events[i].calendar,
                            description: 'Importado Lex-On',
                            color: this.getRandomColor(events[i].calendar)
                        },
                        this.props.lexon.userId,
                        this.props.all.login.formValues.user,
                        this.props.lexon.lexonToken)
                        if (res){
                            importCalendarList.push(
                                {
                                    summary: events[i].calendar,
                                    id: calId,
                                    description: 'Importado Lex-On'
                                }
                            );
                            calendarExists = importCalendarList.find(c => c.summary.toLowerCase() === events[i].calendar.toLowerCase());
                        }
                    }
                }else{
                    calId = `/remote.php/dav/calendars/${this.props.all.login.formValues.user}/${encodeURIComponent(selectedCalendarFromLexon.summary)}/`;
                }
                let eventType = {};
                if (selectedImportType === 1){// Verificacion si existe el tipo de evento
                    let eventTypeSelected = this.eventTypeDataSource.find(evt => evt.text === events[i].calendar )
                    if (eventTypeSelected){//El tipo de evento existe
                      eventType.name = eventTypeSelected.text;
                      eventType.id = eventTypeSelected.id;
                      eventType.color = eventTypeSelected.backgroundColor;
                    }else{//No existe se procede a crear
                      const newEventType = await addorUpdateEventType(
                        {
                          email:this.props.email,
                          eventType:{
                            name:events[i].calendar,
                            color:"#914150"
                          }
                        },
                        this.props.lexon.lexonToken
                      )
                      if (newEventType.errors.length === 0){
                        this.getlistEventTypes()
                        await this.sleep(500)
                        eventType.name = newEventType.data.name;
                        eventType.id = newEventType.data.idEvent;
                        eventType.color = newEventType.data.color;
                      }
                    }
                }
               
                try {
                    let cal = calendarExists;
                    let createdEvent = {};
    
                    if (cal
                        &&  (events[i].idEvent === null || events[i].idEvent === '')
                    ){
                        let addCalRes = null;

                        try {

                            if (eventType?.id){
                                lefEvent.categories = [{
                                    name: eventType.name
                                }]
                                lefEvent.color = eventType.color
                              }

                            lefEvent.x = [
                                { key: 'X-ACTUATION', value: '' },
                                { key: 'X-COMPANY', value: '' },
                                { key: 'X-IDEVENTACTION', value: '' },
                                { key: 'X-IDCOMPANY', value: '' },
                                { key: 'X-IDEVENTLEXON', value: events[i].id }
                            ] //If this is the replacement of extenden properties check if in the implementation we are loading those properties

                            lefEvent.filename = cal.id + guid;
                            await addCalendarEvent(
                                cal.id,
                                lefEvent,
                                this.props.lexon.userId,
                                this.props.all.login.formValues.user,
                                this.props.lexon.lexonToken
                            );
                            createdEvent.id = guid;
                            createdEvent.calId = cal.id;    
                        } catch (err) {
                            console.error('error -->', err);
                        }
    
                        if (createdEvent.id && events[i].idClassification && events[i].idClassification > 0){
                            // Appointment
                            const lexEvent = {
                                Id: events[i].id,
                                Subject: events[i].subject,
                                AllDay: events[i].allDay ? events[i].allDay : this.isAllDay(events[i]),
                                Guid: createdEvent.id,
                                StartTime: events[i].startDate,
                                EndTime: events[i].endDate,
                                calendar: {
                                    id: cal.id,
                                    summary: events[i].calendar,
                                    backgroundColor: '',
                                    foregroundColor: ''
                                },
                                Reminders: (events[i].reminder) ? [{method: 'email', minutes: events[i].reminder}] : null,
                                Account: this.props.lexon.account,
                                Importado: 1
                            };
    
                            const { provider } = this.props.lexon;
                            let newAppointmentId, addAppointRes, updateEvRes;
                            
                            if (!idUser){
                                idUser = this.props.currentUser.idUser;
                            }
    
                            try {
                                addAppointRes = await createAppoinment(events[i].bbdd, events[i].idCompany, { idUser, provider }, lexEvent, null, this.props.lexon.lexonToken);
                                newAppointmentId = addAppointRes.result.data;
    
                                try {
                                    lefEvent.calendar = {
                                        id: cal.id,
                                            summary: events[i].calendar,
                                            backgroundColor: '',
                                            foregroundColor: ''
                                    }
    
                                    lefEvent.x = [
                                        { key: 'X-ACTUATION', value: `${events[i].idClassification}` },
                                        { key: 'X-COMPANY', value: `${events[i].bbdd}` },
                                        { key: 'X-IDEVENTACTION', value: `${newAppointmentId}` },
                                        { key: 'X-IDCOMPANY', value: `${events[i].idCompany}` },
                                        { key: 'X-IDEVENTLEXON', value: events[i].id }
                                    ] //If this is the replacement of extenden properties check if in the implementation we are loading those properties
    
                                    try {
                                        if (events[i].reminder !== null && events[i].reminder > 0) {
                                            lefEvent.reminders = [{
                                                type: 'display',
                                                trigger: events[i].reminder
                                            }]
                                        }

                                        await addCalendarEvent(
                                            cal.id, lefEvent,
                                            this.props.lexon.userId,
                                            this.props.all.login.formValues.user,
                                            this.props.lexon.lexonToken
                                        )

                                        console.info('Debug: main.jsx | onExportEvents | Event updated OK');
                                        console.info('Debug: main.jsx | onExportEvents | Classification info updated in provider event');

                                    } catch (err) {
                                        console.error('Debug: main.jsx | onExportEvents | ERROR storing classification info in external provider event');
                                        console.error(err);
                                    }
                                } catch (err) {
                                  console.error('Debug: main.jsx | onExportEvents | ERROR adding event to actuation in lexon');
                                  console.error(err);
                                }
                              } catch (err) {
                                console.error('Debug: main.jsx | onExportEvents | ERROR adding event to actuation in lexon');
                                console.error(err);
                              }
                        }
                    }
                    eventsImported++;
                } catch (err) {
                    errors.push({ event: events[i], error: err });
                }
                await this.sleep(1000);//Check these two sleep to check wich one is the correct one
            } else {
                if (events[i].calendar === null) {
                    errors.push({
                      event: events[i],
                      error: {
                        body: '{"code":"Inválido","message":"El evento no tiene calendario"}',
                        message: "El evento no tiene calendario",
                      },
                    });
                }
                else if (eventFound) {
                    errors.push({
                        event: events[i],
                        error: {
                        body: '{"code":"Duplicado","message":"Evento duplicado"}',
                        message: "Evento duplicado",
                        },
                    });
                }
            }

            

            dispatchEvent(new CustomEvent('ExportEventsProgress', {
                detail: {
                    completed: false,
                    progress: Math.round(i * 100 / events.length),
                    errors,
                    warnings,
                    eventsImported
                }
            }));

            await this.sleep(1000);//Check these two sleep to check wich one is the correct one
        }

        dispatchEvent(new CustomEvent('ExportEventsProgress', {
            detail: {
                completed: true, progress: 100, errors,
                warnings,
                eventsImported
            }
        }));

        this.sidebarCalendarList();
        this.loadCalendarList(true)
        this.setState({
            importingEvents: true
        });
    }

    async sleep(time) {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve();
            }, time);
        });
    }

    isAllDay(event) {
        if (event.allDay){
            return true;
        }
        if (event.startDate.endsWith("00:00:00.000000") && event.endDate.endsWith("00:00:00.000000")) {
            return true;
        }
        return false;
    }

    // Filter Event Type View Dialog
    dialogFilterEventTypeClose(args) {
        if (args == undefined) {
        this.toastObj.show(getToast().toast[13]);
        }
        this.setState({
        hidePromptFilterEventTypeDialog: false,
        });
    }

    toastCusAnimation = {
        hide: { duration: '1' },
        show: { duration: '200' }
    };

    toastPreventDuplicate(e) {
        const toastEle = e.element;
        const toasts = e.toastObj.element.children;
        for (let i = 0; i < toasts.length; i++) {
            const toastTitle = toasts[i].querySelector('.e-toast-title');
            const toastMessage = toasts[i].querySelector('.e-toast-message');
            if (toastTitle && toastTitle.isEqualNode(toastEle.querySelector('.e-toast-title'))) {
                return true;
            }
            if (!toastTitle && toastMessage && toastMessage.isEqualNode(toastEle.querySelector('.e-toast-message'))) {
                return true;
            }
        }
        return false;
    }

    toastOnbeforeOpen(e) {
        e.cancel = this.toastPreventDuplicate(e);
    }

    toastOnclose(e) {        
        if (e.toastContainer.childElementCount === 0) {
            this.toastBtnHide.element.style.display = 'none';
        }
    }

    editorTemplate() {}

    getTimeString(value) {
        return this.instance.formatDate(value, { skeleton: 'hm' });
    }

    text_truncate(str, length, ending) {
        if (length == null) {
            length = 10;
        }
        if (ending == null) {
            ending = '...';
        }
        if (str.length > length) {
            return str.substring(0, length - ending.length) + ending;
        }
            return str;
    }

    eventTemplate(viewType, props) {
        this.viewCalendar.current = viewType;
        const { eventTypeColorMode } = this.state;
        let colorExist = false;
        if (props.EventType?.color !== undefined && props.EventType?.color !== null) {
            colorExist = true
        }
        let subjectStr = props.Subject;
        if (props.Subject !== undefined) {
            subjectStr = props.Subject;
        } else {
            subjectStr = i18n.t("schedule.notitle")
        }

        return (
            <div 
                style={{ 
                    width: eventTypeColorMode === EVENT_TYPE_COLOR_MODES.DOT ? '98%' : '100%',
                    cursor: 'pointer',
                    height: '100%',
                    overflow: 'hidden'
                }} 
                data-toggle="tooltip"
                data-placement="top"
                title={props.Subject}
            >
            <div className="image" style={{ height: '100%', width: '100%', overflow: 'hidden' }}>
                <div className='eventicon d-flex' style={{ gap: '0.25rem', alignItems: 'flex-start', height: '100%', width: '100%', overflow: 'hidden' }}>
                    {(props.LexonClassification && 
                        props.LexonClassification !== 'undefined' && 
                        props.LexonClassification !== 'null') && (
                        <div style={{ flexShrink: 0 }}>
                            <LogoIcon width="15" height="15" />
                        </div>
                    )}
                    {!props.IsAllDay && (
                        <div style={{ flexShrink: 0 }}>
                            {moment(props.StartTime).format("HH:mm")}
                        </div>
                    )}
                    <div 
                        style={{ flex: '1', minWidth: 0, overflow: 'hidden', fontSize: '13px', fontWeight: '500' }}
                        className={!props.IsAllDay && viewType !== 'Month' ? 
                            'text-truncate-calendar' : 'text-truncate'}>
                        {subjectStr}
                    </div>
                    {(colorExist && eventTypeColorMode === EVENT_TYPE_COLOR_MODES.DOT) && (
                        <div style={{ flexShrink: 0, width: '20px', display: 'flex', justifyContent: 'flex-end' }}>
                            <span 
                                style={{
                                    backgroundColor: props.EventType.color,
                                    marginTop: '3px',
                                    border: '2px solid var(--white)'
                                }}
                                className='dot floatleft'
                            />
                        </div>
                    )}
                </div>
            </div>
            </div>
        );
    }

    getTimeDiffString(start, end) {
        const { hours, minutes } = dateTimeDiff(start, end);
        return hours > 0 ? `${hours}h ${minutes}min` : `${minutes}min`;
    }

    eventTemplateAgendaView(props) {
        const { 
            StartTime: startTime,
            EndTime: endTime,
            LexonClassification: lexonClassification,
            IsAllDay: isAllDay,
            Subject: subject,
            EventType: eventType,
        } = props;

        const { eventTypeColorMode } = this.state;
        const subjectStr = subject ?? i18n.t("schedule.notitle");
        const eventDuration = this.getTimeDiffString(startTime, endTime);

        return (
            <div>
                <div className="event-card-data">
                    {isAllDay ? (
                        <>
                        <div className="event-card-data-info">
                            {
                              lexonClassification && (
                                <LogoIcon width="15" height="15" className="event-lefebvre-img" />
                              )
                            }
                            <span className="event-card-data-allday">
                                {i18n.t('calendar.allDay')}
                            </span>
                            <span className="event-card-data-title ml-3">
                                {subjectStr}
                            </span>
                        </div>
                      </>
                    ) : (
                        <div>
                            <div className="event-card-data-info">
                            {
                                lexonClassification && (
                                    <LogoIcon width="15" height="15" className="event-lefebvre-img" />
                                )
                            }
                                <span className="event-card-data-time">
                                    {getDateTimeInHHMM(startTime)}
                                </span>
                                <span className="event-card-data-title">
                                    {subjectStr}
                                </span>
                            </div>
                            <div className="event-card-data-duration">
                                {eventDuration}
                            </div>
                        </div>
                    )}
                    <div className="event-card-data-dot">
                        {
                            (eventType?.color && eventTypeColorMode === EVENT_TYPE_COLOR_MODES.DOT) && (
                                <Dot color={eventType?.color} size={12} />
                            )
                        }
                        {props?.RecurrenceRule && (
                            <span className="event-card-data-recurrence ml-1" />
                        )}
                    </div>
                </div>
            </div>
        );
    }

    onAgendaEmptyStateLinkClick(event) {
        event.preventDefault();
        if (!this.layoutIframe) {
          this.handleScheduleOpenNewEventEditor();
        } else {
          this.setState({ openNewEventOnFullCalendar: true });
          try {
            localStorage.setItem(this.openNewEventFromIframeStorageKey, "1");
          } catch {
            // localStorage may be blocked by browser settings
          }
          const { lexon } = this.props;
          window.open(`calendar/access/${lexon.lexonToken}/?prov=IM0`, "_blank");
        }
    }

    renderAgendaEmptyState() {
        const scheduleElement = this.scheduleObj?.element;
        if (!scheduleElement || this.scheduleObj.currentView !== "Agenda") {
          return;
        }

        const emptyEventNodes = scheduleElement.querySelectorAll(".e-agenda-view .e-empty-event");
        if (!emptyEventNodes.length) {
          return;
        }

        emptyEventNodes.forEach((emptyEventNode) => {
          if (emptyEventNode.getAttribute("data-custom-agenda-empty") === "true") {
            return;
          }

          emptyEventNode.setAttribute("data-custom-agenda-empty", "true");
          emptyEventNode.classList.add("agenda-empty-event-host");

          ReactDOM.render(
            <div className="agenda-empty-state">
              <div className="agenda-empty-state-icon" aria-hidden="true">
                <ArchiveIcon fill="var(--gray-blue)" width="32" height="32" />
              </div>
              <div className="agenda-empty-state-content">
                <div className="agenda-empty-state-title">{i18n.t('calendar.create_events')}</div>
                <div className="agenda-empty-state-text">
                  <a href="#" onClick={this.onAgendaEmptyStateLinkClick.bind(this)}>
                    {i18n.t('eventtype.not_found_link')}
                  </a>{" "}
                  {i18n.t('calendar.associate_color')} <div>{i18n.t('calendar.differentiate_events')}</div>
                </div>
              </div>
            </div>,
            emptyEventNode
          );
        });
    }

    onDataBinding(e, calendarId) {
        const items = this.dataManager.items;
        if (items.length > 0) {
            for (let i = 0; i < items.length; i++) {
                const event = items[i];
                const status = (event.status || '').toString().trim().toLowerCase();
                if (status === STATUS_CANCELLED) {
                    const cancelledEventIndex = this.scheduleData.findIndex(x => x.Id === event.id);
                    if (cancelledEventIndex !== -1) {
                        this.scheduleData.splice(cancelledEventIndex, 1);
                    }
                    continue;
                }

                const start = event.start.dateTime;
                const end = event.end.dateTime;

                // Recurrence
                let recurrenceRule;
                if (event.recurrence != undefined) {
                    recurrenceRule = event.recurrence[0].replace('RRULE:', '');
                }
                // Attendees
                let attendees = [];
                if (event.attendees != undefined) {
                    attendees = event.attendees;
                } else {
                    attendees = undefined;
                }
                
                // EventType
                const eventType = {};
                if (event.categories != undefined) {
                    eventType.name = event.categories;
                    eventType.color = this.eventTypeDataSource.find(t => t.text === event.categories) ? this.eventTypeDataSource.find(t => t.text === event.categories).backgroundColor : event.color;//event.color;
                }

                let reminders = [];
                if (event.reminders != undefined) {
                    reminders = event.reminders;
                }

                const data = {
                    Id: event.id,
                    CalendarId: calendarId,
                    filename: event.filename,
                    Subject: event.summary,
                    Location: event.location,
                    Description: event.description,
                    StartTime: start,
                    EndTime: end,
                    IsAllDay: event.IsAllDay,
                    Visibility: event.visibility,
                    RecurrenceRule: recurrenceRule,
                    ImageName: "icon-lefebvre-bl",
                    Attendees: attendees,
                    EventType: eventType,
                    Reminders: reminders,
                    LexonClassification: event.lexonActuation,
                    CompanySelected: event.companySelected,
                    IdCompanySelected: event.idCompanySelected,
                    IdEventAction: event.idEventAction,
                    IdEventLexon: event.idEventLexon,
                }

                let existingEventIndex = this.scheduleData.findIndex(x => x.Id === event.id);

                if (existingEventIndex === -1){
                    this.scheduleData.push(data);
                } else {
                    if (JSON.stringify(this.scheduleData[existingEventIndex]) !== JSON.stringify(data)) {
                        this.scheduleData[existingEventIndex] = data;
                    }
                }
            }
        }
        e.result = this.scheduleData;

        // Re-run conflict check if editor is open in iframe mode and events just loaded
        if (this.layoutIframe && this.pendingConflictCheck && this.editorElement) {
            console.log('🔄 [IFRAME MODE] Events loaded, re-running conflict check...');
            setTimeout(() => {
                this.pendingConflictCheck();
            }, 100);
        }
    }

    async createLexonAppointmentForEventCreated(event, eventData, calendar) {
        const eventGuid =
            typeof eventData?.Id === 'string'
                ? eventData.Id.split('/').pop()
                : eventData?.Guid;

        if (!eventGuid) {
            console.error('No se pudo obtener el GUID del evento para crear la cita en Lexon');
        }

        const { provider, bbdd, idCompany, lexonToken, userId } = this.props.lexon;
        const { idUser, idResponsable } = this.props.currentUser;

       eventData.Reminders = (event.reminders || []).map(e => ({method: 'email', trigger: (e.trigger)}));

        const appoiment = await createAppoinment(
            bbdd,
            idCompany,
            {
                idUser,
                provider
            },
            {
                ...eventData,
                StartTime: event.start,
                EndTime: event.end,
                Attendees: event.attendees || event.Attendees,
                Id: eventData.IdEventAction || undefined,
                Guid: eventGuid,
                calendar: calendar
            },
            idResponsable ?? null,
            lexonToken
        );
        const idEventAction = appoiment.result.data;
        event.x = [
            { key: 'X-ACTUATION', value: `` },
            { key: 'X-COMPANY', value: `` },
            { key: 'X-IDEVENTACTION', value: `${idEventAction}` },
            { key: 'X-IDCOMPANY', value: `` },
        ];
        this.selectedEvent = {
            ...eventData,
            calendar: { ...calendar },
            Reminders: event.reminders,
            Attendees: event.attendees || event.Attendees,
            IdEventAction: idEventAction
        };
        this.sendMessagePutUser(userId);
        return idEventAction;
    }


    sendMessagePutUser(user) {
        const { email, lexon, calendarsResult } = this.props;
        
        const eventId = (
            this.selectedEvent &&
            this.selectedEvent.Id &&
            typeof this.selectedEvent.Id === 'string') ? this.selectedEvent?.Id?.split("/")?.pop() : '';

        let sm = [];

        if(this.selectedEvent) {
            sm = [this.createLexonEvent({ ...this.selectedEvent, Guid: eventId, Id: eventId })];
        }

        if (this.state.showPromptImportContactsDialog || this.state.showPromptImportEventsV2Dialog) {
            sm = calendarsResult.calendars || [];
        }

        const filteredCalendars = calendarsResult?.calendars.filter(calendar => calendar && calendar.accessRole !== "reader" && calendar.accessRole !== "read" ) || [];
        const companySelected = this.selectedEvent ? this.selectedEvent.CompanySelected : undefined;
        const idCompanySelected = this.selectedEvent ? this.selectedEvent.IdCompanySelected : undefined;

        window.dispatchEvent(
            new CustomEvent('PutUserFromLexonConnector', {
                detail: {
                    entry: user,
                    idNavision: this.props.currentUser.idClienteLef,
                    selectedMessages: sm,
                    idCaseFile: lexon.idCaseFile,
                    bbdd: lexon.bbdd || companySelected,
                    idCompany: this.props.lexon.idCompany || idCompanySelected,
                    provider: lexon.provider,
                    account: email,
                    app: this.state.showPromptImportEventsV2Dialog
                        ? 'calendar:import-v2'
                        : this.state.showPromptImportContactsDialog ? 'calendar:import' : 'calendar',
                    env: window.currentUser ? window.currentUser.env : null,
                    idResponsable: this.props.lexon.idResponsable ?? this.props.currentUser.idResponsable ?? null,
                    userCalendars: filteredCalendars,
                    lexonToken: this.props.lexon.lexonToken,
                }
            })
        );
    }

    createLexonEvent(event) {
        if(this.props.calendarsResult.calendars.length > 0) {
            const calendar = this.props.calendarsResult.calendars.find(x => x.id === event.CalendarId);
            return {
                Id: event.Id,
                IdEventAction: event.IdEventAction ? event.IdEventAction : undefined,
                Subject: event.Subject,
                Location: event.Location,
                Description: event.Description,
                Guid: event.Id,
                CalendarId: calendar.id,
                StartTime: event.StartTime,
                RecurrenceRule: event.RecurrenceRule,
                Visibility: event.Visibility,
                EndTime: event.EndTime,
                calendar: {
                    id: calendar.id,
                    title: calendar.summary,
                    description: '',
                    color: calendar.backgroundColor,
                    fgColor: '#000000'
                },
                IsAllDay: event.IsAllDay,
                EventType: event.EventType && Object.keys(event.EventType).length > 0 ?
                {
                    eventTypeName: event.EventType.name,
                    eventTypeColor: event.EventType.color
                } : undefined,
                LexonClassification: event.LexonClassification,
                Attendees: event.Attendees,
                reminders: {
                    overrides: (
                        event.reminders) 
                            ? event.reminders.map(e => ({method: 'email', minutes: e.trigger || e.minutes})) 
                            : (event.Reminders) 
                                ? event.Reminders.map(e => ({method: 'email', minutes: e.trigger || e.minutes})) 
                                : null
                }
            };
        }
    }

    handleGetUserFromLexonConnector() {
        const { userId } = this.props.lexon;
        if (userId) {
            this.setState({ lexonEvent: true });
            this.sendMessagePutUser(userId);
        }
    }

    onSetSidebarOpenCalendar(open) {
        const {configCalendar, userId, account} = this.props.lexon;
        const shortProvider = (configCalendar && configCalendar.provider) ? configCalendar.provider.substring(0,2).toUpperCase() : null;
        if (shortProvider && shortProvider !== this.props.lexon.provider){
            const token = this.props.lexon.lexonToken ? this.props.lexon.lexonToken : this.props.lexon.token;
            if (this.props.lexon.lexonToken){
                switch (shortProvider) {
                    case "GO":
                        window.open(`${window.URL_MF_GOOGLE}/calendar/access/${token}/?prov=${shortProvider}0&email=${configCalendar.account}`, "_blank");
                        break;
                    case "OU":
                        window.open(`${window.URL_MF_OUTLOOK}/calendar/access/${token}/?prov=${shortProvider}0`, "_blank")
                        break;
                    default:
                        window.open(`calendar/access/${token}/?prov=${shortProvider}0&account=${base64.encode(account)}`)
                        break;
                }
            } else if (this.props.lexon.user) {
                switch (shortProvider) {
                    case "GO":
                        window.open(`${window.URL_MF_GOOGLE}/calendar/user/${shortProvider}0${userId}`, "_blank");
                        break;
                    case "OU":
                        window.open(`${window.URL_MF_OUTLOOK}/calendar/user/${shortProvider}0${userId}`, "_blank");
                        break;
                    default:
                        window.open(`calendar/user/${shortProvider}0${userId}`)
                        break;
                }
            } else {
                window.open("calendar", "_blank");
            }
        } else {
            this.setState({
                sidebarComponent: (
                    <CalendarComponent sidebarDocked={this.onSetSidebarDocked} />
                )
            });
            this.setState({ sidebarDocked: open }, () => {
                this.forceUpdate();
            });
        }
    }

    onSetSidebarOpenLexon(open) {
        this.setState({
            sidebarComponent: (
                <LexonComponent sidebarDocked={this.onSetSidebarDocked} />
            )
        });
        this.setState({ sidebarDocked: open }, () => {
            this.forceUpdate();
        });
    }

    onSetSidebarDocked(open) {
        this.setState({ sidebarDocked: open });
    }

    async componentDidMount() {
        const search = this.props.location.search;
        const appConnectCalendar = new URLSearchParams(search).get('appConnectCalendar');
        const appConnectEvent = new URLSearchParams(search).get('appConnectEvent');
        const appConnect = appConnectCalendar || appConnectEvent;
        const appConnectParse = (appConnect) && parseJwt(appConnect);
        
        if (appConnectParse && window !== window.top) {
            const newLexonUserId = getUserId(appConnectParse);
            const lastLexonUserId = localStorage.getItem(SESSION_USER_KEY);
            if (newLexonUserId) {
                if (lastLexonUserId && lastLexonUserId !== String(newLexonUserId)) {
                    // Cambio de cuenta de Lexon detectado: limpiar la sesion de correo
                    // de la cuenta anterior antes de mostrar el calendario de la nueva.
                    removeState();
                    localStorage.setItem(SESSION_USER_KEY, String(newLexonUserId));
                    window.location.reload();
                    return;
                }
                localStorage.setItem(SESSION_USER_KEY, String(newLexonUserId));
            }
        }

        await this.setGlobalization();
        this.setState({ globalizationReady: true });
        this.showResourcesDirective.current = true;
        this.props.setIsSearchTopBar(false);
        const IMAPCalendarsUserOptions = Cookies.get(`Lefebvre.IMAPCalendarsUserOptions`)
        if (!IMAPCalendarsUserOptions){
            // Validate scheduleObj and its properties before writing cookie
            const currentView = this.scheduleObj?.currentView || 'Month';
            const selectedDate = this.scheduleObj?.selectedDate instanceof Date && !isNaN(this.scheduleObj.selectedDate.getTime())
              ? this.scheduleObj.selectedDate.toISOString()
              : new Date().toISOString();
            const cookieData = `${this.props.lexon.account}|${currentView}|${selectedDate}`
            if (window.REACT_APP_ENVIRONMENT === 'QA'){
                Cookies.set(`Lefebvre.IMAPCalendarsUserOptions`, cookieData, {
                  domain: 'localhost',
                  expires: 365
                });  
              } else {
                Cookies.set(`Lefebvre.IMAPCalendarsUserOptions`, cookieData, {
                  domain: 'lefebvre.es',
                  sameSite: 'None',
                  secure: true,
                  expires: 365
                }); 
              }  
        }

        document.title = 'Lefebvre Calendar';

        window.addEventListener(
            "closeImportEventsDialog",
            this.handleCloseImportEvents
        );

        window.addEventListener(
            "handleBtnDisabledPrimary",
            this.handleBtnDisabledPrimary
        );

        // CalDAV connection error event listener (shows modal with retry button)
        window.addEventListener('caldav-connection-error', this.handleCaldavConnectionError);
        
        // CalDAV retry reload event listener (for test mode - reloads calendar data)
        window.addEventListener('caldav-retry-reload', this.handleCaldavRetryReload);

        // Listen for recurrence confirmation from search grid
        window.addEventListener('OpenRecurrenceConfirmationFromGrid', this.handleRecurrenceFromGrid);

        window.addEventListener('input', (evt) => {
            let btnSave = document.querySelector(".e-event-save");
            if (evt.target.id === "Subject" && btnSave) {
              if (evt.target.value !== '') {
                btnSave.disabled = false;
              } else {
                btnSave.disabled = true;
              }
            }
        });

        const {
            userId,
            idClientLef,
            lexonToken,
        } = this.props.lexon;

        const { account } = this.props.currentUser;
        let accountLexon = this.props.lexon.configCalendar?.account;

        const {
            user,
            password
        } = this.props.all.login.formValues;

        const { name } = this.props.currentUser;
        if (userId && !this.props.nextcloudUser) {
            let accountValues;
            if (!account && !accountLexon) {
                const { data } = await getDefaultAccount(userId, lexonToken);
                accountLexon = data.email
            }
            if (user === undefined){
                const url = `${window.API_GATEWAY_ACC}/api/v2/accounts/auth/usermail/${userId}/account/imap/${account || accountLexon}`;
                var myHeaders = new Headers();
                myHeaders.append("Authorization", "Bearer " + lexonToken);
                const response = await fetch(url, {
                    method: 'GET',
                    headers: myHeaders
                });
                const data = await response.json();

                if (data && data.data) {
                    const acData = data.data.configAccount;
                    accountValues = {
                        serverHost: acData.imap,
                        serverPort: acData.imapPort,
                        user: acData.imapUser,
                        password: acData.imapPass,
                        imapSsl: acData.imapSsl,
                        smtpHost: acData.smtp,
                        smtpPort: acData.smtpPort,
                        smtpSsl: acData.smtpSsl,
                        smtpTls: acData.smtpTls
                    }
                    this.props.setFormValues(accountValues);
                }

                await createCalendarUser(name, idClientLef, userId, accountValues.user.toLowerCase(), accountValues.password, lexonToken);
                await createPersonalCalendarUser(userId, accountValues.user.toLowerCase(), lexonToken)
            } else {
                await createCalendarUser(name, idClientLef, userId, user?.toLowerCase() || account, password, lexonToken);
                await createPersonalCalendarUser(userId, user?.toLowerCase() || account, lexonToken )
            }
            this.props.setNextcloudUser(true);
        }

        this.props.setService(null);

        window.addEventListener('resize', this.updateDimensions);

        window.addEventListener(
            'GetUserFromLexonConnector',
            this.handleGetUserFromLexonConnector
        );


        window.addEventListener(
            'EventClassified',
            this.handleClassificatedEvent
        );

        window.addEventListener(
            'RemoveSelectedEvent',
            this.handleClassificatedEventRemoved
        );
        window.addEventListener('ExportEvents', this.onExportEvents);
        this.sidebarCalendarList();
        this.setState({
            loading: true,
            loadCalendar: true
        });

        let openNewEventOnFullCalendar = false;
        try {
          openNewEventOnFullCalendar = localStorage.getItem(this.openNewEventFromIframeStorageKey) === "1";
        } catch {
          openNewEventOnFullCalendar = false;
        }
        this.setState({ appConnectData: appConnectParse, openNewEventOnFullCalendar });
    }

    componentDidUpdate(prevProps, prevState) {
        // Apply timeScale config when globalizationReady changes to true and scheduleObj is available
        if (!prevState.globalizationReady && this.state.globalizationReady && this.scheduleObj) {
            const imapConfigHoursCalendar = Cookies.get(`Lefebvre.ImapConfigHoursCalendar`);
            if (imapConfigHoursCalendar) {
                const configHoursSplit = imapConfigHoursCalendar.split('|');
                const newCalendarTimeScale = {
                    enable: true,
                    interval: parseInt(configHoursSplit[1], 10),
                    slotCount: parseInt(configHoursSplit[2], 10)
                };
                this.scheduleObj.timeScale = newCalendarTimeScale;
                this.props.setConfigHoursCalendar(newCalendarTimeScale);
            }
        }
        
        if(this.scheduleObj && !this.state.selectedDateUpdated) {
            const IMAPCalendarsUserOptions = Cookies.get(`Lefebvre.IMAPCalendarsUserOptions`)
            if (IMAPCalendarsUserOptions && IMAPCalendarsUserOptions.split('|')[0] === this.props.lexon.account){
              const cookieDate = IMAPCalendarsUserOptions.split('|')[2]
              // Validate date is not "undefined" string and creates a valid Date
              if (cookieDate && cookieDate !== 'undefined') {
                const parsedDate = new Date(cookieDate)
                if (!isNaN(parsedDate.getTime())) {
                  this.setState({selectedDateUpdated:true, selectedDate: parsedDate })
                  this.scheduleObj.selectedDate = parsedDate
                } else {
                  // If date is invalid, use current date
                  this.setState({selectedDateUpdated:true, selectedDate: new Date() })
                  this.scheduleObj.selectedDate = new Date()
                }
              } else {
                // If date is undefined, use current date
                this.setState({selectedDateUpdated:true, selectedDate: new Date() })
                this.scheduleObj.selectedDate = new Date()
              }
            }   
        }
      
        if(prevState.windowSize !== this.state.windowSize) {
            var closeConfig = document.querySelector('.e-profile-wrapper');
            if(closeConfig) {
                closeConfig.className = 'e-profile-wrapper e-lib e-popup e-control e-popup-close';
            }
        }      
        if (prevProps.calendarsResult.calendars !== this.props.calendarsResult.calendars) {
            this.scheduleData = [
                ...this.scheduleData,
                {
                    Id: 'ee4ef73a-d53a-d5d3-912c-9f54e83b7d58',
                    CalendarId: this.props.calendarsResult?.calendars[0]?.id,
                    Subject: "horas",
                    StartTime: "1985-02-14T12:00:00.000Z",
                    EndTime: "1985-02-14T14:00:00.000Z",
                    IsAllDay: false,
                    Attendees: [],
                    EventType: {},
                    Reminders: []
                }
            ];
        }

        if (prevProps.calendarsResult.calendars !== this.props.calendarsResult.calendars) {
            if (this.state.loadCalendar) {
                if (((this.layoutIframeNewEventView || this.layoutIframeEditEventView)
                && this.layoutIframe) === false) {
                    const calendarsResult = orderBy(this.props.calendarsResult.calendars, "checked");
                    let selected = calendarsResult.find(x => x.checked);
                    if (!selected) {
                        selected = calendarsResult[0];
                    }
                    this.loadCalendarEvents(selected?.id, true);
                } else if (this.layoutIframe && (this.layoutIframeNewEventView || this.layoutIframeEditEventView)) {
                    // Load events in iframe mode for conflict checking
                    const iframeCalendarId = this.props.lexon.idCalendar;
                    if (iframeCalendarId) {
                        this.loadCalendarEvents(iframeCalendarId, true);
                    } else {
                        const calendarsResult = orderBy(this.props.calendarsResult.calendars, "checked");
                        let selected = calendarsResult.find(x => x.checked);
                        if (!selected) {
                            selected = calendarsResult[0];
                        }
                        if (selected) {
                            this.loadCalendarEvents(selected?.id, true);
                        }
                    }
                }
                this.getlistEventTypes();
                this.setState({
                    loadCalendar: false,
                });
            }
        } else if (this.state.importingEvents){
            const calendarsResult = orderBy(this.props.calendarsResult.calendars, "checked");
            let selected = calendarsResult.find(x => x.checked);
            if (!selected) {
                selected = calendarsResult[0];
            }
            this.loadCalendarEvents(selected?.id, true);
            this.setState({
                importingEvents: false
            });
        }

        if (prevProps.calendarsResult.calendarError !== this.props.calendarsResult.calendarError &&
            this.props.calendarsResult.calendarError === 'Not Account') {
            this.props.clearErrorCalendars();
            this.setState({
                loading: false,
                showAlertUser: true,
            });
        }
    }

    updateDimensions = () => {
        this.setState({ windowSize: window.innerWidth });
    };

    /**
     * Handles recurrence confirmation when selecting a recurring event from the search grid
     * Receives pre-built scheduleEventData from EventsSearch.jsx
     */
    handleRecurrenceFromGrid = (event) => {
        const { scheduleEventData } = event.detail;

        // Set the event data and show the recurrence confirmation modal
        this.setState({ quickInfoEventData: scheduleEventData }, () => {
            setTimeout(() => {
                this.setState({ showRecurrenceConfirmation: true });
            }, 100);
        });
    }

    componentWillUnmount() {
        window.removeEventListener(
            'GetUserFromLexonConnector',
            this.handleGetUserFromLexonConnector
        );
        window.removeEventListener(
            'GetUserFromCentinelaConnector',
            this.handleGetUserFromCentinelaConnector
        );
        window.removeEventListener('EventClassified', this.handleClassificatedEvent);
        window.removeEventListener('RemoveSelectedEvent', this.handleClassificatedEventRemoved);
        window.removeEventListener('ExportEvents', this.onExportEvents);
        window.removeEventListener('handleBtnDisabledPrimary', this.handleBtnDisabledPrimary);
        window.removeEventListener('resize', this.updateDimensions);
        window.removeEventListener('closeImportEventsDialog',this.handleCloseImportEvents);
        // CalDAV connection error event listener cleanup
        window.removeEventListener('caldav-connection-error', this.handleCaldavConnectionError);
        window.removeEventListener('caldav-retry-reload', this.handleCaldavRetryReload);
        window.removeEventListener('OpenRecurrenceConfirmationFromGrid', this.handleRecurrenceFromGrid);
        this.props.setIsFilterDate(false);
        this.props.setIsSearchTopBar(false);
        this.props.setEventFilterKeyword('');
        if (!this.layoutIframeEditEventView) {
            this.props.resetIdActuation();
            this.props.resetIdEvent();
        }
        if (this.remObj.current && this.remObj.current.parentNode) {
            this.remObj.current.parentNode.removeChild(this.remObj.current);
        }
        if (this.tagObjHead.current && this.tagObjHead.current.parentNode) {
            this.tagObjHead.current.parentNode.removeChild(this.tagObjHead.current);
        }
        this.unmountAttendeePortal();
    }

    refreshEventTypeDropdownSafe() {
        const dropdown = this.drowDownListEventType;
        if (!dropdown || dropdown.isDestroyed) {
            return;
        }
        // Syncfusion can keep stale instances between popup cycles.
        // Skip refresh when the input is detached to avoid internal null destroy calls.
        if (!dropdown.inputElement || !dropdown.inputElement.isConnected) {
            return;
        }
        dropdown.dataSource = this.eventTypeDataSource;
        dropdown.refresh();
    }

    onDataBindingEventTypeList(items) {
        this.eventTypeDataSource = [];
        const safeItems = Array.isArray(items) ? items : [];
        const sortedItems = [...safeItems].sort((a, b) => {
            const left = (a?.name || '').toString();
            const right = (b?.name || '').toString();
            return left.localeCompare(right, 'es', { sensitivity: 'base' });
        });
        const mapFilterEventType = ["Sin tipo de evento","Otros tipos de eventos"]
        if (sortedItems.length > 0) {
            for (let i = 0; i < sortedItems.length; i++) {
                const evt = sortedItems[i];
                this.eventTypeDataSource.push({
                    text: evt.name,
                    id: evt.idEvent,
                    backgroundColor: evt.color
                });
                mapFilterEventType.push(evt.name)
            }
        }
        this.setState({filterEventType: mapFilterEventType})

        if (this.drowDownListEventType != undefined) {
            this.drowDownListEventType.dataSource = this.eventTypeDataSource;
        }
    }

    getlistEventTypes() {
        if (this.props.email) {
            getEventTypes(this.props.email, this.props.lexon.lexonToken)
                .then(result => {
                    const eventTypes = Array.isArray(result?.data?.eventTypes)
                        ? result.data.eventTypes
                        : [];

                    const eventTypeColorMode = result?.data?.eventTypeColorMode === EVENT_TYPE_COLOR_MODES.BACKGROUND
                        ? EVENT_TYPE_COLOR_MODES.BACKGROUND
                        : EVENT_TYPE_COLOR_MODES.DOT;
                    this.setState({ eventTypeColorMode });
                    this.onDataBindingEventTypeList(eventTypes);
                    // Update EventType colors in already-loaded scheduleData so the calendar
                    // reflects the new/deleted event type colors without a full reload
                    this.scheduleData.forEach(event => {
                        if (event.EventType && event.EventType.name) {
                            const updatedType = this.eventTypeDataSource.find(t => t.text === event.EventType.name);
                            if (updatedType) {
                                event.EventType.color = updatedType.backgroundColor;
                            } else {
                                // Event type was deleted — clear color so calendar color is used
                                event.EventType = {};
                            }
                        }
                    });
                    this.scheduleObj?.refreshEvents();
                })
                .catch(error => {
                    console.error('error ->', error);
                    this.onDataBindingEventTypeList([]);
                });
        }
    }

    loadCalendarList(DisableloadSchedule, eventTypeChanged = false) {
        this.loading = true;

        this.resourceCalendarData = [];
        const { user } = this.props.all.login.formValues;
        const { userId } = this.props.lexon;
        const { lexonToken } = this.props.lexon;
        calendarList(userId, user, lexonToken)
        .then(result => {
            this.resourceCalendarData = orderBy(result.items, "primary");
            const existChange = this.props.calendarsResult.calendars.filter(calendar => !result.items.some(item => item.backgroundColor === calendar.backgroundColor
                  && item.summary === calendar.summary
                  && item.description === calendar.description));
            if (this.props.calendarsResult.calendars.length !== result.items.length || existChange.length > 0 || eventTypeChanged) {
                this.resourceCalendarData.find(x => x.id === this.resourceCalendarData[0].id).checked = true;
                if (!DisableloadSchedule) {
                    this.loadCalendarEvents(this.resourceCalendarData[0].id, true);
                    this.scheduleObj.refresh();
                }
            }
            this.loading = false;
        })
        .catch(error => {
            this.loading = false;
            console.error('error ->', error);
        });
    }

    createGuid() {
        function _p8(s) {
            const p = (`${Math.random().toString(16)}000000000`).substr(2, 8);
            return s ? `-${p.substr(0, 4)}-${p.substr(4, 4)}` : p;
        }
        return _p8() + _p8(true) + _p8(true) + _p8();
    }

    convertTZ(date, tzString) {
        return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: tzString }));
    }

    buildEventoCalDav(values, isNew = false, action = 'create') {
        //important to update event
        let filename = "";
        const saveType = isNew ? "new" : "update";

        if (typeof values.Id === 'string') {
            filename = values.Id.startsWith(values.CalendarId) ? values.Id : values.CalendarId + (values.Id.startsWith('/remote.php') ? values.Id.split('/').pop() : values.Id);
        } else {
            const guid = this.createGuid();
            filename = values.CalendarId + guid;
            values.Guid = guid;
            if (!values.Id) {
                values.Id = guid;
            }
        }
        //Event basic data
        this.newVar = {
            allDay: values.IsAllDay,
            summary: values.Subject,
            location: values.Location,
            description: values.Description,
            start: values.IsAllDay ? moment(values.StartTime).format('YYYYMMDD') : moment(values.StartTime).format('YYYY-MM-DD HH:mm'),
            end: values.IsAllDay ? moment(values.EndTime).format('YYYYMMDD') : moment(values.EndTime).format('YYYY-MM-DD HH:mm'),
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            filename: filename,
            saveType: saveType,
            visibility: values.Visibility ? 'private' : 'default'
        };
        const event = this.newVar;
        //event Type
        if (values.EventType != undefined && values.EventType != null && Object.keys(values.EventType).length > 0) {
            let item;
            if (values.EventType.name != undefined) {
                item = this.eventTypeDataSource.find(x => x.text == values.EventType.name);
            } else if (values.EventType.eventTypeName) {
                item = this.eventTypeDataSource.find(x => x.text == values.EventType.eventTypeName);
            } else {
                item = this.eventTypeDataSource.find(x => x.text == values.EventType);
            }
            event.color = item?.backgroundColor;
            event.categories = [{
                name: item?.text
            }];
        }

        //Recurrence
        if (values.RecurrenceRule != undefined) {
           const recurrenceEvent = this.getRecurrenceEvent(values.RecurrenceRule);
           event.repeating = recurrenceEvent;
        }

        //Atendees
        let arrTo2 = this.state.to2;
        let arrTo =
        this.state.to !== "" && this.state.to != undefined
            ? this.state.to?.split(",")
            : [];
        let arr = arrTo2.length > arrTo.length ? arrTo2 : arrTo;
        let ateendeeObj = [];
        if (arr.length > 0) {
            Object.keys(arr).forEach(key => {
                ateendeeObj.push({
                    name: arr[key],
                    email: arr[key],
                    mailto: arr[key],
                    type: 'individual'
                });
            });
        }

        if (
            values.Attendees &&
            values.Attendees.length > 0 &&
            ateendeeObj.length === 0 && 
            action === 'classify') {
            ateendeeObj = values.Attendees;
        }

        const organizerData = {
            name: (this.props.lexon.name) ? this.props.lexon.name : this.props.currentUser.name,
            email: this.props.email,
            mailto: this.props.email //to override email
        };

        event.organizer = organizerData;
        event.attendees = ateendeeObj;

        const cat = (values.LexonClassification || this.currentClassification);

        if (cat || (values.IdEventAction || this.currentIdEventAction)) {
            const companySelected = values.CompanySelected || this.currentCompany || '';
            const idCompanySelected = values.IdCompanySelected || this.currentIdCompany || '';
            const idEventAction = values.IdEventAction || this.currentIdEventAction || '';
            event.x = [
                { key: 'X-ACTUATION', value: `${cat}` },
                { key: 'X-COMPANY', value: `${companySelected}` },
                { key: 'X-IDEVENTACTION', value: `${idEventAction}` },
                { key: 'X-IDCOMPANY', value: `${idCompanySelected}` },
            ];
        }

        event.organizer = organizerData;

        if (this.remObj.current && this.remObj.current.listviewInstance) {
            const arrR = this.remObj.current.listviewInstance.dataSource;
            if (arrR.length > 0) {
                event.reminders = [];
                Object.keys(arrR).forEach(key => {
                    event.reminders.push({
                        type: 'display',
                        trigger: arrR[key].minutesvalue
                    });
                });
            }
        }

        if (values.reminders?.overrides &&
            values.reminders?.overrides.length > 0 &&
            action === 'classify') {
            const overrides = values.reminders.overrides;
            event.reminders = overrides.map(override => ({
                type: 'display',
                trigger: override.minutes
            }));

        }

        return event;
    }

    getRecurrenceEvent(recurrenceRule) {
        const valueList = recurrenceRule.split(';');
        let freqValue = null;
        let intervalValue = null;
        let untilValue = null;
        let byDayValue = null;
        let bySetPosValue = null;
        let byMonthValue = null;
        let byMonthDayValue = null;
        let countValue = null;
        valueList.forEach(value => {
             if (value.split('=')[0] === 'FREQ') {
                 freqValue = value.split('=')[1];
             } else if (value.split('=')[0] === 'INTERVAL') {
                 intervalValue = value.split('=')[1];
             } else if (value.split('=')[0] === 'BYDAY') {
                const days = value.split('=')[1];
                byDayValue = days.includes(',') ? days.split(','): days;
             } else if (value.split('=')[0] === 'BYSETPOS') {
                 bySetPosValue = value.split('=')[1];
             } else if (value.split('=')[0] === 'BYMONTH') {
                 byMonthValue = value.split('=')[1];
             } else if (value.split('=')[0] === 'BYMONTHDAY') {
                 byMonthDayValue = value.split('=')[1];
             } else if (value.split('=')[0] === 'UNTIL') {
                 untilValue = value.split('=')[1];
             } else if (value.split('=')[0] === 'COUNT') {
                 countValue = value.split('=')[1];
             }
        });
        const repeating = {
             freq: freqValue,
             count: countValue,
             interval: intervalValue,
             byDay: byDayValue,
             byMonth: parseInt(byMonthValue),
             byMonthDay: parseInt(byMonthDayValue),
             bySetPos: parseInt(bySetPosValue),
             wkst:  'SU'// Start the week on Sunday, default is Monday
         };
         if (untilValue) {
            repeating.until = moment(untilValue);
         }

        return repeating;
    }

    onEventDragStart() {}

    onEventDragStop() {}

    onEventClick(args) {
        if (this.selectedEventElement) {
            setEventSelected(this.selectedEventElement, false);
        }
        const element = this.scheduleObj.currentView === 'Agenda' ? args.element.parentNode : args.element;
        this.selectedEventElement = element;
        setEventSelected(element, true);
    }

    tabContent() {
       const container = document.createElement('div');
        container.id = 'lexon-app-tab';
        return container;
    }

    selectingTab(args) {
        this.setState({tabChanged:true})

        const formElement = this.scheduleObj.eventWindow.element.querySelector('.e-schedule-form');
        const validator = (formElement).ej2_instances[0];
        validator.validate();
        let btnSave = document.querySelector(".e-event-save");
        let btnCancel = document.querySelector(".e-event-cancel");
        let btnDelete = document.querySelector(".e-event-delete");
        if (validator.errorRules.length <= 0) {
            this.cancel = false;
            if (args.selectedIndex === 0 && args.selectingIndex === 1) {
                setTimeout(() => {
                    const container = document.getElementById('lexon-app-tab');
                    this.lexonAppRoot = createRoot(container);
                    this.lexonAppRoot.render(<LexonComponentCalendar type="calendarEvents" />);
                }, 0);
                const subjectElement = document.getElementsByClassName('e-subject')[0];
                if (this.selectedEvent && (!this.selectedEvent.Subject) || (this.selectedEvent.Subject === '')) {
                    this.selectedEvent.Subject = subjectElement ? subjectElement.textContent : '';
                }
                // Hide buttons
                const buttons = document.getElementsByClassName("e-footer-content");
                if (buttons) {
                    btnSave.hidden = true;
                    btnDelete.hidden = true;
                    btnSave.innerText = i18n.t('general.save');
                    btnCancel.innerText = i18n.t('general.close');
                    for (let i = 0; i < buttons.length; i++) {
                        buttons[i].style.visibility = 'visible';
                    }
                }
            } else if (args.selectedIndex === 1 && args.selectingIndex === 0) {
                // Show buttons
                window.dispatchEvent(new CustomEvent('handleBtnCancelHidden', {
                    detail: { 
                    disabledBtnCancel: true,
                }}));
                btnSave.hidden = false;
                btnCancel.hidden = false;
                btnDelete.hidden = false;
                const buttons = document.getElementsByClassName("e-footer-content");
                if (buttons) {
                    btnSave.disabled = false;
                    btnDelete.disabled = false;
                    btnCancel.disabled = false;
                    btnCancel.innerText = i18n.t('general.cancel');
                    if (!this.state.isEdit) {
                      btnSave.disabled = false;
                      btnDelete.disabled = true;
                      btnCancel.innerText = i18n.t('general.cancel');
                      btnSave.innerText = i18n.t('general.save');
                    }

                    for (let i = 0; i < buttons.length; i++) {
                        buttons[i].style.visibility = 'visible';
                    }
                }
            }
            if (this.tabObj.selectingID === '1' && this.scheduleObj.eventWindow.eventData.Id === undefined) {
                this.isLexonTabAutoSave = true;
                this.scheduleObj.addEvent(this.scheduleObj.eventWindow.getEventDataFromEditor().eventData);
                this.scheduleObj.eventWindow.eventData.typeEvent = "lexon";
            } else if(this.tabObj.selectingID === '1' && this.scheduleObj.eventWindow.eventData.Id !== undefined) {
                this.isLexonTabAutoSave = true;
                let Data = {
                    Id: this.scheduleObj.eventWindow.eventData.Id,
                    ...this.scheduleObj.eventWindow.getEventDataFromEditor().eventData,
                };
                this.scheduleObj.saveEvent(Data);
            }
        } else {
            args.cancel = true;
        }
    }

    doubleOpen(args) {
        if (this.layoutIframe) {
            args.cancel = true;
            const lexon = this.props.lexon.lexonToken ? this.props.lexon.lexonToken : this.props.lexon.user;
            if (this.state.appConnectData) {
                window.open(`access/${lexon}/?prov=GO0`, "_blank");
                return;
              }
            if (this.props.lexon.lexonToken) {
                window.open(`calendar/access/${lexon}/?prov=IM0`, "_blank");
            } else if (this.props.lexon.user) {
                window.open(`calendar/user/${lexon}`, "_blank");
            } else {
                window.open("calendar", "_blank");
            }
        } else if(this.scheduleObj.currentView === 'Month') {
            const timeDate = new Date();
            const startTime = args.startTime;
            const endTimeDate = args.endTime;

            startTime.setHours(timeDate.getHours());
            startTime.setMinutes(timeDate.getMinutes());

            endTimeDate.setHours(timeDate.getHours());
            endTimeDate.setMinutes(timeDate.getMinutes() + INTERVAL_IN_MINUTES);

            const cellData = {
                subject: this.props.lexon.title ? this.props.lexon.title : null,
                startTime: startTime,
                endTime: args.isAllDay ? moment(endTimeDate).subtract(1, "days") : endTimeDate,
                isAllDay: false
            };
        
            this.scheduleObj.openEditor(cellData, 'Add');
        }
    }

    onResizeStop(){
       this.setState({isResized: true})
    }

    normalizeReminderState(reminders = []) {
        return reminders.map((reminder) => {
            const minutes = Number(reminder?.minutes ?? reminder?.trigger ?? reminder?.minutesvalue ?? reminder?.value ?? 0);
            const parsedMinutes = Number.isFinite(minutes) ? minutes : 0;

            return {
                title: reminder?.method || reminder?.title || 'email',
                value: parsedMinutes,
                minutesvalue: parsedMinutes,
                id: reminder?.id || 'n',
                icon: reminder?.icon || 'delete-icon'
            };
        });
    }

    syncReminderList(reminders = []) {
        const listviewInstance = this.remObj?.current?.listviewInstance;

        if (!listviewInstance) {
            return;
        }

        const normalizedReminders = this.normalizeReminderState(reminders);
        listviewInstance.dataSource = normalizedReminders;
        listviewInstance.dataBind();
    }

    async onPopupOpen(args) {
      // HARDENING: red de seguridad. Cualquier excepción inesperada durante el montaje del popup
      // se captura para que el editor NUNCA deje el iframe en blanco (peor caso: popup degradado, no blanco).
      try {
        args.duration = INTERVAL_IN_MINUTES;

        if (args.type && args.type === "ValidationAlert"){
            const dlgContainers = document.querySelectorAll('.e-dlg-container'); 
            for (let i = 0; i < dlgContainers.length; i++) {
                if(dlgContainers[i].querySelector('#scheduleQuickDialog')){
                    dlgContainers[i].style.display = "none";
                    this.setState({ validationAlert: dlgContainers[i] })
                    args.cancel = true;
                }
            }
        }

        if (args.type && args.type === "QuickInfo"){
            this.setState({isPopUpOpen: true});
        }

        // TO DO: Move events from calendar (See Gmail Client)
        if (args.data.Id !== undefined) {
            this.setState({ originalEventCalendarId: args.data.CalendarId });
          } else {
            this.setState({ originalEventCalendarId: "" });
          }

        const { t } = this.props;
        if (window != window.top) {
            const appUrl = this.state.appConnectData ? this.state.appConnectData?.appConnectUrl : window.URL_LEXON;
            const DateMessage = args.data.startTime;
            window.top.postMessage(
                JSON.stringify({
                    idEvent: args.data.Id,
                    actionCancelled: false,
                    selectedDate: DateMessage,
                    message: '',
                    isAuth: false,
                }),
                appUrl
            );
        }

        // default values for EventType coming from event args
        if (args.data.EventType != undefined && args.data.EventType?.color != undefined) {
           this.setState({ eventType: args.data.EventType.name });
           if (this.drowDownListEventType != undefined) {
               this.drowDownListEventType.value = args.data.EventType.name;
           }
        } else {
           this.setState({ eventType: undefined });
            if (this.drowDownListEventType != undefined &&
                !this.drowDownListEventType.isDestroyed) {
                this.drowDownListEventType.value = undefined;
                this.drowDownListEventType.text = '';
                this.drowDownListEventType.index = -1;
                this.refreshEventTypeDropdownSafe();
            }
        }

        // default values for Atendees coming from event args
        if (args.data.Attendees != undefined) {
            const arr = [];
            Object.keys(args.data.Attendees).forEach(key => {
                arr.push(args.data.Attendees[key].email);
            });
            this.setState({ to2: arr });
        } else {
            this.setState({ to2: [], to: "" });
        }

        // default values for Visibility coming from event args
        if (args.data.Visibility != undefined) {
           const isVisibility = args.data.Visibility === 'PRIVATE' || args.data.Visibility === true ? true : false;
           this.setState({ isVisibility: isVisibility });
           if (this.drowDownListVisibility != undefined) {
               this.drowDownListVisibility.checked = isVisibility;
           }
        } else {
           this.setState({ isVisibility: false });
           if (this.drowDownListVisibility != undefined) {
               this.drowDownListVisibility.checked = false;
           }
        }

        // default values for Reminders coming from event args
        if (args.data.Reminders !== undefined) {
           const reminderList = Array.isArray(args.data.Reminders) ? args.data.Reminders : [];
           const arr = this.normalizeReminderState(reminderList);
           this.setState({ reminders: arr }, () => {
               this.syncReminderList(arr);
           });
        } else {
           this.setState({ reminders: [] }, () => {
               this.syncReminderList([]);
           });
        }

        if (args.type === 'RecurrenceAlert') {
            args.cancel = true;
            if (!this.layoutIframe) {
                this.scheduleObj.closeQuickInfoPopup();
                setTimeout(()=>{
                  this.setState({showRecurrenceConfirmation: true });
                },100);
            }
        }
      
        if (args.type === "DeleteAlert") {
            args.cancel = true;
        }

        if (args.type === 'QuickInfo') {
            const currentClassification = args.data.LexonClassification;
            const content = document.getElementsByClassName("e-popup-content");

            if (!args.data.Id) {
                const calendarObj = this.props.calendarsResult.calendars.find((x) => x.checked && x.id === this.checkedCalendar.current);
                if (calendarObj) {
                    args.data.CalendarId = calendarObj.id;
                }
            }

            if(currentClassification && content[0]) {
                const first = content[0].firstChild;
                const ndiv = this.createClassifiedDiv();
                content[0].insertBefore(ndiv, first);
            }

            const description = document.getElementsByClassName("e-description");
            if (
                args.data.Description !== null &&
                args.data.Description !== undefined &&
                args.data.Description.length > 120
            ) {
                // If description is too long the buttons to edit or erase the event aren't visible so we're limitting the desc preview to first 120 chars
                var nodeToChange = description[0].childNodes[1];
                if (nodeToChange !== null && nodeToChange !== undefined){
                    nodeToChange.textContent = `${nodeToChange.textContent.substring(
                        0,
                        120
                    )}...`;
                }
            }

            if (this.layoutIframe) {
                const buttonElementEdit = ".e-event-popup .e-edit";
                var removeButton = document.querySelector(buttonElementEdit);
                if (removeButton != undefined) {
                    removeButton.disabled = true;
                }

                if (args.data.Id === undefined) {
                    args.cancel = true;
                }
            }

            //Not allow to update events of not owner or writer calendar permissions
            const calendar = this.props.calendarsResult.calendars.find(x => x.id == args.data.CalendarId);
            if (!calendar) {
                return;
            }
            const calendarRole = calendar.accessRole ?? '';
            if (calendarRole === "read") {
                const buttonElementRemove = args.type === "QuickInfo" ? ".e-event-popup .e-delete" : ".e-schedule-dialog .e-event-delete";
                var removeButtonElement = document.querySelector(buttonElementRemove);
                if (removeButtonElement != undefined) {
                    removeButtonElement.disabled = true;
                }
            }
            var formElement = args.element.querySelector(".e-schedule-form");
            if (formElement != null) {
              var validator = formElement.ej2_instances[0];
              validator.addRules("Subject", {
                required: [true, i18n.t("schedule.validator-required")],
              });
              validator.addRules("StartTime", {
                required: [true, i18n.t("schedule.validator-required")],
              });
              validator.addRules("EndTime", {
                required: [true, i18n.t("schedule.validator-required")],
              });
              validator.addRules("Description", {
                maxLength: [3000, i18n.t('schedule.max_length_description')],
              });
            }

        }
        if (args.type === 'Editor') {
            this.setState({ isInvalidEmail: false });
            // HARDENING: si el diálogo aún no está montado (race de apertura del editor), usar args.element
            // como fallback y salir sin romper si tampoco existe — evita el crash que dejaba el iframe en blanco.
            const dlg = document.getElementById('schedule_dialog_wrapper') || args.element;
            if (!dlg) {
                // TELEMETRÍA: diálogo del editor no disponible al abrir (race extrema).
                console.warn('[IMAP-CAL] onPopupOpen(Editor): diálogo no disponible al abrir; se omite el setup para evitar iframe en blanco.');
                return;
            }
            let btn = dlg.getElementsByClassName('e-event-cancel');
            let btnSave = document.querySelector('.e-event-save');
            let deleteBtn = dlg.getElementsByClassName('e-event-delete');

            if (this.layoutIframe) {
                if (!this.layoutIframeEditEventView) {
                    if (!this.layoutIframeNewEventView) {
                        args.cancel = true;
                    }
                }
             }
             
            const datetimeWrapper = args.element.querySelectorAll('.e-datetime-wrapper'); 
            if(args.data && args.data.Id) {
                this.setState({isEdit: true, loading: false});
                if (btnSave) btnSave.innerText = i18n.t('general.save');
                if (deleteBtn[0]) deleteBtn[0].hidden = false;
            } else {
                this.setState({isEdit: false, loading: false});
                if (btnSave) btnSave.innerText = i18n.t('general.create');
                // Habilitar botón si hay título de lexon O si Subject ya tiene valor (ej: desde quickInfo)
                const hasTitle = this.props.lexon.title || (args.data && args.data.Subject);
                if (btnSave) btnSave.disabled = hasTitle ? false : true;
            }

            this.setState({ creatingEvent: true });
            // Reset flag since editor is now open
            this.isOpeningEditor = false;

            // Set the correct calendar in the dropdown for new events
            if (this.pendingCalendarIdForDropdown && !args.data.Id) {
                const calendarIdToSet = this.pendingCalendarIdForDropdown;
                setTimeout(() => {
                    const calendarDropdown = document.querySelector('#CalendarId');
                    if (calendarDropdown && calendarDropdown.ej2_instances && calendarDropdown.ej2_instances[0]) {
                        calendarDropdown.ej2_instances[0].value = calendarIdToSet;
                        calendarDropdown.ej2_instances[0].dataBind();
                    }
                }, 100);
                this.pendingCalendarIdForDropdown = null;
            }
            
            // Protect this.current* from being overwritten with undefined
            // when the same event is reopened after a refresh/refreshEvents call
            const isSameEvent = this._currentEditingEventId && args.data.Id && this._currentEditingEventId === args.data.Id;
            this._currentEditingEventId = args.data.Id;

            if (isSameEvent) {
                // Same event reopened after refresh - only overwrite if args.data has actual values
                this.currentClassification = args.data.LexonClassification ?? this.currentClassification;
                this.currentCompany = args.data.CompanySelected ?? this.currentCompany;
                this.currentIdCompany = args.data.IdCompanySelected ?? this.currentIdCompany;
                this.currentIdEventAction = args.data.IdEventAction ?? this.currentIdEventAction;
            } else {
                // Different event or new event - always set from args.data
                this.currentClassification = args.data.LexonClassification;
                this.currentCompany = args.data.CompanySelected;
                this.currentIdCompany = args.data.IdCompanySelected;
                this.currentIdEventAction = args.data.IdEventAction;
            }

            // If existing event has no classification in scheduler data, fetch from CalDAV
            // This handles stale scheduleData where X-properties were not loaded
            if (args.data.Id && !this.currentClassification) {
                const eventCalendarId = args.data.CalendarId;
                const eventGuid = args.data.Id.split("/").pop();
                getEventById(
                    this.props.lexon.userId,
                    this.props.all.login.formValues.user,
                    this.props.lexon.lexonToken,
                    eventCalendarId,
                    eventGuid
                ).then(result => {
                    const fetchedEvent = result?.result?.items?.[0];
                    if (fetchedEvent?.lexonActuation) {
                        this.currentClassification = fetchedEvent.lexonActuation;
                        this.currentCompany = fetchedEvent.companySelected;
                        this.currentIdCompany = fetchedEvent.idCompanySelected;
                        this.currentIdEventAction = fetchedEvent.idEventAction;
                        // Update stale scheduler data
                        const evt = this.scheduleObj?.dataModule.dataManager.dataSource.json.find(
                            e => e.Id === args.data.Id
                        );
                        if (evt) {
                            evt.LexonClassification = fetchedEvent.lexonActuation;
                            evt.CompanySelected = fetchedEvent.companySelected;
                            evt.IdCompanySelected = fetchedEvent.idCompanySelected;
                            evt.IdEventAction = fetchedEvent.idEventAction;
                        }
                        // Update selectedEvent for sendMessagePutUser
                        if (this.selectedEvent && this.selectedEvent.Id === args.data.Id) {
                            this.selectedEvent.LexonClassification = fetchedEvent.lexonActuation;
                            this.selectedEvent.CompanySelected = fetchedEvent.companySelected;
                            this.selectedEvent.IdCompanySelected = fetchedEvent.idCompanySelected;
                            this.selectedEvent.IdEventAction = fetchedEvent.idEventAction;
                        }
                    }
                }).catch(() => {
                    // Fetch failed - proceed without X-properties
                });
            }

            setTimeout(() => {
                const startTimeInput = args.element.querySelector('[name="StartTime"]');
                const endTimeInput = args.element.querySelector('[name="EndTime"]');
                const allDayCheckbox = args.element.querySelector('[name="IsAllDay"]');
            
                const checkConflicts = debounce(() => {
                    try {
                        const eventData = this.scheduleObj.eventWindow.getEventDataFromEditor().eventData;
                        const startTime = eventData.StartTime;
                        const endTime = eventData.EndTime;
                        const currentEventId = args.data?.Id;
                        const isAllDay = eventData.IsAllDay;
                    
                        if (startTime && endTime) {
                            const conflicts = this.checkEventConflict(startTime, endTime, currentEventId, isAllDay);
                        
                            if (conflicts.length > 0) {
                                this.setState({
                                    conflictWarning: i18n.t("schedule.event-conflict-description"),
                                    hasTimeConflict: true
                                }, () => {
                                    this.showConflictWarning(args.element);
                                });
                            } else {
                                this.setState({
                                    conflictWarning: null,
                                    hasTimeConflict: false
                                }, () => {
                                    this.hideConflictWarning(args.element);
                                });
                            }
                        }
                    } catch (error) {
                        console.error('❌ [ERROR] in checkConflicts:', error);
                    }
                }, 300);
            
                if (allDayCheckbox) {
                    allDayCheckbox.addEventListener('change', checkConflicts);
                }
                // Adjuntar listeners a los DateTimePicker de Syncfusion sin sobrescribir la lógica original
                if (startTimeInput && startTimeInput.ej2_instances && startTimeInput.ej2_instances[0]) {
                    const startTimePicker = startTimeInput.ej2_instances[0];
                    const originalStartChange = startTimePicker.change;
                    startTimePicker.change = function(args) {
                        if (typeof originalStartChange === 'function') {
                            originalStartChange.call(this, args);
                        }
                        checkConflicts(args);
                    };
                }
            
                if (endTimeInput && endTimeInput.ej2_instances && endTimeInput.ej2_instances[0]) {
                    const endTimePicker = endTimeInput.ej2_instances[0];
                    const originalEndChange = endTimePicker.change;
                    endTimePicker.change = function(args) {
                        if (typeof originalEndChange === 'function') {
                            originalEndChange.call(this, args);
                        }
                        checkConflicts(args);
                    };
                }
            
                // Store references for iframe mode - allows re-checking when events load
                this.pendingConflictCheck = checkConflicts;
                this.editorElement = args.element;
                setTimeout(() => {
                    checkConflicts();
                }, 100);
            }, 1000);

            setTimeout(() => {        
                if (btn && btn.length > 0) {
                    btn[0].onclick = this.clickCancel;
                }

                if (deleteBtn && deleteBtn.length > 0) {
                    deleteBtn[0].onclick = () => {
                      this.setState({showDeleteConfirmation: true });
                    };
                }
                if (btnSave) {
                    if (args.data && args.data.Id) {
                        btnSave.onclick = () => {
                            if(this.state.validationAlert) {
                                this.setState({
                                    showDateValidationAlert: true,
                                    validationAlert: null
                                });
                                return;
                            }
                            let data = {
                                Id: args.data.Id,
                                ...this.scheduleObj.eventWindow.getEventDataFromEditor().eventData,
                            };
                            this.scheduleObj.saveEvent(data);
                            this.scheduleObj.closeEditor();
                        };
                    } else {
                        btnSave.onclick = () => {
                            if(this.state.validationAlert) {
                                this.setState({
                                    showDateValidationAlert: true,
                                    validationAlert: null
                                });
                                return;
                            }
                            this.scheduleObj.closeEditor();
                        };
                    }
                  
                }
            }, 1000);

            if (this.layoutIframe && (this.layoutIframeNewEventView || this.layoutIframeEditEventView)) {
                const scheduleDialogWrapper = document.getElementById("schedule_dialog_wrapper");
                if (scheduleDialogWrapper) scheduleDialogWrapper.classList.add('schedule-dialog-wrapper-iframe');

                const head = document.getElementById("schedule_dialog_wrapper_dialog-header");
                if (head) head.classList.add('hidden');
            }

            const calendar = this.props.calendarsResult.calendars.find(
                (c) => c.id === args.data.CalendarId
            );

            this.selectedEvent = { ...args.data, calendar };

            
            if (deleteBtn[0]) deleteBtn[0].disabled = false;

            var editButtonSave = document.querySelector('.e-event-save');
            if (editButtonSave) editButtonSave.hidden = false;
            const calendarRole = this.props.calendarsResult.calendars.find(x => x.id == args.data.CalendarId)?.accessRole ?? '';
            if (calendarRole === "read") {
                if (deleteBtn[0]) deleteBtn[0].disabled = true;
                if (editButtonSave) editButtonSave.hidden = true;
            }

            if(args.data.RecurrenceRule){
                if (deleteBtn[0] != undefined) {
                    deleteBtn[0].innerText = i18n.t('schedule.delete-recurrence-text');
                }
            }else{
                if (deleteBtn[0] != undefined) {
                    deleteBtn[0].innerText = i18n.t('schedule.delete-event-text');
                }
            }
            const dialogObj = args.element.ej2_instances[0];
            if (dialogObj && dialogObj.buttons && dialogObj.buttons[1]) {
                dialogObj.buttons[1].buttonModel.isPrimary = false;
            }
            args.element.style.width = "900px";
            args.element.style.height = "800px";

            let formElement = args.element.querySelector('.e-schedule-form');
            if (formElement != null) {
                let validator = (formElement).ej2_instances[0];
                validator.addRules("Subject", {
                    required: [true, i18n.t("schedule.validator-required")],
                });
                validator.addRules("StartTime", {
                    required: [true, i18n.t("schedule.validator-required")],
                  });
                  validator.addRules("EndTime", {
                    required: [true, i18n.t("schedule.validator-required")],
                  });
                  validator.addRules("Description", {
                    maxLength: [3000, i18n.t('schedule.max_length_description')],
                  });
            }
            if(args.element.querySelector('#label_Subject')) {
                const label = args.element.querySelector("#label_Subject");
                const labelStartDate = args.element.querySelector("#label_StartTime");
                const labelEndDate = args.element.querySelector("#label_EndTime");
                const subjectInput = args.element.querySelector("#Subject");
                const LocationInput = args.element.querySelector("#Location");
                const descriptionInput = args.element.querySelector("#Description");
                const startDatePicker = args.element.querySelector("#StartTime")
                const endDatePicker = args.element.querySelector("#EndTime")
                subjectInput.placeholder = i18n.t('calendar.subject');
                LocationInput.placeholder = i18n.t('calendar.location');
                startDatePicker.placeholder = i18n.t('calendar.start_date_placeholder');
                endDatePicker.placeholder = i18n.t('calendar.end_date_placeholder');
                descriptionInput.placeholder = i18n.t('general.write_here_description_placeholder');

                const descriptionWrapper = descriptionInput.closest(".e-float-input") || descriptionInput.parentElement;
                let descriptionLength = args.element.querySelector(".description-length");
                if (!descriptionLength) {
                  descriptionLength = createElement("span", { className: "description-length" });
                  descriptionWrapper.insertAdjacentElement("afterend", descriptionLength);
                }
                const updateDescriptionLength = () => {
                  descriptionLength.textContent = `${descriptionInput.value.length}/3000`;
                };
                updateDescriptionLength();
                descriptionInput.oninput = updateDescriptionLength;

                const span = args.element.querySelector(".custom-span-required");
                if (!span) {
                  const contentSpan = createElement("span", {
                    className: "custom-span-required",
                  });
                  const contentSpan2 = createElement("span", {
                    className: "custom-span-required",
                  });
                  const contentSpan3 = createElement("span", {
                    className: "custom-span-required",
                  });
                  contentSpan.innerHTML = " *";
                  contentSpan2.innerHTML = " *";
                  contentSpan3.innerHTML = " *";
                  label.appendChild(contentSpan);
                  labelStartDate.appendChild(contentSpan2);
                  labelEndDate.appendChild(contentSpan3);
                }
            }
            // Create required custom elements in initial time
            if (!args.element.querySelector('.custom-field-row')) {
                let row = createElement("div", { className: "custom-field-row custom-field-row-twoItems" });
                let rowAttendes = createElement("div", {
                    className: "custom-field-row",
                  });
                  let rowReminders = createElement("div", {
                    className: "custom-field-row",
                  });
                  let rowRecurrence = createElement("div", {
                    className: "custom-field-row field-row-recurrence",
                  });
          
                  let rowVisibility = createElement("div", {
                    className: "custom-field-row",
                  });
          
                  let recurrenceLabel = createElement("span", {
                    className: "recurrent-label",
                  });
                  recurrenceLabel.textContent = "Recurrencia"

                  if (formElement && formElement.firstChild) {
                      formElement.firstChild.insertBefore(
                        rowAttendes,
                        formElement.firstChild.childNodes[1]
                      );
                      formElement.firstChild.insertBefore(
                        row,
                        formElement.firstChild.childNodes[6]
                      );
                      formElement.firstChild.insertBefore(
                        rowVisibility,
                        formElement.lastChild.lastChild
                      );
                      formElement.firstChild.insertBefore(
                        recurrenceLabel,
                        formElement.lastChild.lastChild
                      );
                      formElement.firstChild.insertBefore(
                        rowRecurrence,
                        formElement.lastChild.lastChild
                      );
                      formElement.firstChild.insertBefore(
                        rowReminders,
                        formElement.lastChild.lastChild
                      );
                  } else {
                      // TELEMETRÍA: punto exacto del crash original (.e-schedule-form sin firstChild al abrir).
                      // Con el fix de apertura única no debería verse; si aparece en los logs del cliente, el form
                      // se montó tarde en una sola apertura y el guard lo está protegiendo (campos custom omitidos).
                      console.warn('[IMAP-CAL] onPopupOpen: .e-schedule-form sin firstChild al abrir el editor; se omiten los campos custom (form aún no montado).');
                  }


                // Adding event type element
                let containerEventType = createElement('div', {className: 'custom-field-container container-event-type'});
                let labelEventType = createElement("label", {
                    className: "label-event-type",
                });
                labelEventType.innerText = i18n.t('schedule.eventtype');
                row.appendChild(document.getElementsByClassName("e-resources-row")[0]);
                row.appendChild(containerEventType);
                containerEventType.appendChild(labelEventType);
                rowRecurrence.appendChild(document.getElementsByClassName("e-recurrenceeditor")[0])

                const inputEle = createElement('input', {
                   className: 'e-field', attrs: { name: 'EventType' }
                });

                containerEventType.appendChild(inputEle);

                await this.sleep(10);

                if (inputEle) {
                    this.drowDownListEventType = new DropDownList({
                        cssClass: 'dropDownlist-eventtype',
                       itemTemplate: ITEM_EVENT_TEMPLATE,
                       dataSource: this.eventTypeDataSource,
                       value: this.state.eventType,
                       placeholder: i18n.t("schedule.eventtype"),
                       showClearButton: true,
                       htmlAttributes: { name: "EventType" },
                    });
                    this.drowDownListEventType.appendTo(inputEle);
                    inputEle.setAttribute('name', 'EventType');
                }

                // Adding visibility element
                let containerVisibility = createElement('div', { className: 'custom-field-container' });
                rowVisibility.appendChild(containerVisibility);
                let inputVisibility = createElement('input', {
                   className: 'e-field', attrs: { name: 'Visibility' }
                });
                containerVisibility.appendChild(inputVisibility);

                this.drowDownListVisibility = new CheckBoxComponent({
                   value: this.state.isVisibility,
                   label: i18n.t("schedule.visibility"),
                   checked: this.state.isVisibility
                });

                this.drowDownListVisibility.appendTo(inputVisibility);
                inputVisibility.setAttribute('name', 'Visibility');


                // Adding attendees2 tag element
                const containerTab2 = createElement(
                    'div', 
                    { 
                        className: 'custom-field-container',
                        id: 'attendee-portal-container'
                    }
                );

                const ddlWrapper = args.element.querySelectorAll(".e-ddl");
                const dateWrapper = args.element.querySelectorAll(".e-date-wrapper");
                const inputDivider = args.element.querySelector(".custom-span-divider-datetime");
                if (!inputDivider) {
                  const contentSpan = createElement("span", {
                    className: "custom-span-divider-datetime custom-span-divider",
                  });
                  const contentSpan2 = createElement("span", {
                    className: "custom-span-divider-datetime custom-span-divider",
                  });
                  const contentSpan3 = createElement("span", {
                    className: "custom-span-divider-ddl custom-span-divider",
                  });
                  const contentSpan4 = createElement("span", {
                    className: "custom-span-divider-ddl custom-span-divider",
                  });
                  const contentSpan5 = createElement("span", {
                    className: "custom-span-divider-ddl custom-span-divider",
                  });
                  const contentSpan6 = createElement("span", {
                    className: "custom-span-divider-ddl custom-span-divider",
                  });
                  const contentSpan7 = createElement("span", {
                    className: "custom-span-divider-ddl custom-span-divider",
                  });
                  const contentSpan8 = createElement("span", {
                    className: "custom-span-divider-ddl custom-span-divider",
                  });
                  const contentSpan9 = createElement("span", {
                    className: "custom-span-divider-ddl custom-span-divider",
                  });
                  const contentSpan10 = createElement("span", {
                    className: "custom-span-divider-ddl custom-span-divider",
                  });
                  const contentSpan11 = createElement("span", {
                    className: "custom-span-divider-ddl custom-span-divider",
                  });
                  const contentSpan12 = createElement("span", {
                    className: "custom-span-divider-ddl custom-span-divider",
                  });
                  datetimeWrapper[0].appendChild(contentSpan);
                  datetimeWrapper[1].appendChild(contentSpan2);
                  ddlWrapper[0].appendChild(contentSpan11);
                  ddlWrapper[1].appendChild(contentSpan12);
                  ddlWrapper[2].appendChild(contentSpan3);
                  ddlWrapper[3].appendChild(contentSpan4);
                  ddlWrapper[4].appendChild(contentSpan5);
                  ddlWrapper[8].appendChild(contentSpan6);
                  ddlWrapper[5].appendChild(contentSpan7);
                  ddlWrapper[6].appendChild(contentSpan8);
                  ddlWrapper[7].appendChild(contentSpan9);
                  dateWrapper[0].appendChild(contentSpan10);
                }
                rowAttendes.appendChild(containerTab2);
                this.renderAttendeePortal();
                // Adding reminder element
                const containerRem = createElement('div', { className: 'custom-field-container' });
                rowReminders.appendChild(containerRem);
                const nodeR = this.remObj.current;

                if (nodeR && nodeR.parentNode !== containerRem) {
                    containerRem.appendChild(nodeR);
                }

            }
             // field required container
             const fieldRequiredDiv = args.element.querySelector(".field-required-container");
             if (!fieldRequiredDiv) {
               let fieldRequiredContainer = createElement("div", {
                 className: "field-required-container",
               });
               const fieldRequiredSpan = createElement("span", {
                 className: "field-required-text",
               });
               const requiredSymboly = createElement("span", {
                 className: "field-required-symboly",
               });
               requiredSymboly.innerHTML = "*";
               fieldRequiredSpan.innerHTML = i18n.t('general.required_field');
               fieldRequiredContainer.insertBefore(requiredSymboly, fieldRequiredContainer.firstChild);
               fieldRequiredContainer.appendChild(fieldRequiredSpan);
               if (formElement) {
                   formElement.insertBefore(fieldRequiredContainer, formElement.firstChild);
               }
             }
            // if from iframe is requested a new event
            if (!this.layoutIframe) {
                const TabContainer = args.element.querySelector('.custom-tab-row');
                if (TabContainer === null) {
                    if (args.element.querySelector('.e-dlg-content')) {
                        const formContainer = args.element.querySelector('.e-schedule-form');
                        const Element = args.element.querySelector('.e-dlg-content');
                        const row = createElement('div', { className: 'custom-tab-row' });
                        if (Element && Element.firstChild) {
                            Element.firstChild.insertBefore(row, Element.firstChild.firstChild);
                        }
                        this.tabObj = new TabComponent({
                            items: [
                                { header: { text: 'Datos generales' }, content: formContainer },
                                { header: { text: 'Clasificar en LexON' }, content: this.tabContent() }
                            ],
                            selectedItem: 0,
                            selecting: this.selectingTab.bind(this)
                        });
                        this.tabObj.animation.previous = { duration: 100 };
                        this.tabObj.animation.next = { duration: 100 };
                        this.tabObj.animation.previous = { effect: 'FadeIn' };
                        this.tabObj.animation.next = { effect: 'FadeIn' };
                        this.tabObj.appendTo(row);
                    }
                } else {
                    this.tabObj.selectedItem = 0;
                    this.tabObj.refresh();
                }
                // Al mover .e-schedule-form al Tab, los ej2 TextBox pierden su valor vinculado.
                // Restaurar Subject y Location para eventos existentes tras appendTo/refresh del Tab.
                if (args.data.Id) {
                    setTimeout(() => {
                        const subjInput = args.element.querySelector("#Subject");
                        if (subjInput && !subjInput.value && args.data.Subject) {
                            subjInput.value = args.data.Subject;
                            if (subjInput.ej2_instances?.[0]) subjInput.ej2_instances[0].value = args.data.Subject;
                        }
                        const locInput = args.element.querySelector("#Location");
                        if (locInput && !locInput.value && args.data.Location) {
                            locInput.value = args.data.Location;
                            if (locInput.ej2_instances?.[0]) locInput.ej2_instances[0].value = args.data.Location;
                        }
                    }, 0);
                }
            }
        }
        this.setState({ quickInfoEventData: args.data }, () => {
            if (args.type === 'Editor') {
                this.renderAttendeePortal();
            }
        });
      } catch (e) {
          // HARDENING + TELEMETRÍA: ningún throw en onPopupOpen debe dejar el iframe en blanco.
          console.warn('[IMAP-CAL] onPopupOpen capturó una excepción inesperada; el popup se abre en modo seguro en vez de dejar el iframe en blanco.', e);
      }
    }

    onPopupClose(args) {
        if (args.type === 'Editor' && this.isLexonTabAutoSave) {
            this.isLexonTabAutoSave = false;
            if (this.layoutIframeEditEventView) {
                args.cancel = true;
                this.lexonTabAutoSaveDone = true;
                return;
            }
        }
        this.isOpeningEditor = false;
        this.currentClassification = null;
         // Clear conflict check references when editor closes
        this.pendingConflictCheck = null;
        this.editorElement = null;

        this.setState({isPopUpOpen: false });
        if (this.lexonAppRoot) {
            const lexonTab = document.getElementById('lexon-app-tab');
            if (lexonTab && lexonTab.parentNode) {
              lexonTab.parentNode.removeChild(lexonTab);
            }
        }
    
        switch (args.type) {
          case "QuickInfo":
            if (this.selectedEventElement) {
                setEventSelected(this.selectedEventElement, false);
                this.selectedEventElement = null;
            }
            if (
              args.data &&
              args.data.LexonClassification &&
              args.data.LexonClassification !== "" &&
              args.data.LexonClassification !== null &&
              args.data.LexonClassification !== undefined
            ) {
              let classification = args.data.LexonClassification;
              window.dispatchEvent(
                new CustomEvent("ResetClassification", {
                  detail: {
                    id: classification,
                  },
                })
              );
            }
            break;
          case "Editor":
            this.unmountAttendeePortal();
            this.setState({ to2: [], to: "", creatingEvent: false, lexonEvent: false });
            if (this.scheduleObj.currentAction === 'Delete' ||
                this.scheduleObj.currentAction === 'DeleteOccurrence' ||
                this.scheduleObj.currentAction === 'DeleteSeries' ||
                (this.scheduleObj.currentAction === undefined && !this.lexonTabAutoSaveDone)) {
                    args.cancel = true;
            }
            this.lexonTabAutoSaveDone = false;
            // Reset editing event tracker so next open treats it as a new event
            this._currentEditingEventId = undefined;
            if (window === window.top){ //4405 & Fix app being closed when creating events from LexOn
              this.props.resetIdActuation();
              this.props.resetIdEvent();
            }
            window.dispatchEvent(
              new CustomEvent("ResetClassification", { detail: { id: "" } })
            );
        }
      }

    createClassifiedDiv() {
        const ndiv = document.createElement('div');
        const span = document.createElement('span');
        const icon = document.createElement('span');
        icon.classList.add('lf-icon-lexon');
        span.textContent = 'Clasificado en Lexon';

        ndiv.classList.add('e-div-iconlef');
        ndiv.appendChild(icon);
        ndiv.appendChild(span);
        return ndiv;
    }

    addLogOutButton(args) {
        const scheduleElement = document.getElementById('schedule');
        if (args.requestType === 'toolBarItemRendered') {
            const logoutIconEle = scheduleElement.querySelector('.e-schedule-logout-icon');
            logoutIconEle.onclick = () => {
                this.setState({isIframeOptionsOpen: !this.state.isIframeOptionsOpen});
            };
            // Syncfusion destroys and recreates the toolbar button on every rebuild,
            // so the Popover must remount to re-resolve the new DOM node as its target
            // (reactstrap caches the target element and never refreshes it otherwise).
            this.setState((prevState) => ({ toolbarRenderKey: prevState.toolbarRenderKey + 1 }));
        }
        const logoutContentEle = createElement('div', {
            className: 'e-profile-wrapper'
        });

        scheduleElement.parentElement.appendChild(logoutContentEle);
    }

    handleLogout() {
        const { userId,lexonToken } = this.props.lexon;
        resetDefaultAccount(userId, lexonToken)
            .then(() => {
                removeState();
            })
            .then(() => {
                if (window != window.top && this.state.appConnectData) {
                    window.top.postMessage(
                        JSON.stringify({
                            isLogout: true
                        }),
                        this.state.appConnectData?.appConnectUrl
                    );
                }
                if (window != window.top) {
                    window.top.postMessage(
                      JSON.stringify({
                        idEvent: undefined,
                        actionCancelled: true,
                        selectedDate: undefined,
                        removed: false,
                        message: "logout",
                        isLogout: true,
                        isAuth: false
                      }),
                      window.URL_LEXON
                    );
                }
                this.props.logout();
                window.location.reload();
            })
            .catch(err => {
                console.error(err);
                this.props.logout();
            })
    }

    openCalendar() {
        const lexon = this.props.lexon.lexonToken ? this.props.lexon.lexonToken : this.props.lexon.user;
        if (this.props.lexon.lexonToken) {
          window.open(`calendar/access/${lexon}/?prov=IM0`, "_blank");
        } else if (this.props.lexon.user) {
          window.open(`calendar/user/${lexon}`, "_blank");
        } else {
          window.open("calendar", "_blank");
        }
    }

    addCalendarsButton(args) {
        const scheduleElement = document.getElementById('schedule');
        if (args.requestType === 'toolBarItemRendered') {
            const calendarIconEle = scheduleElement.querySelector('.e-schedule-calendar-icon');
            calendarIconEle.onclick = () => {
                this.toggleSideBar();
            };
        }
    }

    addConfigurationButton(args) {
        const scheduleElement = document.getElementById('schedule');
        const root = document.getElementById("root");
        if (args.requestType === 'toolBarItemRendered') {
            const userIconEle = scheduleElement.querySelector('.e-schedule-user-icon');
            userIconEle.onclick = () => {
                this.profilePopup.relateTo = userIconEle;
                this.profilePopup.dataBind();
                if (this.profilePopup.element.classList.contains('e-popup-close')) {
                    this.printCalendarformat();
                    this.profilePopup.show();
                } else {
                    this.profilePopup.hide();
                }
            };
            root.onclick = (event) => {
                const targetElement = event.target;
                if (!targetElement.classList.contains("icon-kebab-menu") && this.profilePopup.element.classList.contains("e-popup-open")) {
                  this.profilePopup.hide();
                }
            };
        }

        const profile = document.querySelector('.e-profile-wrapper');

        if(profile === null) {
            const userContentEle = createElement('div', {
                className: 'e-profile-wrapper'
            });

            scheduleElement.parentElement.appendChild(userContentEle);
            const userIconEle = scheduleElement.querySelector('.e-schedule-user-icon');
            const output = this.buttonEventTypeObj;
            this.profilePopup = new Popup(userContentEle, {
                content: output,
                relateTo: userIconEle,
                position: { X: 'left', Y: 'bottom' },
                collision: { X: 'flip', Y: 'flip' },
                targetType: 'relative',
                viewPortElement: scheduleElement,
                width: 'auto',
                height: 60
            });
            this.profilePopup.hide();
        }
    }

    async checkSharedCalendarPermissions(CalendarId) { 
        if (this.layoutIframeEditEventView || this.layoutIframeNewEventView) {
            try { 
                const permissions = await invitedUsers(
                    CalendarId,
                    this.props.lexon.userId,
                    this.props.all.login.formValues.user,
                    this.props.lexon.lexonToken
                );
                this.isSharedCalendarPendingClose = (permissions.responses[0].data.invite[0].user &&
                    permissions.responses[0].data.invite[0].user.length > 0) ? true : false;
            } catch (error) {
                console.error('Error checking calendar permissions:', error);
                this.isSharedCalendarPendingClose = false;
            }
        }
    }

    onDataBound() {
         if (!this.state.isDataBound) {
            if (this.state.openNewEventOnFullCalendar && !this.layoutIframe) {
                this.handleScheduleOpenNewEventEditor();
                try {
                    localStorage.removeItem(this.openNewEventFromIframeStorageKey);
                } catch {
                    // localStorage may be blocked by browser settings
                }
            }
        }
        // FIX: guard SÍNCRONO (this._editorOpenTriggered) además de this.state.isDataBound.
        // onDataBound se dispara varias veces seguidas (rebind por cada calendario); como setState
        // es asíncrono, el guard basado en state deja pasar varias llamadas y abre el editor 2-3 veces.
        // Esas aperturas solapadas provocan que popupOpen se ejecute mientras Syncfusion reconstruye
        // el form (firstChild null) → crash intermitente "insertBefore" en máquinas lentas.
        if (!this.state.isDataBound && !this._editorOpenTriggered) {
            // New event is called
            if (this.layoutIframeNewEventView && this.props.calendarsResult.calendars.length) {
                this._editorOpenTriggered = true;
                this.handleScheduleOpenNewEventEditor();
                this.setState({isDataBound: true});
            }

            // Edit event is called
            if (this.layoutIframeEditEventView && this.props.calendarsResult.calendars.length) {
                if (this.layoutIframe) {
                    this._editorOpenTriggered = true;
                    this.handleScheduleOpenEditEventEditor();
                    this.setState({isDataBound: true});
                } else {
                    if (this.scheduleData.length) {
                        this._editorOpenTriggered = true;
                        this.handleScheduleOpenEditEventEditor();
                        this.setState({isDataBound: true});
                    }
                }
            }
            this.setState({openNewEventOnFullCalendar: false});
        } else if (
            this._editorOpenTriggered && !this._dupOpenWarned &&
            this.props.calendarsResult?.calendars?.length &&
            (this.layoutIframeNewEventView || this.layoutIframeEditEventView)
        ) {
            // TELEMETRÍA: confirma que el guard síncrono evitó una reapertura solapada del editor
            // (causa raíz del crash intermitente "insertBefore"). Si esto NO aparece en los logs del
            // cliente al reproducir, la causa podría ser otra y habría que revisar.
            this._dupOpenWarned = true;
            console.warn('[IMAP-CAL] Reapertura del editor bloqueada por guard síncrono (race de aperturas solapadas evitada). idActuation:', this.props.lexon?.idActuation);
        }
        this.renderAgendaEmptyState();
    }

    eventRendered(args) {
        const calendar = this.props.calendarsResult.calendars.find((c) => c.id === args.data.CalendarId);
        const useEventType = this.state.eventTypeColorMode === EVENT_TYPE_COLOR_MODES.BACKGROUND && args.data.EventType?.color;
        const bgColor = useEventType ? args.data.EventType.color : calendar?.backgroundColor;
        applyEventColors(args.element, bgColor, calendar?.backgroundColor);
        
        if (args.data.RecurrenceRule) {
            const existEvent = this.tableEvents.current.some((x) => 
            moment(x.StartTime).format("YYYY-MM-DD") === moment(args.data.StartTime).format("YYYY-MM-DD") 
              && x.RecurrenceID === args.data.RecurrenceID);
            if (!existEvent) {
                this.tableEvents.current = [...this.tableEvents.current, {
                    ...args.data, 
                }];
            } 
          } else {
            const existEvent = this.tableEvents.current.some((x) => x.Id === args.data.Id);
            if (!existEvent) {
                this.tableEvents.current = [...this.tableEvents.current, {
                    ...args.data, 
                }];
            } 
        }
        if (!this.state.loadedEvent && !this.state.isDataBound) {
            const dateRange = document.querySelectorAll('.e-date-range');
            this.tableMonth.current = dateRange[0].innerText;
            // FIX PEC-6614: esta ruta también abre el editor y solo estaba protegida por state asíncrono
            // (loadedEvent/isDataBound), por lo que podía programar una segunda apertura solapada con la
            // de onDataBound. Se aplica el mismo guard SÍNCRONO (_editorOpenTriggered) que en onDataBound.
            // New event is called
            if (this.layoutIframeNewEventView && !this.layoutIframe && !this._editorOpenTriggered) {
               this._editorOpenTriggered = true;
               setTimeout(() => {
                this.handleScheduleOpenNewEventEditor();
               }, 800);
            }
            // // Edit event is called
            if (this.layoutIframeEditEventView && !this.layoutIframe && !this._editorOpenTriggered) {
                this._editorOpenTriggered = true;
                setTimeout(() => {
                    this.handleScheduleOpenEditEventEditor();
                }, 800);
            }
            this.setState({
                loadedEvent: true,
            });
        }
    };

    async onEventRendered(args) {
        // Validate scheduleObj and its properties before writing cookie
        const currentView = this.scheduleObj?.currentView || 'Month';
        const selectedDate = this.scheduleObj?.selectedDate instanceof Date && !isNaN(this.scheduleObj.selectedDate.getTime())
          ? this.scheduleObj.selectedDate.toISOString()
          : new Date().toISOString();
        const cookieData = `${this.props.lexon.account}|${currentView}|${selectedDate}`
        if (window.REACT_APP_ENVIRONMENT === 'QA'){
          Cookies.set(`Lefebvre.IMAPCalendarsUserOptions`, cookieData, {
            domain: 'localhost',
            expires: 365
          });  
        } else {
          Cookies.set(`Lefebvre.IMAPCalendarsUserOptions`, cookieData, {
            domain: 'lefebvre.es',
            sameSite: 'None',
            secure: true,
            expires: 365
          }); 
        }  

        if (args.requestType === 'eventRemoved' && args.data[0].occurrence !== undefined){
            args.requestType ='eventChanged' 
        }

        let event;
        switch (args.requestType) {
            case 'toolBarItemRendered':
                //if not iframe view
                if (!this.layoutIframe) {
                    this.addConfigurationButton(args);
                } else {
                    this.addLogOutButton(args);
                }
                this.addCalendarsButton(args);
                break;

            case "dateNavigate":
                this.setState({tableEvents: []});
                this.tableEvents.current = [];
                const dateRange = document.querySelectorAll('.e-date-range');
                this.tableMonth.current = dateRange[0].innerText;
                if (this.props.calendarsResult && this.props.calendarsResult.calendars &&  this.props.calendarsResult.calendars.length === 0){
                    break;
                }
        
                this.dateNavigate = true; // To control the eventChanged event that comes after.
        
                let calendars = groupBy(
                    this.props.calendarsResult.calendars,
                    "checked"
                );
                
                for (let index = 0; index < calendars.true.length; index++) {
                    const cal = calendars.true[index];
                    this.loadCalendarEvents(cal.id, true, 'dateNavigate');
                }
                this.scheduleObj.dataBind();

                break;

            case 'eventChanged':
                if (Array.isArray(args.data) && args.data.length > 0) {
                    args.data = args.data[0];
                }
                if (!args.data.CalendarId) {
                    break;
                }
                
                this.checkSharedCalendarPermissions(args.data.CalendarId);
                let idEvent;

                if (args.data[0] != undefined) {
                    idEvent = args.data[0].Id;
                    if (typeof args.data[0].Id !== 'string') {
                        args.data[0].Guid = this.localEvents[args.data[0].Id];
                    }
                } else {
                    if (this.state.isResized){
                        //Filtering data
                        this.scheduleData = this.scheduleData.filter(data => data.Id.includes('/remote.php'))
                        if(args.data.occurrence !== undefined){
                            args.data = args.data.occurrence
                        }
                        idEvent = args.data.filename
                        args.data.Id = idEvent
                    }else{
                        idEvent = args.data.Id;
                    }
                    
                    if (typeof args.data.Id !== 'string') {
                        args.data.Guid = this.localEvents[args.data.Id];
                    } else {
                        args.data.Guid = args.data.Id.split("/").pop();
                    }
                }

                var desc = this.scheduleObj.dataModule.dataManager.dataSource.json.find(e => e.Id === idEvent);

                if (desc) {
                    //reset reminders
                    desc.Reminders = [];

                    // Update Reminders
                    const arrR = this.remObj.current.listviewInstance.dataSource;
                    if (arrR.length > 0) {
                       Object.keys(arrR).forEach(key => {
                           desc.Reminders.push({
                               type: 'display',
                               trigger: arrR[key].value
                           });
                       });
                    }

                    //reset attendess
                    desc.Attendees = [];

                    //Update Attendess
                    const att = this.state.to2;
                    if (att != undefined) {
                        Object.keys(att).forEach(key => {
                            desc.Attendees.push({ email: att[key] });
                        });
                    }

                    var existentAttendees = [];
                    var addedAttendees = [];
                    var removedAttendees = [];
                    if (JSON.stringify(args.data.Attendees) !== JSON.stringify(this.state.to2)){
                        addedAttendees = this.state.to2.filter(x => !args.data.Attendees?.map(x => x.email).includes(x));
                        removedAttendees = args.data.Attendees?.filter(x => !this.state.to2.includes(x.email));
                        removedAttendees = (removedAttendees?.length > 0) ? removedAttendees.map(x => x.email) : [];
                    }
                    existentAttendees = this.state.to2.filter(x => args.data.Attendees?.map(x => x.email).includes(x));

                    //update eventType
                    //Convert dropdown eventType in eventtype object to paint into schedule event
                    if (desc.EventType != undefined && desc.EventType != null) {
                        let item;
                        item = this.eventTypeDataSource.find(x => x.text == desc.EventType)
                        // create EventType with structure
                        let eventType = {};
                        if (item != undefined) {
                            eventType.name = item.text;
                            eventType.id = item.id;
                            eventType.color = item.backgroundColor;
                            desc.EventType = eventType;
                            args.data.EventType = { ...eventType };
                        }

                        args.data.EventType = desc.EventType;
                    }
                      if (
                        this.currentClassification !== undefined &&
                        this.currentClassification !== null
                      ) {
                        desc.LexonClassification = this.currentClassification;
                        desc.CompanySelected = this.currentCompany;
                        desc.IdCompanySelected = this.currentIdCompany;
                        desc.IdEventAction = this.currentIdEventAction;
                      }
                }

                //Update the schedule datasource
                this.scheduleObj.dataModule.dataManager.update();

                if (
                    this.currentClassification !== undefined &&
                    this.currentClassification !== null
                ) {
                    args.data.LexonClassification = this.currentClassification;
                    args.data.CompanySelected = this.currentCompany;
                    args.data.IdCompanySelected = this.currentIdCompany;
                    args.data.IdEventAction = this.currentIdEventAction;
                }

                //update the Event to call the api
                const origianlId = args.data.Id;
                // args.data.Id = args.data.CalendarId + args.data.Guid;
                
                
                //let itemToModify = desc.CalendarId
                let calendarToModify = args.data.CalendarId;
                if (Array.isArray(args.data) && args.data[0].occurrence != undefined && !this.state.isResized && calendarToModify) { 
                    //call function to remvove event from serie
                    const eventParent = this.buildEventoCalDav(args.data[0].parent);
                    event = this.buildEventoCalDav(args.data[0].occurrence);
                    event.exdate = `VALUE=DATE:${event.end}`
                    event.start = eventParent.start
                    event.end = eventParent.end
                    this.updateCalendarEventCRUD(calendarToModify, itemToModify, event, false, notifications, args.data);
                    break;
                }

                event = this.buildEventoCalDav(args.data);

                const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                const invalidEmailExists = event.attendees.some(attendee => !emailRegex.test(attendee.email.trim()));
                if (invalidEmailExists) {
                  args.cancel = true;
                  return;
                }

                const itemToModify = args.data.Id;

                if (args.changedRecords[0] != undefined && !this.state.isResized) {
                    calendarToModify = args.changedRecords[0].CalendarId;
                    if (
                        this.currentClassification !== undefined &&
                        this.currentClassification !== null
                    ) {
                        args.changedRecords[0].LexonClassification = this.currentClassification;
                        args.changedRecords[0].CompanySelected = this.currentCompany;
                        args.changedRecords[0].IdCompanySelected = this.currentIdCompany;
                        args.changedRecords[0].IdEventAction = this.currentIdEventAction;
                    }
                    event = this.buildEventoCalDav(args.changedRecords[0]);
                    args.data = args.changedRecords[0]
                }
                //TO DO: Move event from calendar
                //call function to update event
                if (args.data.CalendarId && this.state.originalEventCalendarId !== args.data.CalendarId && 
                    this.state.originalEventCalendarId !=='')  {
                    this.setState({loading: true });
                    const newData = args.data[0] || args.data;
                    const originalData = { ...newData };
                    
                    
                    // if event is all day add one less day
                    delete args.data.Id;
                    event = this.buildEventoCalDav(newData);
                    // if the calendar is not checked remove from current view
                    if (!this.props.calendarsResult.calendars.find(x => x.id == newData.CalendarId).checked) {
                        delete this.scheduleObj.dataModule.dataManager.dataSource.json.splice(-1, 1);
                    }

                    if (newData.EventType != undefined && newData.EventType != null) {
                        let item;
                        item = this.eventTypeDataSource.find(x => x.text == newData.EventType);
                        // create EventType with structure
                        const eventType = {};
                        if (item != undefined) {
                            eventType.name = item.text;
                            eventType.id = item.id;
                            eventType.color = item.backgroundColor;
                            newData.EventType = { ...eventType };
                        }
                    }
                   
                    const calendar = this.props.calendarsResult.calendars.find(x => x.id === newData.CalendarId);
                    this.selectedEvent = { ...newData, calendar: { ...calendar }, reminders: event.reminders };
        
                    //Removing extended Properties 
                    const TempExtendedProperties = { ...event.x };
                    delete event.extendedProperties;
                        //Se elimina el evento original para evitar el bug de que no existan 2 eventos asociados a una misma clasificacion
                        //call function to delete event
                        let calendarFromRemove = this.state.originalEventCalendarId;
                        const { idClienteLef, idClienteNavision } = this.props.currentUser;
                        if (newData.LexonClassification && newData.LexonClassification !== 'null') {
                            removeAppoinment(newData.CompanySelected, newData.IdCompanySelected, newData.LexonClassification, idClienteNavision, idClienteLef, this.props.lexon.lexonToken);
                        }
                        //  call function to remvove event
                        this.deleteCalendarEventCRUDAsync(
                        calendarFromRemove,
                        origianlId,
                        true,
                        originalData
                        ).then(async() => {
                        addCalendarEvent(newData.CalendarId, event, this.props.lexon.userId, this.props.all.login.formValues.user, this.props.lexon.lexonToken, true)
                        .then(async result => {
                            setTimeout(() => {
                                this.setState({loading: false });
                                this.loadCalendarEvents(args.data.CalendarId, true);
                                this.loadCalendarEvents(this.state.originalEventCalendarId, true);
                              }, 800);
                            let generatedId = event.filename.split('/').pop()
                            this.selectedEvent = { ...newData, Id: generatedId, Guid: generatedId, calendar: { ...calendar }, reminders: event.reminders };
                            if (event.extendedProperties) { 
                            this.selectedEvent.EventType = {
                                ...event.extendedProperties.private,
                            };
                            }
                            // refresh event data
                            if (this.scheduleObj.eventWindow.eventData != undefined) {
                                this.scheduleObj.eventWindow.eventData.Subject = event.summary;
                                this.scheduleObj.eventWindow.eventData.Id = event.filename; 
                                this.scheduleObj.eventWindow.eventData.Guid = generatedId;

                            }
                            this.localEvents[newData.Id] = newData.Guid;
                            newData.Id = generatedId;
                            newData.Guid = generatedId;
                            newData.ImageName = "icon-lefebvre-bl";
                            newData.Attendees = event.attendees;
                            this.setState({ to2: [], to: "" });
                        
                            newData.Reminders = event.reminders;

                            if (event.attendees.length > 0) {
                                sendNotificationAttendees(
                                    this.props.lexon.lexonToken,
                                    this.props.lexon.userId,
                                    event, "createdEvent",
                                    [],
                                    result.payload
                                );
                            }
                        
                            if (!newData.RecurrenceRule) {
                                this.toastObj.show(getToast(newData).toast[9]);
                              } else {
                                this.toastObj.show(getToast(newData).toast[16]);
                            }
                        })
                        .catch((error) => {
                            setTimeout(() => {
                                this.setState({loading: false });  
                              }, 800);
                            if (error.result != undefined) {
                            if (error.result.error.errors[0] != undefined) {
                                if (
                                error.result.error.errors[0].reason == "requiredAccessLevel"
                                ) {
                                this.toastObj.show({
                                    content:
                                    "Necesitas tener acceso de escritura de este calendario",
                                    cssClass: "e-toast-danger",
                                    icon: "lf-icon lf-icon-close-round"
                                });
                                console.error("error ->", error);
                                if (this.scheduleObj) {
                                    delete this.scheduleObj.dataModule.dataManager.dataSource.json.splice(
                                        -1,
                                        1
                                    );
                                    this.scheduleObj.refreshEvents();
                                }
                                if (window != window.top) {
                                    this.clickCancel("Not Permission");
                                }
                                return;
                                }
                            } else {
                                this.toastObj.show(getToast().toast[10]);
                                if (window != window.top) {
                                this.clickCancel("");
                                }
                                console.error("error ->", error);
                            }
                            } else {
                            this.toastObj.show(getToast().toast[10]);
                            if (window != window.top) {
                                this.clickCancel("");
                            }
                            console.error("error ->", error);
                            }
                        }); 

                        //Adding lexon clasification
                        if (
                            TempExtendedProperties !== null &&
                            TempExtendedProperties[0]
                        ) {
                            this.classifyEventOnLexon(
                            newData,
                            TempExtendedProperties[0].value,
                            TempExtendedProperties[1].value
                            ).then(() => {
                                this.closeEventDialog();
                            }).catch((error) => {
                                console.error('Error on classifyEventOnLexon', error);
                                this.setState({showNotClassifiedEvent: true});
                            });
                        } else {
                            this.closeEventDialog();
                        }
                        }).catch(() => {
                            setTimeout(() => {
                                this.setState({loading: false });  
                            }, 800);
                        });
                    break;
                }

                var notifications = {existentAttendees: existentAttendees, addedAttendees: addedAttendees, removedAttendees: removedAttendees};

                if ((args.data.LexonClassification === '' || args.data.LexonClassification === undefined) &&
                    (args.data.IdEventAction || args.data.IdEventAction !== '')) {
                    var calendarData = this.props.calendarsResult.calendars.find(x => x.id === calendarToModify);
                    if (calendarData) {
                        var idEventAction = await this.createLexonAppointmentForEventCreated(
                            event,
                            args.data,
                            calendarData
                        );
                        if (idEventAction) {
                            args.data.IdEventAction = idEventAction;
                            this.currentIdEventAction = idEventAction;
                        }
                    }
                }

                //call function to update event
                this.updateCalendarEventCRUD(calendarToModify, itemToModify, event, false, notifications, args.data);
                if (this.state.isResized){
                    this.setState({isResized:false})
                }
                // create EventType with structure in update from iframe
                if (
                    args.data.EventType != undefined &&
                    args.data.EventType != null &&
                    window != window.top
                ) {
                    let item;
                    item = this.eventTypeDataSource.find(
                    (x) => x.text == args.data.EventType
                    );
                    let eventType = [];
                    if (item != undefined) {
                    eventType.name = item.text;
                    eventType.id = item.id;
                    eventType.color = item.backgroundColor;
                    args.data.EventType = eventType;
                    }
                }

                if(this.props.lexon.idActuation) {
                    this.classifyEventOnLexon(
                        {...args.data, ...desc}, 
                        this.props.lexon.idActuation
                    )
                    .then(() => {
                        this.closeEventDialog();
                    }).catch((error) => {
                        console.error('Error on classifyEventOnLexon', error);
                        this.setState({showNotClassifiedEvent: true});
                    });
                } else {
                   this.closeEventDialog();
                }

                break;

            case 'eventCreated': {
                if (this.scheduleObj.eventWindow.eventData?.Id) {
                    let Data = {
                        Id: this.scheduleObj.eventWindow.eventData.Id,
                        ...this.scheduleObj.eventWindow.getEventDataFromEditor().eventData,
                    };
                    this.scheduleObj.saveEvent(Data);
                    this.loadCalendarEvents(args.data[0].CalendarId, false);
                    this.loadCalendarEvents(args.data[0].CalendarId, true);
                    args.cancel = true;
                    break;
                }
                
                this.setState({loading: true });
                // if event is all day add one less day
                event = this.buildEventoCalDav(args.data[0], true);
                // if the calendar is not checked remove from current view
                if (!this.props.calendarsResult.calendars.find(x => x.id == args.data[0].CalendarId).checked) {
                    delete this.scheduleObj.dataModule.dataManager.dataSource.json.splice(-1, 1);
                }

                if (args.data[0].EventType != undefined && args.data[0].EventType != null) {
                    let item;
                    item = this.eventTypeDataSource.find(x => x.text == args.data[0].EventType);
                    // create EventType with structure
                    const eventType = {};
                    if (item != undefined) {
                        eventType.name = item.text;
                        eventType.id = item.id;
                        eventType.color = item.backgroundColor;
                        args.data[0].EventType = { ...eventType };
                    }
                }

                const calendar = this.props.calendarsResult.calendars.find(x => x.id === args.data[0].CalendarId);

                this.selectedEvent = { 
                    ...args.data[0],
                    calendar: { ...calendar },
                    Reminders: event.reminders,
                    Attendees: event.attendees 
                };

                if (event.reminders) {
                    args.data[0].Reminders = event.reminders.map(e => ({method: 'email', trigger: (e.trigger)}));
                }

                await this.createLexonAppointmentForEventCreated(event, args.data[0], calendar);

                addCalendarEvent(args.data[0].CalendarId, event, this.props.lexon.userId, this.props.all.login.formValues.user, this.props.lexon.lexonToken, true)
                    .then(async result => {
                        this.setState({
                            loading: false,
                            creatingEvent: false,
                            lexonEvent: false 
                        });
                        this.setState({tableEvents: []});
                        this.tableEvents.current = [];
                        // refresh event data
                        if (this.scheduleObj.eventWindow.eventData != undefined) {
                            this.scheduleObj.eventWindow.eventData.Subject = event.summary;
                            this.scheduleObj.eventWindow.eventData.Id = args.data[0].Id;
                        }
                        this.localEvents[args.data[0].Id] = args.data[0].Guid;
                        args.data[0].Id = event.filename;
                        args.data[0].ImageName = "icon-lefebvre-bl";
                        args.data[0].Attendees = event.attendees;
                        
                        if (!args.data[0].RecurrenceRule) {
                            this.toastObj.show(getToast(args.data[0]).toast[7]);
                        } else {
                            this.toastObj.show(getToast(args.data[0]).toast[17]);
                        }

                        this.loadCalendarEvents(args.data[0].CalendarId, false);
                        this.loadCalendarEvents(args.data[0].CalendarId, true);

                       this.checkSharedCalendarPermissions(args.data[0].CalendarId);

                        if (this.props.lexon.idActuation) {
                            this.classifyEventOnLexon(args.data[0], this.props.lexon.idActuation)
                            .then(() => {
                               this.closeEventDialog();
                            }).catch((error) => {
                                console.error('Error on classifyEventOnLexon', error);
                                this.setState({showNotClassifiedEvent: true});
                            });
                        } else {
                            this.closeEventDialog();
                        }
                        if (this.state.appConnectData) {
                            this.closeEventDialog();
                        }
                        if (event.attendees.length > 0){
                            sendNotificationAttendees(
                                this.props.lexon.lexonToken,
                                this.props.lexon.userId,
                                event, "createdEvent",
                                [],
                                result.payload
                            );
                        }
                        // Dispatch event to refresh search grid
                        window.dispatchEvent(new CustomEvent('RefreshEventSearchGrid'));
                    })
                    .catch(error => {
                         this.toastObj.show(getToast().toast[8]);
                         console.error('error ->', error);
                         if (window != window.top) {
                            this.clickCancel('Not Permission');
                        }
                    });

                break;
            }

            case 'eventRemoved':
                //call function to delete event
                let item = args.data[0].Id;
                let calendarFromRemove = args.data[0].CalendarId;
                if (args.data[0].occurrence != undefined) {
                    const d = new Date(args.data[0].occurrence.StartTime);
                    const dateString = `${moment(d).seconds(0).toISOString().split('.')[0]}Z`;
                    const ExcRecurenceDate = dateString.replace(/[:.-]/g, "");
                    item = `${args.data[0].parent.Id}_${ExcRecurenceDate}`;
                    calendarFromRemove = args.changedRecords[0].CalendarId;
                }
                //call function to remvove event
                this.deleteCalendarEventCRUD(item, false, args.data[0]);

                break;

            case "viewNavigate":
                this.setState({tableEvents: []});
                this.tableEvents.current = [];
                const dateViewNavigateRange = document.querySelectorAll('.e-date-range');
                this.tableMonth.current = dateViewNavigateRange[0].innerText;
                break;
        }

    }

    async classifyEventOnLexon(event, idActuation, bbddSeleted = "", idCompanySelected = "") {
        const { provider, bbdd, account, idCompany } = this.props.lexon;
        const { idUser } = this.props.currentUser;

        const calendar = this.props.calendarsResult.calendars.find(c => c.id === event.CalendarId);
        const st = moment(event.StartTime).format('YYYY-MM-DD HH:mm');
        const et = moment(event.EndTime).format('YYYY-MM-DD HH:mm');
        
        const lexonEvent = {
            ...event,
            Id: null,
            Guid: event.Id.split("/").pop(), 
            calendar, 
            StartTime: st, 
            EndTime: et, 
            Account: account
        };
        const sc = await createAppoinment(
            bbddSeleted === "" ? bbdd : bbddSeleted, 
            idCompanySelected === "" ? idCompany : idCompanySelected,
            { 
                idUser, 
                provider 
            }, 
            lexonEvent, 
            this.props.currentUser.idResponsable ?? null,
            this.props.lexon.lexonToken
        );
        if (idActuation !== 'null') {
            await addEventToActuation(
                bbddSeleted === "" ? bbdd : bbddSeleted, 
                idCompanySelected === "" ? idCompany : idCompanySelected,
                idUser, 
                sc.result.data, 
                idActuation,
                this.props.lexon.lexonToken
            );
        }
        

        // Clear idActuation
        this.props.resetIdActuation();
        event.LexonClassification = idActuation;
        event.CompanySelected = bbddSeleted === "" ? bbdd : bbddSeleted;
        event.IdCompanySelected = idCompanySelected === "" ? idCompany : idCompanySelected;
        event.IdEventAction = sc.result.data;
        await this.handleClassificatedEvent({detail: { ...event, Guid: event.Id }});
    }


    addCalendarEventCRUD(CalendarId, event, hiddeMessage) {
        addCalendarEvent(CalendarId, event, this.props.lexon.userId, this.props.all.login.formValues.user, this.props.lexon.lexonToken)
            .then(() => {
                if (!hiddeMessage) {
                    this.toastObj.show(getToast().toast[1]);
                }
            })
            .catch(error => {
                this.toastObj.show(getToast().toast[2]);
                console.error('error ->', error);
            });
    }

    async removeAppoinmentLexon(args, hiddeMessage, lexonToken) {
        const { idUser, idClienteLef, idClienteNavision } = this.props.currentUser;
        if (idUser) {
            const response = await removeAppoinmentByAppoitmentId(
                args.CompanySelected, 
                args.IdCompanySelected, 
                args.IdEventAction, 
                idClienteNavision, 
                idClienteLef,
                lexonToken
            );
            if (window != window.top && response && !hiddeMessage) {
                this.onCloseDeleteAlert();
            }
        }
    }

    deleteCalendarEventCRUD(item, hiddeMessage, args, isFromDeleteCalendarEventCRUDAsync = false) {
        const filename = item;
        const { userId, lexonToken, bbdd,  idCompany } = this.props.lexon;
        deleteCalendarEvent(filename, userId, this.props.all.login.formValues.user, lexonToken)
            .then(async() => {
                if (!this.state.appConnectData && args.LexonClassification) {
                    await this.removeAppoinmentLexon(args.occurrence || args, hiddeMessage, lexonToken);
                }
                // eliminar cita sin clasificación de Lexon si tiene IdEventAction asociado
                if (!this.state.appConnectData &&
                    (!args.LexonClassification && args.LexonClassification === '') &&
                    (args.IdEventAction && args.IdEventAction !== '')) {
                    const newCompany = { CompanySelected: bbdd, IdCompanySelected: idCompany };
                    await this.removeAppoinmentLexon(
                        { ...(args.occurrence || args), ...newCompany }, 
                        hiddeMessage,
                        lexonToken
                    );
                }

                if (args && args.Attendees && args.Attendees.length > 0){

                    const organizerData = {
                        name: (this.props.lexon.name) ? this.props.lexon.name : this.props.email,
                        email: this.props.email,
                        mailto: this.props.email //to override email
                    };

                    var attendeesObj = [];
                    args.Attendees.forEach(att => {
                        attendeesObj.push({name: att.email, email: att.email});
                    })

                    const event = {
                        organizer: organizerData,
                        attendees: attendeesObj,
                        summary: args.Subject,
                        description: args.Description,
                        allDay: args.IsAllDay,
                        start: args.IsAllDay ? moment(args.StartTime).add(1, 'days').format('YYYYMMDD') : moment(args.StartTime).format('YYYY-MM-DD HH:mm'),
                        end: args.IsAllDay ? moment(args.EndTime).add(1, 'days').format('YYYYMMDD') : moment(args.EndTime).format('YYYY-MM-DD HH:mm'),
                        location: args.Location
                    }

                    sendNotificationAttendees(
                        this.props.lexon.lexonToken,
                        this.props.lexon.userId,
                        event,
                        "removedEvent"
                    );
                }

                if (!hiddeMessage) {
                    if (!args.RecurrenceRule) {
                        this.toastObj.show(getToast(args).toast[11]);
                      } else {
                        this.toastObj.show(getToast(args).toast[15]);
                    }
                }

                // Remover el evento de scheduleData por filename
                this.scheduleData = this.scheduleData?.filter(event => event.Id !== filename);

                // Refrescar los eventos en el calendario
                if (this.scheduleObj) {
                    this.scheduleObj.eventSettings.dataSource = [...this.scheduleData];
                    this.scheduleObj.refreshEvents();
                }

                if (!isFromDeleteCalendarEventCRUDAsync) {
                    if (window != window.top) {
                        this.onCloseDialog(true);
                    }
                }
                
            })
            .catch(error => {
                this.toastObj.show(getToast(this.scheduleObj?.activeEventData?.event).toast[12]);
                console.error('error ->', error);
            });
    }

    async deleteCalendarEventCRUDAsync(
        calendarFromRemove,
        origianlId,
        hiddeMessage,
        originalData
      ) {
        //  call function to remvove event
        this.deleteCalendarEventCRUD(
          origianlId,
          hiddeMessage,
          originalData,
          true
        );
        return await this.sleep(1500);
      }

    updateCalendarEventCRUD(calendarId, item, event, hiddeMessage, notifications = undefined, args) {
        const parts = item.split("/");
        const guid = parts[parts.length - 1];
        this.selectedEvent = { ...this.selectedEvent, Attendees: event.attendees };
        if(event && event.x && event.x[0] && event.x[0].key && event.x[0].value !== '' && window === window.top) {
            this.updateAppoinmentLexon(calendarId, guid, event);
        }
        addCalendarEvent(calendarId, event, this.props.lexon.userId, this.props.all.login.formValues.user, this.props.lexon.lexonToken, true)
            .then(result => {
                this.loadCalendarEvents(calendarId, false);
                this.loadCalendarEvents(calendarId, true);
                if (notifications && notifications.addedAttendees && notifications.addedAttendees.length > 0){
                    sendNotificationAttendees(
                        this.props.lexon.lexonToken, 
                        this.props.lexon.userId,
                        event,
                        "updatedEvent:attendeeAdded",
                        notifications.addedAttendees,
                        result.payload
                    );
                }
                if (notifications && notifications.removedAttendees && notifications.removedAttendees.length > 0){
                    sendNotificationAttendees(
                        this.props.lexon.lexonToken,
                        this.props.lexon.userId,
                        event,
                        "updatedEvent:attendeeRemoved",
                        notifications.removedAttendees,
                        result.payload
                    );
                }
                if (notifications && notifications.existentAttendees && notifications.existentAttendees.length > 0){
                    sendNotificationAttendees(
                        this.props.lexon.lexonToken, 
                        this.props.lexon.userId,
                        event,
                        "updatedEvent",
                        notifications.existentAttendees,
                        result.payload
                    );
                }
                if (!hiddeMessage) {
                    if (!args.RecurrenceRule) {
                        this.toastObj.show(getToast(args).toast[9]);
                      } else {
                        this.toastObj.show(getToast(args).toast[16]);
                    }
                }
                // Dispatch event to refresh search grid
                window.dispatchEvent(new CustomEvent('RefreshEventSearchGrid'));
            })
            .catch(error => {
                this.toastObj.show(getToast().toast[2]);
                console.error('error ->', error);
                if (window != window.top) {
                    this.clickCancel('');
                }
            });
    }

    async updateAppoinmentLexon(calendarId, item, event) {
        const { provider, account } = this.props.lexon;
        const { idUser } = this.props.currentUser;
        const calendar = this.props.calendarsResult.calendars.find(c => c.id === calendarId);
        const st = moment(event.start).format('YYYY-MM-DD HH:mm');
        const et = moment(event.end).format('YYYY-MM-DD HH:mm');
        const lexonEvent = {
            ...event,
            Guid: item,
            calendar,
            StartTime: st,
            EndTime: et,
            Account: account,
            Reminders: 
                event.reminders
                    ? event.reminders.map(e => ({method: 'email', minutes: e.trigger})) 
                    : (event.Reminders) 
                        ? event.Reminders.map(e => ({method: 'email', minutes: e.trigger})) 
                        : null
            
        }
        const companySelected = event.x[1].value;
        const idEventAction = event.x[2].value;
        const idCompanySelected = event.x[3].value;
        await updateAppoinment(
            companySelected,
            idCompanySelected,
            idEventAction,
            { idUser, provider },
            lexonEvent, 
            this.props.lexon.lexonToken,
            this.props.currentUser.idResponsable ?? null
        );
    }

    loadCalendarEventsFromCookie(){
        var storedSelection = Cookies.get('Lefebvre.ImapCalendarsSelection');
        let loadingCalendars = this.state.loadingCalendars;

        let calIds = '';
        if (storedSelection){
            calIds = storedSelection.split('|');
            calIds.pop();
        }

        if (calIds !== ''){
            calIds.forEach(cal => {
                if (!this.state.loadingCalendars.find(c => c === cal)){
                    loadingCalendars.push(cal);
                    this.setState({
                        loadingCalendars: loadingCalendars
                    });
                    this.loadCalendarEvents(cal, true);
                }
            })
        }
    }

    loadCalendarEvents(calendar, checked, dateNavigate) {
        this.setState({
            tableEvents: [],
        });
        let predicate;

        let loadingCalendars = this.state.loadingCalendars;
        dateNavigate= dateNavigate ?? this.state.tabChanged

        if(this.props.lexon.idCalendar && window != window.top) {
            calendar = this.props.lexon.idCalendar
        }

        let reduxChecked = this.props.calendarsResult.calendars.some(cal => cal.id === calendar && cal.checked === true);
        // If calendar selection or date selection changes while there are recursive calls pending there are events being loaded in the schedule that should not be loaded.
        // reduxChecked has the calendar checked property value when entering this function
        if (reduxChecked !== checked){
            // Calendar selection has changed. We must update redux to match new selection.
            this.props.checkCalendar(calendar, checked);
        } else if (reduxChecked !== checked && eventList.length > 0){
            // Calendar selection has changed before all API calls were finished
            if (reduxChecked === false && checked){
                // If the calendar has been unchecked and a previous checked recursive call of that calendar is received, we change checked value to false to stop recursion.
                checked = false;
            }
        }

        const obj = this;

        if (checked){
            if (!loadingCalendars.find(id => id === calendar)){
                loadingCalendars.push(calendar);
                this.setState({
                    loadingCalendars: loadingCalendars
                });
            }

            if (this.isFirstLoad){
                this.isFirstLoad = false;
                this.loadCalendarEventsFromCookie();
            }

            getEventList(calendar, this.props.lexon.userId, this.props.all.login.formValues.user, this.props.lexon.lexonToken, this.scheduleObj.selectedDate)
            .then(result => {
                this.props.selectCalendar(calendar, checked);
                this.defaultCalendar = calendar;

                if (this.state.filterEventType?.length > 0){
                    result.result.items =  [
                        ...result.result.items.filter(item => this.state.filterEventType.includes (item?.categories || 'Sin tipo de evento' ) ),
                        ...this.state.filterEventType.includes("Otros tipos de eventos") ? 
                          result.result.items.filter(item => this.eventTypeDataSource.findIndex( evt=>  evt.text === item?.categories ) ===-1 && item?.categories) : []
                      ]
                }
                // if calendar from left sidebar list is checked load the main event list
                    this.dataManager = result.result;
                    this.onDataBinding(this.dataManager, calendar);

                //Set checkedCalendarResourceData calendar items as cheked
                this.props.calendarsResult.calendars.find(x => x.id == calendar).checked = checked;

                if (checked) {
                    // Track last selected calendar synchronously (for use in handleScheduleOpenNewEventEditor)
                    this.lastSelectedCalendarId = calendar;

                    if (!dateNavigate) {
                        const currentCalendars = this.state.calendarResult?.length > 0
                            ? this.state.calendarResult
                            : this.props.calendarsResult.calendars;
                        const nextCalendarResult = currentCalendars.map((calendarItem) => (
                            calendarItem.id === calendar
                                ? { ...calendarItem, checked }
                                : { ...calendarItem }
                        ));

                        this.setState({ calendarResult: nextCalendarResult });
                    }
                }
                else {
                    this.scheduleData = this.scheduleData.filter(obj => obj.CalendarId !== calendar);
                }
                // Filter selected calendar to pass to the query
                const calendars = groupBy(this.props.calendarsResult.calendars, "checked");

                // Set the calendar field as default when only one calendar is checked
                this.setDefaultCalendarField(calendars.true, calendar);

                // Load selected calendar to pass to the query
                this.predicateQueryEvents(calendars.true, predicate);

                this.setState({
                    loading: false,
                    loadingCalendars: loadingCalendars,
                    tabChanged:false
                });                
                this.loading = false;
                setTimeout(() => {
                    if (this.scheduleObj) {
                        this.scheduleObj.eventSettings.dataSource = [...this.scheduleData];
                        this.scheduleObj.refreshEvents();
                    }
                }, 500);
            })
            .catch(error => {
                this.loading = false;
                if (window != window.top) {
                    this.clickCancel('Not Account');
                }
                console.error('error ->', error);
            });
        } else {
            // Calendar has been unchecked
            this.scheduleData = this.scheduleData.filter(function (obj) {
                return obj.CalendarId !== calendar;
            });

            // Filter selected calendar to pass to the query
            let calendars = groupBy(this.props.calendarsResult.calendars, "checked");

            // Load selected calendar to pass to the query
            this.predicateQueryEvents(calendars.true, predicate);

            loadingCalendars = loadingCalendars.filter(id => id === calendar);

            this.setState({
                loading: false,
                loadingCalendars: loadingCalendars
            });

            setTimeout(() => {
                if (this.scheduleObj) {
                    this.scheduleObj.eventSettings.dataSource = [...this.scheduleData];
                    this.scheduleObj.refreshEvents();
                }
            }, 100);
        }
    }

    setDefaultCalendarField(calendarList, calendar) {
        if (calendarList != undefined) {
            if (calendarList.length > 0) {
                calendarList.every(key => {
                    if (key.checked && key.primary) {
                        calendar = key.id;
                        return false;
                    } else if (key.checked && key.primary === undefined) {
                        calendar = key.id;
                        return true;
                    }
                });
            }
        } else {
            this.props.calendarsResult.calendars.forEach(key => {
                if (key.checked && key.primary) {
                    calendar = key.id;
                }
            });
        }
    }

    predicateQueryEvents(calendarList, predicate) {
        if (calendarList != undefined) {
            calendarList.forEach((valor) => {
                if (predicate) {
                    predicate = predicate.or('CalendarId', 'equal', valor.id);
                } else {
                    predicate = new Predicate('CalendarId', 'equal', valor.id);
                }
            });
        }

        if (this.scheduleObj) {
            this.scheduleObj.eventSettings.query = new Query().where(predicate);
        }
    }

    handleScheduleDate = (args) => {
        this.scheduleObj.selectedDate = args.value;
        let calendars = groupBy(this.props.calendarsResult.calendars, "checked");
        if (calendars.length > 0){
            calendars.true.forEach((cal) => {
                this.loadCalendarEvents(cal.id, true);
            });
        }
        
        this.scheduleObj.dataBind();
    }

    handleScheduleOpenNewEventEditor = () => {
        const endTimeDate = new Date();
        endTimeDate.setMinutes(endTimeDate.getMinutes() + 60);
        const cellData = {
            subject: this.props.lexon.title ? this.props.lexon.title : null,
            startTime: new Date(Date.now()),
            endTime: endTimeDate
        };
        if (this.layoutIframe) {
            this.setState({calendarResult: this.props.calendarsResult.calendars });
        }
        
        // Determine which calendar ID to select in the dropdown
        const calendars = this.props.calendarsResult?.calendars || [];
        
        if (this.lastSelectedCalendarId) {
            this.pendingCalendarIdForDropdown = this.lastSelectedCalendarId;
        } else if (this.state.calendarResult && this.state.calendarResult.length > 0) {
            this.pendingCalendarIdForDropdown = this.state.calendarResult[0]?.id || null;
        } else {
            // Fallback: use first checked calendar, or first calendar
            const checkedCalendars = calendars.filter(c => c.checked === true);
            this.pendingCalendarIdForDropdown = checkedCalendars.length > 0 
                ? checkedCalendars[0].id 
                : calendars[0]?.id || null;
        }
        
        this.isOpeningEditor = true;
        setTimeout(() => {
            this.scheduleObj.openEditor(cellData, 'Add');
        }, 800);
    }

    async handleScheduleOpenEditEventEditor() {
        const eventData = this.scheduleData.find(x => x.Id && x.Id.includes(this.props.lexon.idEvent));
        const event = await getEventById(this.props.lexon.userId, this.props.all.login.formValues.user, this.props.lexon.lexonToken, this.props.lexon.idCalendar, this.props.lexon.idEvent);
        if (this.layoutIframe) {
            this.setState({calendarResult: this.props.calendarsResult.calendars })
        }
        if (eventData && eventData.LexonClassification) {
            setTimeout(() => {
                eventData.RecurrenceRule ? this.scheduleObj.openEditor(eventData, "EditSeries") :
                    this.scheduleObj.openEditor(eventData, "Save");
            }, 800);

        } else if(event && event.result?.items.length > 0 && event.result?.items[0].lexonActuation) {
            const eventDataById = getEventDataById(event.result.items[0], this.props.lexon.idCalendar);
            eventDataById.RecurrenceRule = null;
            const alreadyInSchedule = this.scheduleData.some(x => x.Id && x.Id.includes(this.props.lexon.idEvent));
            if (!alreadyInSchedule) {
                this.scheduleData = [...this.scheduleData, eventDataById];
            }
            setTimeout(() => {
                eventDataById.RecurrenceRule ? this.scheduleObj.openEditor(eventDataById, 'EditSeries') :
                    this.scheduleObj.openEditor(eventDataById, 'Save');
            }, 800);

        } else {
            this.clickCancel('Not Found');
        }
        this.setState({
            loading: false
        });
    }

    syncCalendarResourceDropdown(calendars = []) {
        if (!this.scheduleObj) {
            return;
        }

        const safeCalendars = Array.isArray(calendars) ? calendars : [];
        const currentResources = Array.isArray(this.scheduleObj.resources) ? this.scheduleObj.resources : [];

        if (currentResources.length > 0) {
            const updatedResources = [...currentResources];
            updatedResources[0] = {
                ...updatedResources[0],
                dataSource: safeCalendars
            };
            this.scheduleObj.setProperties({ resources: updatedResources }, true);
            this.scheduleObj.dataBind();
        }

        const calendarDropdownElement = document.getElementById('CalendarId');
        const calendarDropdown = calendarDropdownElement?.ej2_instances?.[0];

        if (calendarDropdown) {
            calendarDropdown.dataSource = safeCalendars;
            calendarDropdown.dataBind();
        }
    }

    mergeCalendarsPreservingOrder(fetchedCalendars = [], previousCalendars = []) {
        if (!previousCalendars || previousCalendars.length === 0) {
            return fetchedCalendars;
        }

        const fetchedById = new Map(fetchedCalendars.map((calendar) => [calendar.id, calendar]));

        const mergedCalendars = previousCalendars
            .filter((calendar) => fetchedById.has(calendar.id))
            .map((calendar) => {
                const fetchedCalendar = fetchedById.get(calendar.id);
                return {
                    ...calendar,
                    ...fetchedCalendar,
                    checked: calendar.checked ?? fetchedCalendar.checked,
                };
            });

        fetchedCalendars.forEach((calendar) => {
            if (!previousCalendars.some((previousCalendar) => previousCalendar.id === calendar.id)) {
                mergedCalendars.push(calendar);
            }
        });

        return mergedCalendars;
    }

    sidebarCalendarList(args = undefined) {
      const { user } = this.props.all.login.formValues;
      const { userId, lexonToken } = this.props.lexon;
      this.props.getCalendars(userId, user, lexonToken, args && args === 'Update' ? [] : this.props.calendarsResult.calendars);

      calendarList(userId, user, lexonToken)
          .then(result => {
              const refreshedCalendars = orderBy(result.items || [], 'primary');
              const currentCalendars = this.state.calendarResult?.length > 0
                  ? this.state.calendarResult
                  : this.props.calendarsResult.calendars;
              const nextCalendars = this.mergeCalendarsPreservingOrder(refreshedCalendars, currentCalendars);
              this.setState({ calendarResult: nextCalendars }, () => {
                  this.syncCalendarResourceDropdown(nextCalendars);
              });
          })
          .catch(error => {
              console.error('error ->', error);
          });
    }

    renderSpinner() {
        return <Spinner visible={true}/>;
    }

    onSignout() {
        const { userId, token, lexonToken } = this.props.lexon;
        resetDefaultAccount(userId, lexonToken)
            .then(() => {
                // signOut();
            })
            .then(() => {
                const urlRedirect = (token) ? `${window.URL_SELECT_ACCOUNT}/access/${token}/` : `${window.URL_SELECT_ACCOUNT}/user/${userId}/encrypt/0`;
                window.open(urlRedirect, '_self');
            });
    }

    onSignoutDisconnect() {
        const { userId, token, lexonToken } = this.props.lexon;
        resetDefaultAccount(userId, lexonToken)
            .then(() => {
                // signOutDisconnect();
            })
            .then(() => {
                const urlRedirect = (token) ? `${window.URL_SELECT_ACCOUNT}/access/${token}/` : `${window.URL_SELECT_ACCOUNT}/user/${userId}/encrypt/0`;
                window.open(urlRedirect, '_self');
            });
    }

    setEmailTags(tag) {
        this.setState({ to2: [...tag] });
    }

    onActionBegin(args) {
        if (args.requestType === 'toolbarItemRendering') {
            const CalendarsIconItem = {
                id: 'showCalendarToolbar', 
                align: 'Left', 
                prefixIcon: 'calendar-icon', 
                text: 'Calendar', 
                cssClass: 'e-schedule-calendar-icon'
            };
            args.items.push(CalendarsIconItem);
           
            if (!this.layoutIframe) {
                let menuIconItem = {
                    id: "configToolbar",
                    align: "Right",
                    prefixIcon: "icon-kebab-menu",
                    text: "Configuration",
                    cssClass: "e-schedule-user-icon",
                };

                args.items.push(menuIconItem);
            } else {
                const LogOutIconItem = {
                    id: "iframe-options-toolbar", 
                    align: 'Right', 
                    prefixIcon: "icon-kebab-menu", 
                    text: '', 
                    toolTip: "",
                    cssClass: 'e-schedule-logout-icon'
                };
                args.items.push(LogOutIconItem);
            }

            // ✅ Esperar a que los elementos del toolbar estén en el DOM antes de renderizar tooltips
            waitForElement('showCalendarToolbar', () => {
                console.log('✅ Toolbar elements ready, enabling tooltips');
                this.setState({ loadedToolbar: true });
            }, {
                maxAttempts: 25,
                initialDelay: 50,
                maxDelay: 500,
                timeout: 3000,
                useObserver: true
            });
        }
    }


    onEventTypeClick() {
        this.profilePopup.hide();
        this.openEventTypeView();
    }

    onConfigurationHoursClick = () => {
        this.profilePopup.hide();
        this.setState(
        {
            hideConfigurationHoursDialog: true
        });
    }

    dialogConfigurationHoursClose = (value) => {
        if (value) {
            this.toastObj.show(getToast().toast[6]);
        }
        this.setState({
            hideConfigurationHoursDialog: false
        });
    }

    onImportEventsTypeClick() {
        this.profilePopup.hide();
        this.openImportEventsView();
    }

    onFilterEventTypeClick() {
        this.profilePopup.hide();
        this.openFilterEventTypeView();
    }

    onImportContactsTypeClick() {
        this.profilePopup.hide();
        this.openImportContactsView();
    }

    onImportEventsV2Click() {
        this.profilePopup.hide();
        this.setState({ showPromptImportEventsV2Dialog: true });
    }

    dialogImportEventsV2Close() {
        this.setState({ showPromptImportEventsV2Dialog: false });
        this.sidebarCalendarList();
    }

      
    convertDayNameToNumber(day) {
      return moment(day, 'dddd').isoWeekday();
    };

    printCalendarformat = () => {
        const groupWeek = this.tableEvents.current.sort((a, b) => a.StartTime - b.StartTime).reduce((acc, tableEvent) => {
            // create a composed key: 'week' 
            const monthWeek = `${moment(tableEvent.StartTime).startOf('isoWeek')}`;
            // add this key as a property to the result object
            if (!acc[monthWeek]) {
              acc[monthWeek] = [];
            }
            // push the current date that belongs to the year-week calculated befor
            acc[monthWeek].push(tableEvent);
            return acc;
        }, {});
      
          const groupWeeks = Object.keys(groupWeek);
          const newCalendarGroup = []
          for(let i=0; i< groupWeeks.length; i++) {
            let newGroupWeeks = groupWeeks[i];
            const groupDay = groupWeek[newGroupWeeks].reduce((acc, tableEvent) => {
              // create a composed key: 'day' 
              const monthDay = `${moment(tableEvent.StartTime).format('dddd')}`;
              
              if (!acc[monthDay]) {
                acc[monthDay] = [];
              }
          
              acc[monthDay].push(tableEvent);
              return acc;
            }, {})
            newCalendarGroup.push(groupDay)
          }
          const newTableEvents = newCalendarGroup.map((x) => {
    
            const newObj = Object.keys(x).reduce((acc, day) => {
              const dayNumber = this.convertDayNameToNumber(day);
              acc[dayNumber] = x[day];
              return acc;
            }, {});
            
            // Ensure all days of the week (1 to 7) are present
            for (let i = 1; i <= 7; i++) {
              if (!newObj[i]) {
                newObj[i] = [];
              }
            }
    
    
            if (this.viewCalendar.current === 'Day') {
                const date = moment(this.tableMonth.current, "DD/MM/YYYY");
                const day = date.format('dddd');
                const dayNumber = this.convertDayNameToNumber(day);
                return [newObj[dayNumber]];
            }
    
            const eventsArray = []
            
            if (this.viewCalendar.current === 'WorkWeek') {
    
              for(let i=1; i<= 5; i++){
                eventsArray.push(newObj[i]);
              }
    
              return eventsArray;
            }
    
            for(let i=1; i<= 7; i++){
              eventsArray.push(newObj[i]);
            }
    
            return eventsArray;
    
        });
          this.setState({
            tableEvents: newTableEvents,
        });
    }

    renderTableEvent(tableEvent) {
        const latestScheduleEvent = this.scheduleObj?.dataModule?.dataManager?.dataSource?.json?.find(
            event => event.Id === tableEvent.Id
        ) || tableEvent;

        const calendarBorderColor = this.props.calendarsResult.calendars.find(
            calendar => calendar.id === latestScheduleEvent.CalendarId
        )?.backgroundColor;
        
        const latestEventType = latestScheduleEvent.EventType;
        const eventTypeName =
            typeof latestEventType === 'string'
                ? latestEventType
                : latestEventType?.name || latestEventType?.text;

        const currentEventTypeColor = eventTypeName
            ? this.eventTypeDataSource.find(t => t.text === eventTypeName)?.backgroundColor
            : latestEventType?.color || latestEventType?.backgroundColor;

        const borderColor = (
            this.state.eventTypeColorMode === EVENT_TYPE_COLOR_MODES.BACKGROUND &&
            currentEventTypeColor
        ) ? currentEventTypeColor : calendarBorderColor;
        
        const countDay = Math.abs(
          moment(tableEvent.StartTime, 'YYYY-MM-DD')
            .startOf('day')
            .diff(moment(tableEvent.EndTime, 'YYYY-MM-DD').hour(tableEvent.IsAllDay ? -1 : 0).startOf('day'), 'days')
        ) + 1;

        return (
          <div
            style={
              {
                border: `2px solid ${borderColor}`,
                marginBottom: '8px',
                padding: '5px',
                breakInside: 'avoid'
              }}
          >
            <div style={{
              display: 'flex',
              flexDirection: 'column'
            }}>
              <span style={{
                wordBreak: 'break-word',
                width: '100%'
              }}>{tableEvent.Subject}</span>
              <span style={{
                marginTop: '5px'
              }}>{
                  countDay >= 2 ? ` ${moment(tableEvent.StartTime).format('D/MM')} 
                    - ${moment(tableEvent.EndTime).format('D/MM')}` :
                    `${moment(tableEvent.StartTime).format('D/MM/YYYY')}`
                }
                <span style={{
                }}>{
                    tableEvent.IsAllDay ?
                      ` ${i18n.t('calendar.allDay')}` :
                      ` ${moment(tableEvent.StartTime).format("HH:mm")} - 
                    ${moment(tableEvent.EndTime).format("HH:mm")}`}
                </span>
              </span>
              {countDay >= 2 && <span style={{
                marginTop: '5px'
              }}>{`${i18n.t('calendar.duration')}: ${countDay} ${i18n.t('calendar.days')}`}</span>}
            </div>
          </div>
        );
    }
    
    onPrintAgenda = () => {

        let day = '';
        if (this.viewCalendar.current === 'Day') {
          const date = moment(this.tableMonth.current, "DD/MM/YYYY");
          day = date.format('dddd');
        }
    
        const divElement = <div>
          <h2>{this.props.tableMonth}</h2>
          <table className="table" style={{
          }}>
            <thead>
              <tr>
                {(this.viewCalendar.current === 'Day') &&
                  <>
                    <th scope="col">{i18n.t(`calendar.${day.toLocaleLowerCase()}`).toUpperCase()}</th>
                  </>
                }
                {(this.viewCalendar.current !== 'WorkWeek' &&
                this.viewCalendar.current !== 'Day') &&
                  <>
                    <th scope="col">{i18n.t('calendar.monday').toUpperCase()}</th>
                    <th scope="col">{i18n.t('calendar.tuesday').toUpperCase()}</th>
                    <th scope="col">{i18n.t('calendar.wednesday').toUpperCase()}</th>
                    <th scope="col">{i18n.t('calendar.thursday').toUpperCase()}</th>
                    <th scope="col">{i18n.t('calendar.friday').toUpperCase()}</th>
                    <th scope="col">{i18n.t('calendar.saturday').toUpperCase()}</th>
                    <th scope="col">{i18n.t('calendar.sunday').toUpperCase()}</th>
                  </>
                }
                {(this.viewCalendar.current === 'WorkWeek') &&
                  <>
                    <th scope="col">{i18n.t('calendar.monday').toUpperCase()}</th>
                    <th scope="col">{i18n.t('calendar.tuesday').toUpperCase()}</th>
                    <th scope="col">{i18n.t('calendar.wednesday').toUpperCase()}</th>
                    <th scope="col">{i18n.t('calendar.thursday').toUpperCase()}</th>
                    <th scope="col">{i18n.t('calendar.friday').toUpperCase()}</th>
                  </>
                }
              </tr>
            </thead>
            <tbody>
              {this.state.tableEvents.length > 0 &&
                  this.state.tableEvents.map((days, index) => (
                    <tr key={index}>
                      {days?.length > 0 && days.map((events, dIndex) => (
                        <td
                          key={dIndex}
                          style={{
                            width: '12%',
                            pageBreakBefore: 'auto',
                            verticalAlign: 'top',
                            border: '1px solid black'
                          }}>
                          {events?.length > 0 && events.sort((a, b) => a.StartTime - b.StartTime).map(event => (
                            <React.Fragment key={event.Id}>
                              {this.renderTableEvent(event)}
                            </React.Fragment>
                          ))}
                        </td>
                      ))}
                    </tr>
                  ))}
            </tbody>
          </table>
        </div>
    
        // Clear the existing element content
        const existingElement = document.getElementById('calendar-events-print-v2');
        if (existingElement) {
          ReactDOM.unmountComponentAtNode(existingElement);
          ReactDOM.render(divElement, existingElement);
        } else {
          console.error('Existing element not found');
        }
    
        const content = document.getElementById("calendar-events-print-v2");
    
        const printWindow = window.open('', '_blank');
        printWindow.document.open();
        printWindow.document.write(content.innerHTML);
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
        let selectedCalendars = this.props.calendarsResult.calendars.filter(
          (c) => c.checked === true
        );
        selectedCalendars.forEach((cal) => {
          this.loadCalendarEvents(cal.id, true);
        });
    
        ReactDOM.unmountComponentAtNode(existingElement);
      }

    /**
     * Adds an address to the list matching the id.
     *
     * @param id
     * @param address
     */
    addAddress(id, address) {
        const normalizedAddress = (address || '').trim();
        if (normalizedAddress.length > 0 && id === 'to') {
            this.setState(prevState => {
                if (prevState.to2.includes(normalizedAddress)) {
                    return null;
                }
                const to2 = [...prevState.to2, normalizedAddress];
                const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                const invalidEmailExists = to2.some(email => !emailRegex.test(email.trim()));
                if (invalidEmailExists) {
                  let editButtonSave = document.querySelector('.e-event-save');
                  if(editButtonSave) {
                      editButtonSave.disabled = true;
                  }
                }
                return {
                    to2,
                    to: to2.join(',')
                };
            }, () => {
                this.renderAttendeePortal();
            });
        }
    }
    /**
     * Removes the address from the under the field matching the id.
     *
     * @param id
     * @param address
     */
    removeAddress(id, address) {
        if (id === 'to') {
            this.setState(prevState => {
                const to2 = [...prevState.to2];
                const index = to2.indexOf(address);
                if (index < 0) {
                    return null;
                }
                to2.splice(index, 1);
                const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                const invalidEmailExists = to2.some(email => !emailRegex.test(email.trim()));
                if (!invalidEmailExists) {
                  this.setState({isInvalidEmail: false});
                  let editButtonSave = document.querySelector('.e-event-save');
                  if(editButtonSave) {
                    editButtonSave.disabled = false;
                  }
                }
                return {
                    to2,
                    to: to2.join(',')
                };
            }, () => {
                this.renderAttendeePortal();
            });
        }
    }
}

Calendar.propTypes = {};

const mapStateToProps = state => ({
        calendarsResult: state.calendarsResult,
        lexon: state.lexon,
        email: state.login.formValues.user,
        all: state,
        currentUser: state.currentUser,
        nextcloudUser: state.application.nextcloudUser
});

const mapDispatchToProps = (dispatch, ownProps) => ({
        ...bindActionCreators(
            {
                getCalendars,
                clearErrorCalendars,
                selectCalendar,
                setDataBase,
                setGUID: setGUID,
                setConfigHoursCalendar,
                setSign: setSign,
                setIsFirstLoad: setIsFirstLoad,
                resetIdActuation,
                resetIdEvent,
                checkCalendar,
                setIsFilterDate: isFilterDate => dispatch(setIsFilterDate(isFilterDate)),
                setIsSearchTopBar: isSearchTopBar => dispatch(setIsSearchTopBar(isSearchTopBar)),
                setEventFilterKeyword: eventFilterKeyword => dispatch(setEventFilterKeyword(eventFilterKeyword)),
            },
            dispatch
        ),
    setError: (err, msg) => dispatch(setError(err, msg)),
    logout: () => {
            dispatch(clearUserCredentials());
            ownProps.navigate('/login');
        },
    setNextcloudUser: value => { dispatch(setNextcloudUser(value))},
    setService: service => {dispatch(setService(service))},
    setFormValues: credentials => {dispatch(setFormValues(credentials))}
});

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps, {
    reloadMessageCache: folder =>
      dispatchProps.reloadMessageCache(stateProps.application.user, folder),
    selectFolder: folder =>
      dispatchProps.selectFolder(folder, stateProps.application.user),
    messageClicked: message =>
      dispatchProps.messageClicked(
        stateProps.application.user.credentials,
        stateProps.application.downloadedMessages,
        stateProps.receivedFolder,
        message
      ),
    setEmailShown: flag => dispatchProps.setEmailShown(flag),
    outboxEventNotified: () => dispatchProps.outboxEventNotified(),
    close: () => dispatchProps.close(stateProps.application),
    setError: (err, msg) => dispatchProps.setError(err, msg),
    resetIdActuation: () => dispatchProps.resetIdActuation(),
    resetIdEvent: () => dispatchProps.resetIdEvent(),
    setCaseFile: casefile => dispatchProps.setCaseFile(casefile),
  });

const ConnectedTranslatedCalendar = withClassNavigate(connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(withRouter(Calendar)));

export default ConnectedTranslatedCalendar;
